import {
  Autocomplete,
  Avatar,
  Backdrop,
  Badge,
  Box,
  Button,
  Card,
  CardHeader,
  Checkbox,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Stack,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  makeStyles,
  Skeleton,
} from '@material-ui/core'
import Page from '../../components/Page'
import { capitalCase, sentenceCase } from 'change-case'
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill'
import trash2Outline from '@iconify/icons-eva/trash-2-outline'
import lockOpenFill from '@iconify/icons-ph/lock-open-fill'
import editFill from '@iconify/icons-eva/edit-fill'
import plusFill from '@iconify/icons-eva/plus-fill'
//materail
import * as Yup from 'yup'
import { Form, FormikProvider, useFormik } from 'formik'
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs'
import Label from 'src/components/Label'
import { useLocation, useNavigate, useParams } from 'react-router'
import { forwardRef, useCallback, useEffect, useMemo, useRef, useState, Fragment } from 'react'
import PublicMsgBoard from 'src/components/_dashboard/official-request/PublicMsgBoard'
import RequestTabUpdates from 'src/components/_dashboard/user/account/RequestTabUpdates'
import PublicMessageBoard from 'src/components/_dashboard/user/profile/PublicMessageBoard.js'
import RequestUpdates from 'src/components/_dashboard/official-request/RequestUpdates'
import PaymentRequest from 'src/components/_dashboard/official-request/PaymentRequest'
import JobNoteWindow from 'src/components/_dashboard/chat/JobNoteWindow'
import { SalesOrderNewBadgeList } from 'src/components/_dashboard/official-request/SalesOrderNewBadge'
import useJobNoteTabUnread from 'src/hooks/useJobNoteTabUnread'
import {
  AddCircle,
  BlockOutlined,
  Delete,
  KeyboardBackspaceOutlined,
  Print,
  UploadFile,
  LocationOn,
  Add,
  Remove,
  CenterFocusStrong,
  NoteAdd,
  AddCircleOutlined,
  PictureAsPdf,
  Description,
  DragIndicator,
  SwapHorizontalCircleOutlined,
} from '@material-ui/icons'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import Modal from 'src/components/_dashboard/blog/ProjectModel'
import Icon from '@iconify/react'
import Scrollbar from 'src/components/Scrollbar'
import axios from 'axios'
import {
  currentFacilityId,
  REST_API,
  REST_API_END_POINT,
  REST_API_IO,
  SEND_EMAIL,
  UNITS,
} from 'src/constants/Defaultvalues'
// import { io } from 'socket.io-client' // OLD
import createAppSocket from 'src/Helpers/createSocket'
import moment from 'moment'
import { formatDateOnly, localTodayDateOnlyUnix, toDateOnlyUnix } from 'src/utils/dateOnly'
import { PATH_DASHBOARD } from 'src/routes/paths'
import { useSnackbar } from 'notistack'
import { LoadingButton, MobileDatePicker } from '@material-ui/lab'
import { UploadAvatar, UploadMultiFile } from 'src/components/upload'
import AttachmentDownloadIconButton from 'src/components/_dashboard/official-request/AttachmentDownloadIconButton'
import AttachmentDownloadAllButton from 'src/components/_dashboard/official-request/AttachmentDownloadAllButton'
import RequestProgressModal from 'src/components/RequestProgressModal';
import { isAdminUser } from '../../utils/adminUserTypes';
import AddClients from 'src/components/_dashboard/official-request/AddClients'
import AddProposal from 'src/components/_dashboard/official-request/AddProposal'
import ConfirmationPopup from 'src/components/_dashboard/official-request/ConfirmationPopup'
import ReactToPrint from 'react-to-print'
import { storage } from '../../firebase/firebase'
import {
  getDownloadURL,
  ref as imageref,
  uploadBytesResumable,
} from 'firebase/storage'
import { Link } from 'react-router-dom'
import { empty } from 'src/Helpers/Common'
import { resolveAttachmentProxyPath } from 'src/Helpers/FileDownloadUtils'
import Locations from 'src/components/_dashboard/official-request/Locations'
import Workflow from 'src/components/_dashboard/general-analytics/RfqForm'
import { AccountNotifications } from '../../components/_dashboard/user/account'
import { set } from 'lodash'
import Proposals from 'src/components/_dashboard/official-request/Proposals'
import useCompanyProfile from 'src/hooks/useCompanyProfile'
import LoadingScreen from 'src/components/LoadingScreen'
import PrintableContent from './printPreview'
import { red } from '@material-ui/core/colors'
import AnimatedButton from 'src/components/animate/AnimatedButton'
import ViewDesignOrderDetails from 'src/components/_dashboard/official-request/ViewDesignOrderDetails'
import { DialogAnimate } from 'src/components/animate'
import filePdfIcon from '@iconify/icons-mdi/file-pdf';
import arrowLeftOutlined from '@iconify/icons-ant-design/arrow-left-outlined';
import arrowRightOutlined from '@iconify/icons-ant-design/arrow-right-outlined';
import emailFillIcon from '@iconify/icons-eva/email-fill';
import { supabase } from '../../supabase/supabaseClient';
import SendDesignsEmailModal from 'src/components/_dashboard/official-request/SendDesignsEmailModal';
import ViewDesignFormSubmissions from 'src/components/design-form/ViewDesignFormSubmissions';
import DesignFormTabs from 'src/components/design-form/DesignFormTabs';
import { fUSPrice } from 'src/utils/formatNumber'
import {
  clearCatalogInstallCost,
  applyInstallPriceEdit,
  applyRetailPriceEdit,
  ensureCatalogBaselines,
  formatPriceToTwoDecimals,
  formatRetailPriceDisplay,
  getCatalogPickerOriginalPrices,
  getCatalogProductWithAdjustment,
  getDisplayedInstallPrice,
  getSignedInstallMarketingAdjustment,
  hydrateSavedOrderLinePrices,
  limitDecimalInput,
  normalizeProductForSave,
  normalizeRetailArrowChange,
  parseMarketingAdjValueTypeFromDb,
  reconcileCatalogMarketingPrices,
  applyMarketingAdjustmentChange,
  applyInstallMarketingAdjustmentChange,
  applyProductAdjValueTypeChange,
  applyInstallAdjValueTypeChange,
  stepRetailPriceByArrow,
} from 'src/utils/retailPriceEdit'
import { useReactToPrint } from 'react-to-print'
import DesignOrderInvoicePage from './DesignOrderInvoicePage'
import DesignOrderInvoiceModalSection from 'src/components/_dashboard/official-request/DesignOrderInvoiceModalSection'
import {
  buildGroupedDesignOrderDisplayRows,
  computeDesignOrderInvoiceTotals,
  mapDesignOrderProductsToCustProduct,
  mapDesignOrderServicesForInvoice,
  serializeDesignOrderGroupedRowsForInvoice,
  getDesignOrderProjectCommunity,
} from 'src/utils/designOrderInvoiceUtils'
import useDesignOrderProductGrouping from './designOrder/useDesignOrderProductGrouping'
import {
  DesignOrderGroupDialogs,
  DesignOrderGroupActionBar,
  DesignOrderGroupSummaryRow,
  getDesignOrderGroupValueColumns,
  DESIGN_ORDER_NEGATIVE_MARKETING_PERMISSIONS,
  DESIGN_ORDER_PRODUCT_TABLE_PRODUCT_COL_SX,
  DESIGN_ORDER_PRODUCT_TABLE_DESCRIPTION_COL_SX,
} from './designOrder/DesignOrderProductGroupingUI'
import {
  buildDesignOrderProductRowsFromApi,
  computeDesignOrderProductsSubTotal,
  DESIGN_ORDER_ROW_ACTIONS_BOX_SX,
  DESIGN_ORDER_ROW_ACTIONS_CELL_SX,
  DESIGN_ORDER_ROW_ACTIONS_LEADING_SLOT_SX,
  enrichDesignOrderAttachmentForDisplay,
  getDesignOrderLosingMoneyRowSx,
  hasDesignOrderWriteProductsBlockingConvert,
  isOnlyEmptyDesignOrderProductRow,
  mapDesignOrderProductAttachmentForDisplay,
} from './designOrder/designOrderProductRowHelpers'
import {
  getGroupAnchorIndexId,
  isIndexIdInList,
  snapshotGroupMemberMarketing,
  resolveGroupMemberMarketingForSave,
  collapseProductsForAutocompleteChips,
  getCatalogAutocompleteDisplayName,
  getCatalogAutocompleteTooltip,
  getAutocompleteSelectionKey,
  stripGroupFieldsFromCatalogOption,
} from './quotation/quotationGroupingHelpers'

import quickbookLogo from 'src/assets/quickbookLogo-removebg-preview.png';

/** Group marketing: DB stores 1 = positive, 0 = negative. */
const parseGroupMarketingAdjValueTypeFromDb = (raw) => {
  if (raw === 0 || raw === false || raw === '0') return false
  if (raw === 1 || raw === true || raw === '1') return true
  if (raw != null && raw !== '') return Number(raw) !== 0
  return true
}

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}))
const MAX_CHARACTERS = 500
const splitOrderCatalogTypes = [
  { id: 'all', label: 'All', inhouse: null, isTrafficCatalog: null },
  { id: 'in_stock', label: 'In Stock', inhouse: 4, isTrafficCatalog: false },
  { id: 'client_owned', label: 'Client Owned', inhouse: 5, isTrafficCatalog: false },
  { id: 'traffic', label: 'Traffic', inhouse: 1, isTrafficCatalog: true },
  { id: 'production_catalog', label: 'Production Catalog', inhouse: 1, isTrafficCatalog: false },
  { id: 'split_catalog', label: 'Split Catalog', inhouse: 6, isTrafficCatalog: false },
  { id: 'estimate_catalog', label: 'Estimate Catalog', inhouse: 7, isTrafficCatalog: false },
  { id: 'sub_contract', label: 'Sub Contract', inhouse: 0, isTrafficCatalog: false }
]
const formatProjectAddress = (project) => {
  if (!project) return 'No address available'
  const addressParts = [project.address, project.city, project.state, project.zip]
    .map((part) => (part || '').toString().trim())
    .filter(Boolean)
  return addressParts.length > 0 ? addressParts.join(', ') : 'No address available'
}

const getCommunityLocationFromProject = (community) => {
  if (!community) {
    return { address: '', city: '', state: '', zip: '' }
  }
  return {
    address: (community.address || '').toString().trim(),
    city: (community.city || '').toString().trim(),
    state: (community.state || '').toString().trim(),
    zip: (community.zip || community.zipcode || '').toString().trim(),
  }
}

const hasCompleteProductLocation = (product) => {
  const locations = Array.isArray(product?.location) ? product.location : []
  const firstLocation = locations[0]
  return Boolean(
    firstLocation?.address &&
      firstLocation?.city &&
      firstLocation?.state &&
      firstLocation?.zip,
  )
}

const withCommunityLocationIfMissing = (product, community) => {
  if (!product || hasCompleteProductLocation(product)) return product
  const communityLocation = getCommunityLocationFromProject(community)
  if (
    !communityLocation.address ||
    !communityLocation.city ||
    !communityLocation.state ||
    !communityLocation.zip
  ) {
    return product
  }
  return {
    ...product,
    location: [{ id: 0, ...communityLocation }],
  }
}

const getCatalogProductSuffix = (option) => {
  if (!option) return ''
  if (option.isTrafficCatalog) return '(TC)'
  if (option.inhouse === 5) return '(Client Owned Catalog)'
  if (option.inhouse === 4) return '(In Stock Catalog)'
  if (option.inhouse === 0) return '(Sub Contract)'
  if (option.inhouse === 6) return '(Split Catalog)'
  if (option.inhouse === 7) return '(Estimate Catalog)'
  return '(Production Catalog)'
}

const getMaxNegativeAdjustment = (item, hasPermission) => {
  const formulaEach = item?.inhouse === 0
    ? Number(item?.sub_contract_price || 0)
    : Number(
      (item?.expected_material_cost_with_markup || 0) +
        (item?.expected_service_cost_with_markup || 0),
    )
  const retailEachBase = Math.max(
    0,
    Number(
      item.original_actual_retail_price ??
        item.original_retail_price ??
        item.actual_retail_price ??
        item.retail_price ??
        item.product_retail_price ??
        0,
    ),
  )
  let maxNegative = Math.max(0, retailEachBase - formulaEach)
  if (hasPermission) {
    maxNegative = retailEachBase
  }
  return maxNegative
}

const getMaxNegativeInstallAdjustment = (data, hasPermission) => {
  const formula = Number(data?.expected_install_labor_cost_with_markup) || 0
  const retail = Math.max(
    0,
    Number(data?.original_install_cost) || Number(data?.install_cost) || 0,
  )
  let maxNegative = Math.max(0, retail - formula)
  if (hasPermission) {
    maxNegative = retail
  }
  return maxNegative
}

const createEmptyProductRow = (indexId = 1) => ({
  indexId,
  entryMode: 'write',
  product_name: '',
  product_desc: '',
  price: 0,
  retail_price: 0,
  is_product_row: 1,
  product_write: 0,
  catalogProduct: null,
  isPersistedRow: false,
})

const PRODUCT_ENTRY_TOGGLE_PAD = 4

const getProductToggleDisplayMode = (row) => {
  if (Number(row?.product_write) === 1) return 'write'
  if (row?.entryMode === 'write' || row?.entryMode === 'choose') return row.entryMode
  if (row?.is_product_row == 1) return 'write'
  return 'choose'
}

// const isDesignOrderLockedProductToggle = (row, userType) =>
//   userType != 1 && userType != 12 && Boolean(row?.isPersistedRow)
const isDesignOrderLockedProductToggle = (row, userTypeOriginal) => {
  if (userTypeOriginal == 1 || userTypeOriginal == 12) return false
  if (row?.isNewlyAddedProductRow) return false
  if (Number(userTypeOriginal) === 11) {
    return Number(row?.addedByUserType ?? row?.catalogProduct?.addedByUserType) !== 11
  }
  return Boolean(row?.isPersistedRow)
}

const PRODUCT_TABLE_PRODUCT_COL_SX = {
  minWidth: 280,
  width: 280,
  maxWidth: 280,
  verticalAlign: 'middle',
}

const PRODUCT_TABLE_DESCRIPTION_COL_SX = {
  minWidth: 320,
  width: 320,
  maxWidth: 320,
  verticalAlign: 'middle',
}

const ProductLineEntryToggle = ({ mode, onChange, disabled, lockDisplay }) => {
  const theme = useTheme()
  const isWrite = mode === 'write'
  const pad = PRODUCT_ENTRY_TOGGLE_PAD
  const inactiveColor =
    theme.palette.mode === 'dark' ? theme.palette.grey[300] : theme.palette.grey[800]
  const activeColor = theme.palette.common.white

  const segmentButtonSx = (active) => ({
    flex: 1,
    position: 'relative',
    zIndex: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.5,
    minWidth: 0,
    px: 1.25,
    py: 0.75,
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: active ? 800 : 600,
    lineHeight: 1.25,
    color: active ? activeColor : inactiveColor,
    textShadow: active ? '0 1px 2px rgba(0,0,0,0.28)' : 'none',
    textTransform: 'none',
    letterSpacing: 0.2,
    transition: 'color 0.25s ease, transform 0.15s ease',
    '& .segment-icon': { opacity: active ? 1 : 0.85 },
    '&:hover': {
      bgcolor: active ? 'transparent' : (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)'),
      color: active ? activeColor : (theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.grey[900]),
    },
    '&:active': { transform: active ? 'none' : 'scale(0.98)' },
  })

  const shellSx = {
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'stretch',
        width: '100%',
        maxWidth: 176,
        minWidth: 160,
        p: `${pad}px`,
        borderRadius: '14px',
        border: `1px solid ${theme.palette.divider}`,
        bgcolor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(145, 158, 171, 0.1)',
    opacity: disabled && !lockDisplay ? 0.55 : 1,
    pointerEvents: disabled || lockDisplay ? 'none' : 'auto',
        boxShadow: theme.palette.mode === 'dark' ? 'inset 0 1px 0 rgba(255,255,255,0.06)' : 'inset 0 1px 2px rgba(0,0,0,0.05)',
  }

  const sliderGradient = isWrite
    ? `linear-gradient(145deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 55%, ${theme.palette.primary.dark} 100%)`
    : `linear-gradient(145deg, ${theme.palette.success.light} 0%, ${theme.palette.success.main} 55%, ${theme.palette.success.dark} 100%)`

  if (lockDisplay) {
    return (
      <Box role="group" aria-label="Product entry mode" sx={shellSx}>
        <Box
          aria-hidden
          sx={{
            position: 'absolute',
            top: pad,
            left: pad,
            right: pad,
            bottom: pad,
            borderRadius: '10px',
            zIndex: 0,
            background: sliderGradient,
            boxShadow: isWrite
              ? `0 2px 6px ${theme.palette.primary.main}33`
              : `0 1px 4px ${theme.palette.success.main}22`,
          }}
        />
        <Button
          variant="text"
          disableRipple
          size="small"
          sx={{
            ...segmentButtonSx(true),
            width: '100%',
            color: activeColor,
            textShadow: '0 1px 2px rgba(0,0,0,0.28)',
          }}
        >
          <Icon className="segment-icon" icon={isWrite ? 'eva:edit-2-outline' : 'eva:grid-outline'} width={15} height={15} />
          {isWrite ? 'Write' : 'Choose'}
        </Button>
      </Box>
    )
  }

  return (
    <Box role="group" aria-label="Product entry mode" sx={shellSx}>
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          top: pad,
          left: pad,
          bottom: pad,
          width: `calc((100% - ${pad * 2}px) / 2)`,
          borderRadius: '10px',
          transform: isWrite ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.32s cubic-bezier(0.34, 1.2, 0.64, 1), background 0.32s ease, box-shadow 0.32s ease',
          zIndex: 0,
          background: sliderGradient,
          boxShadow: isWrite
            ? `0 2px 6px ${theme.palette.primary.main}33`
            : `0 1px 4px ${theme.palette.success.main}22`,
        }}
      />
      <Button variant="text" disableRipple size="small" onClick={() => onChange('write')} sx={segmentButtonSx(isWrite)}>
        <Icon className="segment-icon" icon="eva:edit-2-outline" width={15} height={15} />
        Write
      </Button>
      <Button variant="text" disableRipple size="small" onClick={() => onChange('choose')} sx={segmentButtonSx(!isWrite)}>
        <Icon className="segment-icon" icon="eva:grid-outline" width={15} height={15} />
        Choose
      </Button>
    </Box>
  )
}

const selectInputValue = (event) => {
  const input = event.target
  setTimeout(() => { 
    if (input?.select) {
      input.select()
    }
  }, 0)
}

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const getChunks = (str) => {
    const chunks = [];
    let currentChunk = '';
    let chunkType = null; // 'hash', 'otherSpecial', 'digit', or 'letter'

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      const isDigit = /\d/.test(char);
      const isLetter = /[a-zA-Z]/.test(char);
      const isHash = char === '#';
      const isOtherSpecial = !isDigit && !isLetter && !isHash;
      
      // Determine chunk type with priority: hash < otherSpecial < digit < letter
      let currentType;
      if (isHash) {
        currentType = 'hash';
      } else if (isOtherSpecial) {
        currentType = 'otherSpecial';
      } else if (isDigit) {
        currentType = 'digit';
      } else {
        currentType = 'letter';
      }

      if (i === 0) {
        chunkType = currentType;
        currentChunk = char;
      } else if (currentType === chunkType) {
        currentChunk += char;
      } else {
        chunks.push({
          value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
          type: chunkType
        });
        currentChunk = char;
        chunkType = currentType;
      }
    }

    if (currentChunk) {
      chunks.push({
        value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
        type: chunkType
      });
    }

    return chunks;
  };

  const chunksA = getChunks(a);
  const chunksB = getChunks(b);
  const len = Math.min(chunksA.length, chunksB.length);

  // Type priority: hash (0) < otherSpecial (1) < digit (2) < letter (3)
  const getTypePriority = (type) => {
    if (type === 'hash') return 0;
    if (type === 'otherSpecial') return 1;
    if (type === 'digit') return 2;
    return 3; // letter
  };

  for (let i = 0; i < len; i++) {
    const chunkA = chunksA[i];
    const chunkB = chunksB[i];

    const priorityA = getTypePriority(chunkA.type);
    const priorityB = getTypePriority(chunkB.type);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // Same type, compare values
    if (chunkA.type === 'digit') {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    } else {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    }
  }

  if (chunksA.length < chunksB.length) return -1;
  if (chunksA.length > chunksB.length) return 1;

  return 0;
}

const getStatusColorAndLabel = (status, hold, design_order_job_status, send_client_app_req, designs, is_from_client, is_in_queue, is_closed) => {
  // HOLD: hold=1 AND status !=0
  if (hold == 1 && status != 0) {
    return {
      color: 'warning',
      label: 'Status: Hold',
    }
  }
  
  // REJECTED: status=6 AND hold=0
  if (status == 6 && hold == 0) {
    return {
      color: 'error',
      label: 'Status: Rejected',
    }
  }
  
  // APPROVED: status=2 AND hold=0
  if (status == 2 && hold == 0) {
    return {
      color: 'success',
      label: 'Status: Approved',
    }
  }
  
  // DESIGN JOB COMPLETED: design_order_job_status = 3 AND send_client_app_req=0 AND status !=0 AND hold = 0
  if (design_order_job_status == 3 && send_client_app_req == 0 && status != 0 && hold == 0) {
    return {
      color: 'success',
      label: 'Status: Review/Send for Approval',
    }
  }
  
  // Check if there are design attachments (doa.id IS NOT NULL equivalent)
  // Check for any attachment with isDesign == 1
  const hasDesignAttachments = designs && Array.isArray(designs) && designs.length > 0 ;
  
  // For status 1, check conditions in priority order
  if (status == 1 && hold == 0) {
    // Handle null/undefined for design_order_job_status
    const jobStatus = design_order_job_status != null ? design_order_job_status : 0;
    
    // AWAITING APPROVAL: status=1 AND hold=0 AND send_client_app_req=1 AND doa.id IS NOT NULL
    if (send_client_app_req == 1 && hasDesignAttachments) {
      return {
        color: 'warning',
        label: 'Status: Awaiting Approval',
      }
    }
    
    // IN DESIGN: doa.id IS NOT NULL AND status = 1 AND hold = 0 AND send_client_app_req=0 AND design_order_job_status != 3
    // This must be checked before NEW to ensure it takes priority when attachments exist
    // if (send_client_app_req == 0 && jobStatus != 3 && hasDesignAttachments) {
    if (send_client_app_req == 0 && jobStatus == 2) {
      return {
        color: 'info',
        label: 'Status: In Design',
      }
    }
    
    // NEW: status=1 AND hold=0 AND doa.id IS NULL AND design_order_job_status != 3 AND send_client_app_req=0
    // Only show NEW if there are NO design attachments
    if (send_client_app_req == 0 && (jobStatus == 1 || jobStatus == 7)&& is_in_queue == 1) {
      return {
        color: 'info',
        label: 'Status: In Queue',
      }
    }
    if (send_client_app_req == 0 && jobStatus == 1  && is_in_queue == 0 ) {
      return {
        color: 'info',
        label: 'Status: New',
      }
    }
    
    // Default fallback for status 1
    return {
      color: 'info',
      label: 'Status: Open',
    }
  }
  
  // Other status cases
  switch (status) {
    case 3:
      return {
        color: hold == 1 ? 'warning' : (is_closed == 1 ? 'error' : 'success'),
        label: hold == 1 ? 'Status: Hold' : (is_closed == 1 ? 'Status: Closed' : 'Status: Approved'),
      }
    case 4:
      return {
        color: hold == 1 ? 'warning' : 'warning',
        label: hold == 1 ? 'Status: Hold' : 'Status: Draft',
      }
    case 5:
      return {
        color: hold == 1 ? 'warning' : 'warning',
        label: hold == 1 ? 'Status: Hold' : 'Status: Closed',
      }
    case 6:
      return {
        color: hold == 1 ? 'warning' : 'error',
        label: hold == 1 ? 'Status: Hold' : 'Status: Rejected',
      }
    default:
      return {
        color: hold == 1 ? 'warning' : 'default',
        label: hold == 1 ? 'Status: Hold' : 'Status: Open',
      }
  }
}

const VALUE_SERVICES = [
  // { id: 0, value: 'Product Sl No.' },
  { id: 1, value: 'Service Name' },
  { id: 2, value: 'Markup (%)' },
  { id: 3, value: 'Cost (Hourly)' },
  { id: 4, value: 'Markup Cost (Hourly)' },
  { id: 5, value: 'Hours' },
  // { id: 6, value: 'Location' },
  { id: 7, value: 'Product Formula Cost' },
  { id: 8, value: 'Additional Cost' },
  { id: 9, value: 'Total cost' },
  { id: 10, value: '' },
]

const useStyles = makeStyles((theme) => ({
  attachmentBox: {
    cursor: 'pointer',
    display: 'flex',
    borderRadius: '6px',
    backgroundColor: '#172e34',
    padding: theme.spacing(1),
    margin: theme.spacing(1, 0),
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    height: '100px',
    overflow: 'hidden',
  },
  attachmentIcon: {
    marginRight: theme.spacing(1),
  },
  delete: {
    m: 2,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  checkbox: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  checkboxContainer: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  dialogContent: {
    padding: theme.spacing(3),
    maxWidth: 768,
    margin: 'auto',
    display: 'flex',
    flexDirection:'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  gridContainer: {
    height: 'auto',
  },
}))

const ATTACHMENTS_PUBLIC_MARKER = '/storage/v1/object/public/signwise-attachments/'

const normalizeUrlString = (raw) => {
  if (!raw) return ''
  try {
    const u = new URL(raw)
    return `${u.origin}${u.pathname}`.replace(/\/+$/, '')
  } catch {
    return raw.split('?')[0].split('#')[0].trim()
  }
}

/** True for URLs / storage paths — false for bare filenames like "Screenshot.png". */
const looksLikeAttachmentRef = (raw) => {
  const s = String(raw || '')
  if (!s) return false
  if (
    s.includes('://') ||
    s.includes('/attachments/file') ||
    s.includes('/storage/v1/object/') ||
    s.includes(ATTACHMENTS_PUBLIC_MARKER)
  ) {
    return true
  }
  // storage-relative path e.g. sales-orders/123_file.png
  return s.includes('/') && /\.[a-z0-9]+$/i.test(s)
}

/** Collapse proxy URLs + direct Supabase URLs to the same storage path. */
const normalizeAttachmentIdentifier = (raw) => {
  if (!raw) return ''
  const str = String(raw).trim()
  if (!str) return ''

  if (str.includes('/attachments/file') && str.includes('path=')) {
    return normalizeUrlString(resolveAttachmentProxyPath(str))
  }

  const publicIdx = str.indexOf(ATTACHMENTS_PUBLIC_MARKER)
  if (publicIdx !== -1) {
    return normalizeUrlString(str.slice(publicIdx + ATTACHMENTS_PUBLIC_MARKER.length))
  }

  return normalizeUrlString(str)
}

const getAttachmentId = (file) =>
  file?.id ?? file?.ID ?? file?.attachment_id ?? file?.design_order_attachment_id ?? null

/** Prefer url/file_url; only use name when it is a URL/path (not a bare filename). */
const getAttachmentPrimaryRef = (f) => {
  if (!f) return ''
  if (f.url) return f.url
  if (f.file_url) return f.file_url
  if (looksLikeAttachmentRef(f.name)) return f.name
  return ''
}

const attachmentFileKey = (f) => {
  const primary = getAttachmentPrimaryRef(f)
  if (primary) return normalizeAttachmentIdentifier(primary)
  // last resort: bare name (unique only when filenames differ)
  return normalizeAttachmentIdentifier(f?.name || '')
}

const attachmentMatches = (a, b) => {
  const idA = getAttachmentId(a)
  const idB = getAttachmentId(b)
  if (idA != null && idB != null && String(idA) !== '' && String(idB) !== '') {
    return String(idA) === String(idB)
  }

  const keyA = attachmentFileKey(a)
  const keyB = attachmentFileKey(b)
  return Boolean(keyA && keyB && keyA === keyB)
}

const pruneAttachmentMapsByFile = (map, fileToRemove) => {
  if (!fileToRemove || !map) return map || {}
  const next = { ...map }
  Object.keys(next).forEach((k) => {
    const arr = next[k]
    if (!Array.isArray(arr)) return
    const filtered = arr.filter((f) => !attachmentMatches(f, fileToRemove))
    if (filtered.length === 0) {
      delete next[k]
    } else {
      next[k] = filtered
    }
  })
  return next
}

const isProductLinkedDesignAttachment = (file, productAttachmentsMap = {}) => {
  const allProductAttachmentFiles = Object.values(productAttachmentsMap).flat()
  const productAttachmentKeys = new Set(
    allProductAttachmentFiles.map(attachmentFileKey).filter(Boolean),
  )
  const productAttachmentIds = new Set(
    allProductAttachmentFiles
      .map((attachment) => getAttachmentId(attachment))
      .filter((id) => id !== null && id !== undefined)
      .map(String),
  )

  const attachmentId = getAttachmentId(file)
  if (attachmentId != null && productAttachmentIds.has(String(attachmentId))) {
    return true
  }

  const fileKey = attachmentFileKey(file)
  return Boolean(fileKey && productAttachmentKeys.has(fileKey))
}

const filterDesignOnlyAttachments = (files, productAttachmentsMap) =>
  (files || []).filter((file) => !isProductLinkedDesignAttachment(file, productAttachmentsMap))

export default function ViewDesignOrder({popupOn, idOfProject, isEditDesignOrder, closeView, setRenderCards, renderCards, onDataChange, headerStepBackRef, onExitDesignOrderEditMode}) {
  const rejectType=[
    {id:1, value:'CLIENT REVISION'},
     {id:2, value:'DESIGN REVISION'},
     {id:3, value:'SALES REVISION'},
    ]
  const { COMPANY_LOGO } = useCompanyProfile()
  const theme = useTheme()
  const { id:ids } = useParams()
  const id = popupOn ? idOfProject : ids
  const classes = useStyles()
  const location = useLocation()
  const edit = popupOn ? isEditDesignOrder : !!(location?.state && !location.state?.fromProjects)
  const fromEstimate = location?.state?.fromEstimate
  const isFromProjects = location.state?.fromProjects || false
  // const edit = false
  const xs = useMediaQuery(theme.breakpoints.down('xs'))
  const sm = useMediaQuery(theme.breakpoints.down('sm'))
  const mdd = useMediaQuery(theme.breakpoints.down('md'))
  const xld = useMediaQuery(theme.breakpoints.up('xl'))
  const componentRef = useRef()
  const designOrderInvoicePrintRef = useRef()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const user = JSON.parse(localStorage.getItem('user'))
  const [currentRFQData, setCurrentRFQdata] = useState({})
  console.log('currentRFQData', currentRFQData)
  const [openEdit, setOpenEdit] = useState(false)
  const [designs, setDesigns] = useState([])
  const [details, setDetails] = useState(null)
  console.log('details++++++++++++++++++', details)
  const [skills, setSkill] = useState(null)
  const [workflow, setWorkFlow] = useState(null)
  const [allProducts, setAllproducts] = useState(null)
  const [invoice, setInvoice] = useState(null)
  const [open, setIsOpen] = useState(false)
  const [totalsum, setTotalSum] = useState(0)
  const [rfqSubTotal, setRFQSubTotal] = useState(0)
  const [DiscountTotal, setDiscountTotal] = useState(0)
  // const [totalWholesalePrice, setTotalWholesalePrice] = useState(0)
  // const [totalRetailPrice, setTotalRetailPrice] = useState(0)
  // const [totalProductFormula, setTotalProductFormula] = useState(0)
  const [addClient, setAddClient] = useState(false)
  const [addVendor, setAddVendor] = useState(false)
  const [progress, setProgress] = useState(null)
  const [addProposal, setAddProposal] = useState(false)
  const [openInvoice, setOpenInvoice] = useState(false)
  const [requestAccept, setRequestAccept] = useState(false)
  const [requestReject, setRequestReject] = useState(false)
  const [allClients, setAllClients] = useState(null)
  const [allClientsEdit, setAllClientsEdit] = useState(null)
  const [currentDate, setCurrentDate] = useState(moment().format('YYYY-MM-DD'))
  const [isCommunityLoading, setIsCommunityLoading] = useState(false)
  const [communities, setCommunities] = useState([])
  const [designOrderProducts, setDesignOrderProducts] = useState([])
  const [designOrderProductGroups, setDesignOrderProductGroups] = useState([])
  const [currentTab, setCurrentTab] = useState(
    user.isVendor ? 'Details' : 'Order Details',
  )
  const [clientApprove, setClientApprove] = useState()
  const [openPreview, setOpenPreview] = useState(false)
  const [orderTextFields, setOrderTextFields] = useState({
    name: '',
    description: '',
    notes: '',
  })
  const [orderTextFieldErrors, setOrderTextFieldErrors] = useState({})
  const [openConvertToSalesOrder, setOpenConvertToSalesOrder] = useState(false)
  const [openConvertToEstimate, setOpenConvertToEstimate] = useState(false)
  const [openConvertToEstimateRequest, setOpenConvertToEstimateRequest] = useState(false)
  const [openMergeToSalesOrder, setOpenMergeToSalesOrder] = useState(false)
  const [openMergeToEstimate, setOpenMergeToEstimate] = useState(false)
  const [openMergeToRequestEstimate, setOpenMergeToRequestEstimate] = useState(false)
  const [openConvertToSplitEstimate, setOpenConvertToSplitEstimate] = useState(false)
  const [convertToSplitEstimate, setConvertToSplitEstimate] = useState(false)
  // const [rejectFile, setRejectFile] = useState(null)
  const [rejectFiles, setRejectFiles] = useState([])
  const [isUploadingRejectFile, setIsUploadingRejectFile] = useState(false)
  const [avatarUrl, setAvatarUrl] = useState([])
  const [referenceFiles, setReferenceFiles] = useState([])
  const [initialAvatarUrls, setInitialAvatarUrls] = useState([]);
  const [initialReferenceUrls, setInitialReferenceUrls] = useState([]);
  const [allAvatarUrl, setAllAvatarUrl] = useState([])
  const [openDelete, setOpenDelete] = useState(false)
  const [reOpen, setReopen] = useState(false)
  const [openReopenDesignOrderDuplicate, setOpenReopenDesignOrderDuplicate] = useState(false)
  const [openDesignOrderDuplicate, setOpenDesignOrderDuplicate] = useState(false)
  const [isDuplicatingDesignOrder, setIsDuplicatingDesignOrder] = useState(false)
  const [confirmInvoice, setConfirmInvoice] = useState(false)
  const [convertToRFQ, setConvertToRFQ] = useState(false)
  const [invoiceReject, setRejectInvoice] = useState(false)
  // const [reqAcceptClient,setReqAcceptClient] = useState(false)
  const [reason, setReason] = useState('')
  const [rejectTypeId, setRejectTypeId] = useState('')
  const [requestedDueDate, setRequestedDueDate] = useState(null)
  const [acceptedClients, setAcceptedClients] = useState(null)
  const [updates, setUpdates] = useState(null)
  const [isSaving, setIsSaving] = useState(false)
  const [previewData, setPreviewData] = useState({})
  const [refresh, setRefresh] = useState(false)
  const ref = useRef()
  const [proposalData, setProposalData] = useState(null)
  const [teamMembers, setTeamMember] = useState([])
  const [customerData, setCustomerData] = useState([])
  const [jobNoteMembers, setJobNoteMembers] = useState(null)
  const [isMember, setIsMember] = useState(false)
  const [localRenderCards, setLocalRenderCards] = useState(false)
  const renderCardsValue = popupOn ? renderCards : localRenderCards
  const setRenderCardsValue = popupOn ? setRenderCards : setLocalRenderCards
  const [loading, setLoading] = useState(false)
  const printableContentRef = useRef()
  const loadedProductGroupsRef = useRef([])
  const productRowsHydratedRef = useRef(false)
  const [openHoldPopup, setOpenHoldPopup] = useState(false);
  const [holdReason, setHoldReason] = useState('');
  const [isSubmittingHold, setIsSubmittingHold] = useState(false);
  const [holdReasonError, setHoldReasonError] = useState('');
  const [rejectedAttachments, setRejectedAttachments] = useState([]);
  const [isClientEdited, setIsClientEdited] = useState(false);
  const [showApprovalPopup, setShowApprovalPopup] = useState(false);

  localStorage.setItem('requestId', id ? id : null)
  let userType = user.user_type
  let userTypeOriginal= user.user_type
  console.log('userType', userType) 
  let userId = user.user_id
  let isClient = user.isClient
  let teamId=user.team_id||null;
  if (user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType =3 // user.parent_user_type
  }
  const explodedPermissions = user?.exploded_permissions
  const {
    hasNew: designNotesHasNew,
    clearNew: clearDesignNotesNew,
  } = useJobNoteTabUnread({
    requestId: details?.converted_design_request_id || null,
    designOrderId: id,
    noteType: 'design',
    userId: user?.user_id,
    // Wait for details so converted request id (if any) is included in the first check
    enabled: !user?.isVendor && details != null,
    isActiveTab: currentTab === 'Design Notes',
    activeTab: currentTab,
  })
  const [data, setData] = useState({})
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [formValues, setFormValues] = useState({})
  const [formDatas, setFormDatas] = useState({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSavingDraft, setIsSavingDraft] = useState(false)
  const [isSubmittingReject, setIsSubmittingReject] = useState(false);
  const [additionalSelectedServices, setAdditionalSelectedServices] = useState(
    [],
  )
  const [productRows, setProductRows] = useState([createEmptyProductRow(1)])
  console.log('productRows', productRows)
  const [catalogPickerOpen, setCatalogPickerOpen] = useState(false)
  const [catalogPickerRowIndexId, setCatalogPickerRowIndexId] = useState(null)
  const [catalogPickerDraft, setCatalogPickerDraft] = useState(null)
  const [rowErrors, setRowErrors] = useState({})
  const [productIndexCounter, setProductIndexCounter] = useState(1)
  const [productAttachments, setProductAttachments] = useState({})
  console.log('productAttachments', productAttachments)
  const [openProductAttachment, setOpenProductAttachment] = useState({})
  const [attachmentTabValue, setAttachmentTabValue] = useState({})
  const [selectedUploadedImages, setSelectedUploadedImages] = useState({})
  const [isUploadingProduct, setIsUploadingProduct] = useState({})
  const [productAttachmentDragOver, setProductAttachmentDragOver] = useState({})
  const [locationStates, setLocationStates] = useState({})
  const [openProductNote, setOpenProductNote] = useState({})
  const [isSavingNote, setIsSavingNote] = useState(false)
  const [isClearingNote, setIsClearingNote] = useState(false)
  const [currentNote, setCurrentNote] = useState('')
  const [noteError, setNoteError] = useState(false)
  const [initialSelectedServices, setInitialSelectedServices] = useState([])
  const [markupType, setMarkupType] = useState(2)
  const hasMarkupPermission = explodedPermissions?.some((permission) =>
    ['View Markup'].includes(permission),
  ) ? true : false

  const grouping = useDesignOrderProductGrouping({
    productRows,
    setProductRows,
    markupType,
    theme,
    enqueueSnackbar,
    productAttachments,
    setProductAttachments,
    explodedPermissions,
    hasMarkupPermission,
    onRemapRowSideEffects: (indexIdMap) => {
      const remapKeys = (prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const install = String(oldKey).endsWith('_install')
          const base = install ? String(oldKey).replace('_install', '') : oldKey
          const newKey = indexIdMap[base]
          if (newKey !== undefined) {
            next[install ? `${newKey}_install` : String(newKey)] = prev[oldKey]
          }
        })
        return next
      }
      setRowErrors((prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = indexIdMap[oldKey]
          if (newKey !== undefined) next[newKey] = prev[oldKey]
        })
        return next
      })
      setProductAttachments(remapKeys)
      setLocationStates(remapKeys)
      setOpenProductAttachment(remapKeys)
      setIsUploadingProduct(remapKeys)
      setOpenProductNote(remapKeys)
      const maxId = Math.max(0, ...Object.values(indexIdMap || {}).map(Number))
      setProductIndexCounter(maxId > 0 ? maxId + 1 : 1)
    },
  })

  const {
    productTableBodyRenderOrder,
    groupedProductsMap,
    catalogProducts,
    setCatalogProducts,
    groupedProducts,
    groupSelectedProductIds,
    groupEditMode,
    toggleGroupProductSelection,
    getProductAttachmentsList: getGroupProductAttachmentsList,
    setCustomerOrderProductGroups: setGroupingCustomerOrderProductGroups,
    setGroupProductMarketingValues,
    setGroupInstallMarketingValues,
    groupProductMarketingValues,
    groupInstallMarketingValues,
  } = grouping

  const designOrderGroupValueColumns = useMemo(
    () => getDesignOrderGroupValueColumns(markupType ?? 2, hasMarkupPermission),
    [markupType, hasMarkupPermission],
  )

  const tableBodyRenderItems = useMemo(() => {
    const order = productTableBodyRenderOrder || []
    if (order.length > 0) return order
    return (productRows || []).map((row) => ({ type: 'row', indexId: row.indexId }))
  }, [productTableBodyRenderOrder, productRows])

  const hasNegativeDesignMarketingPermission = explodedPermissions?.some((permission) =>
    DESIGN_ORDER_NEGATIVE_MARKETING_PERMISSIONS.includes(permission),
  )

  const [selectedServices, setSelectedServices] = useState([])
  const [filteredServices, setFilteredServices] = useState([])
  const [serviceOnlyLocationStates, setServiceOnlyLocationStates] = useState({})
  const [allServiceLocationSame, setAllServiceLocationSame] = useState(false)
  const [membersLoading, setMembersLoading] = useState(false)
  const [filteredMembers, setFilteredMembers] = useState([])
  const [designers, setDesigners] = useState([])
  const [collaborators, setCollaborators] = useState([])
  const [salesRepName, setSalesRepName] = useState('')
  const [salesRepId, setSalesRepId] = useState(null)
  const [salesRepOptions, setSalesRepOptions] = useState([])
  const [teamMembersOptions, setTeamMembersOptions] = useState([])
  const [teamMembersLoading, setTeamMembersLoading] = useState(false)
  const [isUploading, setIsUploading] = useState(false)
  const [isUploadingReference,setIsUploadingReference] = useState(false)
  const [selectedPDF, setSelectedPDF] = useState(null)
  const [selectedPDFItem, setSelectedPDFItem] = useState(null)
  const [openPDFModal, setOpenPDFModal] = useState(false)
  const [pdfLoading, setPdfLoading] = useState(true)
  const [useOfficeViewer, setUseOfficeViewer] = useState(true)
  const [openDesignSelect, setOpenDesignSelect] = useState(false)
  const [sendForApproval, setSendForApproval] = useState(false)
  const [selectedDesigns, setSelectedDesigns] = useState([])
  const [openImageModal,setOpenImageModal] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDesignsInModal, setSelectedDesignsInModal] = useState([]);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [emailModalDesigns, setEmailModalDesigns] = useState([]);
  const [openInvoiceEmailModal, setOpenInvoiceEmailModal] = useState(false);
  const [invoicePdfData, setInvoicePdfData] = useState(null);
  // Print/preview ready only after products + services from design-order fetch are available
  const [invoicePreviewReady, setInvoicePreviewReady] = useState(false);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [progressRequestData, setProgressRequestData] = useState(null);
  const [socketReady, setSocketReady] = useState(false);
  const [progressHeading, setProgressHeading] = useState('Updating Design Order');
  const [autoUpdateData, setAutoUpdateData] = useState(null);
  const [editTab, setEditTab] = useState(0); // 0: Design Order, 1: Design Forms
  const [savedDesignFormData, setSavedDesignFormData] = useState({});
  const [isLoadingFormData, setIsLoadingFormData] = useState(false);
  const [allTeamMembers, setAllTeamMembers] = useState([]);
  const socketRef = useRef(null);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [openReopenConfirm, setOpenReopenConfirm] = useState(false);
  const [openCloseConfirm, setOpenCloseConfirm] = useState(false);
  const [isClosingDesignOrder, setIsClosingDesignOrder] = useState(false);
  const accessPublicMessageBoard = explodedPermissions?.some((permission) =>
    ['Access Design Order Client Message Board'].includes(permission),
  )
  const accessForApproveDesignOrderForClient = explodedPermissions?.some((permission) =>
    ['Approve Design Order For Client'].includes(permission),
  )
  const accessForSendDesignOrderToClient = explodedPermissions?.some((permission) =>
    ['Send Design Order To Client'].includes(permission),
  )
  const hasViewCostPermission =
    !explodedPermissions?.length ||
    explodedPermissions.some((permission) =>
      ['View Cost', 'View Product Cost', 'View Service Cost', 'View Design Order Cost', 'View Estimate Cost'].includes(permission),
    )

  const handlePrintDesignOrder = useReactToPrint({
    content: () => designOrderInvoicePrintRef.current,
    pageStyle: `
      @page { size: A3; margin: 12mm; }
      body { font-family: 'Public Sans', sans-serif; font-size: 12pt; }
      table { width: 100%; border-collapse: collapse; }
      #right { text-align: right; margin-top: -200px; }
      #total { text-align: right; display:flex; justify-content: flex-end; }
      #subtotal { text-align: left; }
      #discount { text-align: left; word-wrap: break-word; margin-right: 100px; }
      #totalmain { text-align: left; }
      #subtotal1 { text-align: left; }
      #discount1 { text-align: left; word-wrap: break-word; margin-right: 30px; }
      #totalmain1 { text-align: left; }
      #total1 { text-align: right; display:flex; justify-content: flex-end; margin-top: -320px; }
      .quotation-heading-print { text-align: center; width: 100%; position: absolute; left: -60px; right: 0; top: -20px; }
      #logoImage { height: 100px; width:100px; }
      #order, #title, #orderID, #to { margin-bottom:-20px; }
    `,
  })

  const designOrderInvoiceTotals = useMemo(
    () => computeDesignOrderInvoiceTotals({
      designOrderProducts,
      designOrderServices: initialSelectedServices || [],
      details,
      invoice,
      customerOrderProductGroups: designOrderProductGroups,
      markupType,
      groupProductMarketingValues,
      groupInstallMarketingValues,
    }),
    [
      designOrderProducts,
      initialSelectedServices,
      details,
      invoice,
      designOrderProductGroups,
      markupType,
      groupProductMarketingValues,
      groupInstallMarketingValues,
    ],
  )

  const designOrderInvoiceDetails = useMemo(() => {
    const projectCommunity = getDesignOrderProjectCommunity(communities, details)
    return {
      ...details,
      show_install_price: details?.show_install_price ?? 1,
      community_address: details?.community_address || projectCommunity?.address || '',
      community_city: details?.community_city || projectCommunity?.city || '',
      community_state: details?.community_state || projectCommunity?.state || '',
      community_zipcode: details?.community_zipcode || projectCommunity?.zip || '',
      community_po_number: details?.community_po_number || projectCommunity?.po_number || '',
      sales_rep_names: details?.sales_rep_names || details?.added_by_name || '',
      participation_ends: details?.participation_ends || details?.due_date || null,
    }
  }, [details, communities])

  const designOrderInvoiceForPrint = useMemo(
    () => ({
      ...invoice,
      cust_product: mapDesignOrderProductsToCustProduct(designOrderProducts),
      customer_contact_name: invoice?.customer_contact_name || invoice?.customer_name || '',
      customer_address:
        invoice?.customer_address ||
        (customerData?.address
          ? [
              customerData.address,
              customerData.city,
              customerData.state,
              customerData.zip || customerData.zip_code,
            ]
              .filter(Boolean)
              .join(', ')
          : ''),
      total: designOrderInvoiceTotals.total,
      extra_discount: designOrderInvoiceTotals.discount,
      tax_amount: designOrderInvoiceTotals.tax,
    }),
    [invoice, designOrderProducts, customerData, designOrderInvoiceTotals],
  )

  const designOrderInvoiceAdditionalServices = useMemo(
    () => mapDesignOrderServicesForInvoice(initialSelectedServices || []),
    [initialSelectedServices],
  )

  // Gate Print until design-order fetch finished (products + services come from same API)
  useEffect(() => {
    if (!openInvoice) {
      setInvoicePreviewReady(false);
      return;
    }
    if (loading || !details) {
      setInvoicePreviewReady(false);
      return;
    }
    setInvoicePreviewReady(true);
  }, [openInvoice, loading, details, initialSelectedServices, designOrderProducts]);

  const designOrderInvoiceProductSubtotal = designOrderInvoiceTotals.productTotal + designOrderInvoiceTotals.installTotal

  const handleSendDesignOrderInvoiceEmail = () => {
    if (!invoice || !details) {
      enqueueSnackbar('Design order data not available', { variant: 'warning' })
      return
    }
    const projectCommunity = getDesignOrderProjectCommunity(communities, details)
    const mappedProducts = mapDesignOrderProductsToCustProduct(designOrderProducts)
    const mappedServices = mapDesignOrderServicesForInvoice(initialSelectedServices || [])
    const groupedDesignOrderDisplayRows = buildGroupedDesignOrderDisplayRows({
      designOrderProducts,
      customerOrderProductGroups: designOrderProductGroups,
      markupType,
      groupProductMarketingValues,
      groupInstallMarketingValues,
    })
    const invoicePdfObject = {
      id: `design_order_invoice_${details.id}`,
      name: `design_order_${details.name || details.id}_${moment().format('YYYY-MM-DD')}.pdf`,
      file_type: 'application/pdf',
      extension: 'pdf',
      url: null,
      invoiceData: {
        invoice: {
          ...designOrderInvoiceForPrint,
          cust_product: mappedProducts,
        },
        details: designOrderInvoiceDetails,
        invoiceDate,
        subTotal: designOrderInvoiceTotals.subtotal,
        groupedInvoiceProductTotal: designOrderInvoiceTotals.productTotal,
        groupedInvoiceInstallTotal: designOrderInvoiceTotals.installTotal,
        additionalSelectedServices: mappedServices,
        projectCommunity,
        hasViewCostPermission,
        customerOrderProductGroups: designOrderProductGroups,
        groupedDesignOrderDisplayRows: serializeDesignOrderGroupedRowsForInvoice(
          groupedDesignOrderDisplayRows,
        ),
        markupType,
        groupProductMarketingValues,
        groupInstallMarketingValues,
      },
    }
    setInvoicePdfData([invoicePdfObject])
    setOpenInvoiceEmailModal(true)
  }

  const handleDesignOrderInvoiceEmailSent = () => {
    setInvoicePdfData(null)
  }

  const viewasadmin =explodedPermissions?.some(permission => ['View Design Order as Admin'].includes(permission)) ? true : false

  if (viewasadmin) {
    userType = 1
  }

  useEffect(() => {
    if (!socketRef.current) {
      // OLD CODE (keep for future restore):
      // socketRef.current = io(REST_API_IO, { path: '/socket.io', transports: ['websocket', 'polling'], secure: true });
      socketRef.current = createAppSocket();
    }
    if (user?.user_id && socketRef.current && id) {
      socketRef.current.emit('request-online-user', { userId: user.user_id, requestId: id });
      socketRef.current.emit('get-request-online-users', { requestId: id });
    }
    if (socketRef.current) {
      socketRef.current.on('update-request-online-users', (payload) => {
        if (!payload) return;
        const { requestId, users } = payload;
        if (String(requestId) !== String(id)) return;
        setOnlineUsers((users || []).map(String));
      });
    }
    return () => {
      if (socketRef.current && user?.user_id && id) {
        socketRef.current.emit('leave-request', { userId: user.user_id, requestId: id });
      }
      if (socketRef.current) socketRef.current.off('update-request-online-users');
    };
  }, [user?.user_id, id]);

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setOpenImageModal(true);
  };

  const handlePrevious = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex < imageDesigns.length - 1 ? prevIndex + 1 : prevIndex));
  };

  const isOrderSalesRepEmpty = (salesRepIds) => {
    if (salesRepIds == null) {
      return true;
    }
    if (Array.isArray(salesRepIds)) {
      return salesRepIds.filter(Boolean).length === 0;
    }
    if (typeof salesRepIds === 'string') {
      return salesRepIds.trim() === '';
    }
    return false;
  };

  const getCommunitySalesRepIds = (community) => {
    // Use ?? so an empty eligible list does not fall back to raw stored IDs.
    const rawIds = community?.all_sales_rep_ids ?? community?.sales_rep_ids;
    if (!rawIds) {
      return [];
    }

    const ids = Array.isArray(rawIds)
      ? rawIds
      : typeof rawIds === 'string'
        ? rawIds.split(',')
        : [];

    return ids
      .map((id) => String(id ?? '').trim())
      .filter(Boolean);
  };

  const getSalesRepOptionsFromCommunity = (community) => {
    const rawNames = community?.all_sales_rep_names ?? community?.sales_rep_names;
    const rawIds = community?.all_sales_rep_ids ?? community?.sales_rep_ids;

    const names = Array.isArray(rawNames)
      ? rawNames
      : typeof rawNames === 'string'
        ? rawNames.split(',').map((s) => s.trim()).filter(Boolean)
        : [];

    const ids = Array.isArray(rawIds)
      ? rawIds
      : typeof rawIds === 'string'
        ? rawIds.split(',').map((s) => s.trim()).filter(Boolean)
        : [];

    const maxLen = Math.max(names.length, ids.length);
    const options = [];

    for (let idx = 0; idx < maxLen; idx += 1) {
      const id = ids[idx] ?? null;
      const rawName = names[idx];

      const matchedTeamMember = teamMembersOptions?.find((member) => {
        const memberId = member?.id ?? member?.user_id;
        return id != null && memberId != null && String(memberId) === String(id);
      });

      const fallbackName =
        matchedTeamMember?.name ||
        [matchedTeamMember?.first_name, matchedTeamMember?.last_name].filter(Boolean).join(' ').trim();

      const name = String(rawName ?? '').trim() || fallbackName || '';
      if (!name && id == null) continue;

      options.push({
        id,
        name: name || String(id),
      });
    }

    return options;
  };

  const handleSendClientApproveReq = async (selectedDesigns) => {
    try {
      setSendForApproval(true);
      console.log('datailssssssssssss', details)
      const response = await axios.post(
        `${REST_API_END_POINT}design-order/sent-approve-req`,
        { design_order_id: details.id, client: details?.client, selectedDesigns: selectedDesigns, userId: userId },
      )
      if (response.data.status === 1) {
        enqueueSnackbar('Designs sent for client approval', { variant: 'success' })
        if (currentTab === 'Job Log') { handleJobLogUpdates() }
      } else {
        enqueueSnackbar('Failed to send designs for client approval', { variant: 'error' })
      }
    } catch (error) {
      console.log('Error while sending client approval request:', error)
      enqueueSnackbar('Failed to send designs', { variant: 'error' })
    } finally {
      setRefresh(true);
      setOpenDesignSelect(false);
      setSendForApproval(false)
    }
  }

  const handleSendSelectedDesignsToEmailModal = () => {
    if (selectedDesignsInModal.length === 0) {
      enqueueSnackbar('Please select at least one design', { variant: 'warning' })
      return
    }
    const selectedDesignFiles = filteredDesigns?.filter((item) => selectedDesignsInModal.includes(item.id))
    setEmailModalDesigns(selectedDesignFiles)
    setOpenEmailModal(true)
  }

  const handleSendCurrentItemToEmailModal = (item) => {
    if (!item || !item.id) {
      enqueueSnackbar('No item to send', { variant: 'warning' })
      return
    }
    setEmailModalDesigns([item])
    setOpenEmailModal(true)
  }

  const handleEmailSent = () => {
    setSelectedDesignsInModal([])
    if (currentTab === 'Job Log') {
      handleJobLogUpdates()
    }
  }

  const fetchDetails = async () => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}settings/get-companyProfile-details`,
      )
      if (res.data.status === 1) {
        setData(...res.data.data)
        setMarkupType(res.data.data[0]?.markup_type)
      }
    } catch (error) {
      console.log('get-companyProfile-details error : ', error)
    }
  }

  useEffect(() => {
    fetchDetails()
  }, [])

  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue)
    if (newValue === 'Design Notes') {
      clearDesignNotesNew()
    }
    // setRefresh(true)
  }
  const HandleClickmenu = () => {
    setAddClient(true)
  }

  const NewUserSchema = Yup.object().shape({
    // name/description are validated manually from local state on submit
    start: Yup.mixed().required('Start Date is required'),
    end: Yup.date()
      .nullable()
      .transform((value, originalValue) => {
        return originalValue ? new Date(originalValue * 1000) : null
      })
      .when('start', (start, schema) => {
        return start
          ? schema.min(start, 'Due Date must be greater than the Start Date')
          : schema
      }),
    community: Yup.object().nullable().required('Project is required'),
  })
  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    // color: theme.palette.text.secondary,
    //   marginBottom: theme.spacing(1)
  }))
  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    // color: theme.palette.text.secondary,
  }))
  //delete design order
  const handleDeleteOrder = async () => {
    try {
      const data = { design_order_id: id, client: details?.client ,userId}
      const res = await axios.post(
        `${REST_API}webservice/delete-design-order/id`,
        data,
      )
      if (res.data.data == true) {
        enqueueSnackbar('Order deleted successfully', { variant: 'success' })
        if(popupOn){
          closeView()
          setRenderCardsValue(!renderCardsValue)
        }else{
          navigate(PATH_DASHBOARD.design.root)
        }
      }
    } catch (error) {
      console.log(error, 'Error in deleting the order')
    }
  }
  // Fetch saved design form data for edit mode
  const fetchSavedDesignFormData = async () => {
    if (!id) return;

    try {
      setIsLoadingFormData(true);
      const res = await axios.post(
        `${REST_API_END_POINT}design-form/get-all-templates-with-values`,
        {
          designOrderId: id,
          module: 1
        }
      );

      if (res.data.status === 1) {
        const templatesWithData = res.data.data || [];

        // Convert API response to savedFormData format expected by DesignFormTabs
        // Format: { templateId: { fieldContent: { field_id, content, value, required } } }
        const convertedData = {};

        templatesWithData.forEach(template => {
          const templateId = template.id || template.template_id;
          if (!templateId) return;

          convertedData[templateId] = {};

          if (template.fields && Array.isArray(template.fields)) {
            template.fields.forEach(field => {
              const fieldContent = field.content || field.name;
              if (!fieldContent) return;

              let fieldValue = '';

              if (field.html_tag === 'checkbox-group') {
                if (field.savedValues && Array.isArray(field.savedValues) && field.savedValues.length > 0) {
                  // Remove duplicates and convert to array of objects format expected by DesignFormTabs
                  const uniqueValues = [...new Set(field.savedValues)];
                  const checkboxArray = uniqueValues.map(value => {
                    const matchingOption = field.options?.find(
                      opt => opt.label === value || opt.value === value || opt.label === String(value) || opt.value === String(value)
                    );
                    return {
                      field_id: field.field_id,
                      label: matchingOption ? matchingOption.value : value,
                      value: matchingOption ? matchingOption.label : value,
                    };
                  });
                  fieldValue = checkboxArray;
                } else {
                  fieldValue = [];
                }
              }
              else if (field.html_tag === 'file' && field.savedValues && Array.isArray(field.savedValues)) {
                field.savedValues.forEach((fileUrl, index) => {
                  const fileContentKey = index === 0 ? fieldContent : `${fieldContent}_${index + 1}`;
                  convertedData[templateId][fileContentKey] = {
                    field_id: field.field_id,
                    content: field.html_tag,
                    value: fileUrl,
                    required: field.required || 0,
                  };
                });
                return;
              }
              else {
                fieldValue = field.value || (field.savedValues && Array.isArray(field.savedValues) ? field.savedValues[0] : '') || '';

                if (field.html_tag === 'autocomplete' && field.options && Array.isArray(field.options) && fieldValue) {
                  const matchingOption = field.options.find(
                    opt => opt.label === fieldValue || opt.value === fieldValue || String(opt.label) === String(fieldValue) || String(opt.value) === String(fieldValue)
                  );
                  if (matchingOption) {
                    fieldValue = matchingOption;
                  }
                }

                if (field.html_tag === 'date' && fieldValue && typeof fieldValue === 'string') {
                  const dateMoment = moment(fieldValue);
                  if (dateMoment.isValid()) {
                    fieldValue = dateMoment.unix();
                  }
                }
              }

              convertedData[templateId][fieldContent] = {
                field_id: field.field_id,
                content: field.html_tag || field.content,
                value: fieldValue,
                required: field.required || 0,
              };
            });
          }
        });

        setSavedDesignFormData(convertedData);
      } else {
        setSavedDesignFormData({});
      }
    } catch (error) {
      console.error('Error fetching saved design form data:', error);
      setSavedDesignFormData({});
    } finally {
      setIsLoadingFormData(false);
    }
  };

  //fetch request details
  const fetchRequestDetails = async () => {
    try {
      setLoading(true)
      const res = await axios.post(
        `${REST_API_END_POINT}design/get-design-order-by-id`,
        {
          design_order_id: id,
          userId,
          userType : userType,
          isClient
        },
      )
      let Data = res.data?.data?.[0] || {}
      if (res.data?.status !== 1) {
        console.error('Failed to fetch design order details:', res.data?.message)
        return
      }
      setCustomerData(res.data.customerData)
      if ((userType == 3 || isClient) && Data.send_client_app_req == 0) {
        let filteredAttachment = res?.data?.attachments.filter(
          (item) => item.added_by == userId,
        )
        const remainingAttachments = res?.data?.attachments.filter(
          (item) => item.added_by != userId,
        )

        const originalAvatarUrls = res?.data?.attachments
            ?.filter((item) => item.added_by == userId)
            ?.map((file) => file.name || file.url);

        setInitialAvatarUrls(originalAvatarUrls);
        setAvatarUrl(filteredAttachment)
        setAllAvatarUrl(remainingAttachments)
      }else if ((userType == 3 || isClient) && Data.send_client_app_req == 1) {
        let filteredAttachment = res?.data?.attachments.filter(
          (item) => item.isDesign == 1
        )
        const remainingAttachments = res?.data?.attachments.filter(
          (item) => item.isDesign != 1
        )

        const originalAvatarUrls = res?.data?.attachments
          ?.filter((item) => item.isDesign == 1)
          ?.map((file) => file.name || file.url);

        setInitialAvatarUrls(originalAvatarUrls);
        setAvatarUrl(filteredAttachment)
        setAllAvatarUrl(remainingAttachments)
      } else {
        setAvatarUrl(res.data.attachments)
      }
      if(res?.data?.reference_attachments){
        setInitialReferenceUrls(res.data.reference_attachments)
        setReferenceFiles(res.data.reference_attachments)
      }else{
        setInitialReferenceUrls([])
        setReferenceFiles([])
      }
      setDetails({
        ...res.data?.data[0],
        description: (res.data?.data[0]?.description || '').replace(/\r?\n/g, '\n'),
        notes: (res.data?.data[0]?.notes || '').replace(/\r?\n/g, '\n'),
        projectMembers: res.data?.projectMembers || []
      });
      setInvoice(res.data?.data[0])
      setDesigns(res.data?.attachments)
      const servicesFromApi = Array.isArray(res?.data?.servicesData)
        ? res.data.servicesData
        : res?.data?.servicesData
          ? [res.data.servicesData]
          : []
      setInitialSelectedServices(servicesFromApi)
      // setUpdates(res.data.updates)
      // Sort communities alphanumerically by name
      const communityData = res.data.community || []
      const sortedCommunityData = [...communityData].sort((a, b) => 
        alphanumericCompare(a?.name || '', b?.name || '')
      )
      setCommunities(sortedCommunityData)
      const designMembers = (res.data?.projectMembers || []).filter(
        (item) => item.user_type === 11,
      )
      const normalizedDesigners = designMembers.map((member) => ({
        id: member.staff_id,
        user_id: member.user_id,
        email: member.email,
        phone: member.phone,
        emailEnabled: member.emailEnabled,
        smsEnabled: member.smsEnabled,
        pcb_new_design_jobs: member.pcb_new_design_jobs,
        pcb_new_design_jobs_email: member.pcb_new_design_jobs_email,
        pcb_new_design_jobs_sms: member.pcb_new_design_jobs_sms,
        view_design_permission: member.view_design_permission,
        name: member.name,
      }))
      setDesigners(normalizedDesigners)
      
      // // Set team members for design notes (includes designers and other project members)
      // const allProjectMembers = res.data?.projectMembers || []
      // setTeamMember(allProjectMembers)

      // Set team members for design notes (includes designers and admins)
      setTeamMember(res.data?.jobNoteMembers || [])
      setRejectedAttachments(res.data?.rejected_attachments || [])
      
      // // Set job note members (same as project members for design orders)
      // setJobNoteMembers(res.data?.projectMembers || [])

      // Set job note members (includes designers and admins for design notes)
      setJobNoteMembers(res.data?.jobNoteMembers || [])
      setDesignOrderProducts(res.data?.productsData || [])
      const groupsFromApi = res.data?.customerOrderProductGroups || []
      setDesignOrderProductGroups(groupsFromApi)
      loadedProductGroupsRef.current = groupsFromApi
      setGroupingCustomerOrderProductGroups(groupsFromApi)
      const initialProductMarketing = {}
      const initialInstallMarketing = {}
      groupsFromApi.forEach((group) => {
        const gid = group?.id ?? group?.group_id
        if (gid == null) return
        const key = String(gid)
        initialProductMarketing[key] = {
          adjustment: Number(
            group.product_marketing_adjustment ??
              group.productMarketingAdjustment ??
              0,
          ),
          adjValueType: parseGroupMarketingAdjValueTypeFromDb(
            group.product_marketing_adj_value_type ??
              group.productMarketingAdjValueType,
          ),
        }
        initialInstallMarketing[key] = {
          adjustment: Number(
            group.install_marketing_adjustment ??
              group.installMarketingAdjustment ??
              0,
          ),
          adjValueType: parseGroupMarketingAdjValueTypeFromDb(
            group.install_marketing_adj_value_type ??
              group.installMarketingAdjValueType,
          ),
        }
      })
      setGroupProductMarketingValues(initialProductMarketing)
      setGroupInstallMarketingValues(initialInstallMarketing)
      setRefresh(false)
      const productsData = res?.data?.productsData || []
      const projectCommunity = sortedCommunityData.find(
        (c) => c.id === res.data?.data?.[0]?.community,
      )
      const { mappedRows, productAttachmentsByIndex, indexCounter } =
        buildDesignOrderProductRowsFromApi(productsData, groupsFromApi, projectCommunity)
        setProductRows(mappedRows)
      setProductIndexCounter(indexCounter)
        setProductAttachments(productAttachmentsByIndex)
        setOpenProductAttachment({})
        setIsUploadingProduct({})
      productRowsHydratedRef.current = true
      setClientApprove(res.data?.data[0]?.client_approve)
      if (edit || location?.state?.fromReopen || location?.state?.fromEstimate) {
        setOpenEdit(true)
      }
    } catch (error) {
      console.error('Error fetching design order details:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (openDesignSelect && designs?.length > 0) {
      const approvedDesignIds = designs
        .filter((d) => d.approved === 1)
        .map((d) => d.id);

      // Merge with existing selectedDesigns and remove duplicates
      setSelectedDesigns((prev) => {
        const merged = [...new Set([...prev, ...approvedDesignIds])];
        return merged;
      });
    }
  }, [openDesignSelect, designs]);

  const handleJobLogUpdates = async (search = '') => {
    try {
      const res = await axios.post(`${REST_API}webservice/design-order/get-job-log-updates`, { design_order_id: id, userId, userType, search });

      if (res?.data?.status === 1) {
        if (!search) {
          setUpdates(res?.data?.updates)
        }
        return res?.data?.updates || []
      }
    } catch (error) {
      console.error('Error fetching job log details:', error);
      if (search) return []
      throw error;
    }
  };

  const handleJobLogSearch = useCallback(
    async (search) => {
      return handleJobLogUpdates(search)
    },
    [id, userId, userType],
  );

  useEffect(() => {
    if (currentTab === 'Job Log') {
      handleJobLogUpdates();
    }
  }, [currentTab]);


  const fetchAllCommunityByClient = async (clientId) => {
    setIsCommunityLoading(true)
    try {
      clientId = clientId.id
      const res = await axios.post(
        `${REST_API}webservice/rfq/get-community-by-client`,
        { clientId ,From:"addSalesOrder",teamId: null,userType:userType},
      )
      let data = res.data?.community || []
      // Sort communities alphanumerically by name
      const sortedCommunities = [...data].sort((a, b) => 
        alphanumericCompare(a?.name || '', b?.name || '')
      )
      setCommunities(sortedCommunities)
    } catch (error) {
      console.log(error, 'Error in fetching all clients')
      setCommunities([])
    } finally {
      setIsCommunityLoading(false)
    }
  }

  const fetchAllClients = async () => {
    try {
      const res = await axios.post(
        `${REST_API}webservice/clients/getAllClients`,
        { userType, userId, order: true,From:"addSalesOrder",teamId: null},
      )
      let data = res.data?.customer
      await setAllClientsEdit(data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients', error)
    }
  }

  const fetchAllServices = async () => {
    await axios
      // .post(`${REST_API}webservice/request/get-all-request`, values)
      .post(`${REST_API}webservice/request/get-labour-cost-services`)
      .then((res) => {
        let result = res?.data?.labourCostServices?.filter(
          (item) => item?.status === 1,
        )
        // setFilteredServices(res.data.labourCostServices)
        // Sort services alphanumerically by name
        const filtered = res.data.labourCostServices.filter(
            (service) => Number(service?.service_type) === 33,
        )
        const sortedServices = [...(filtered || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        setFilteredServices(sortedServices)
      })
      .catch((errors) => {
        console.log(errors, 'error in fetching all requests')
      })
  }

  const fetchMembers = async () => {
    axios
      .post(`${REST_API_END_POINT}project/get-data-for-add-project`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        if (response.data.status === 1) {
          // Sort designers alphanumerically by name
          const sortedDesigners = [...(response.data?.allDesigners || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
          setFilteredMembers(sortedDesigners)
        } else {
          setFilteredMembers([])
        }
      })
      .catch((errors) => {
        console.log(errors, 'error in fetching all requests')
        setFilteredMembers([])
      })
  }

  const fetchAllProductsForDesignOrder = async () => {
    try {
      const res = await axios.post(`${REST_API}webservice/request/get-all-quotations-add`, {
        userType,
        isClient,
        userId,
        page: 1,
        rowsPerPage: 5000,
        where: '(r.status = 8)',
        search: '',
        sort: 'new',
        from: null,
        to: null,
        filterClient: [],
        filterUser: [],
        dueData: true,
        filterProjectType: null,
        filterCommunity: [],
      })
      if (res.data?.products) {
        setAllproducts(res.data.products)
      }
    } catch (error) {
      console.log('Error fetching products for design order:', error)
    }
  }

  
  const fetchTeamMembersForCollaborators = async () => {
    if (!userId) return;
    setTeamMembersLoading(true);
    try {
      const res = await axios.post(`${REST_API_END_POINT}teams/get-all-teams-data-collaborators`, {
        usersId: userId,
        usersType: userType,
        isClient: isClient || false,
        page: 1,
        rowsPerPage: 5000,
        orderBy: 'name',
        order: 'asc',
      });
      const raw = res.data?.team_members?.data || res.data?.team_members || [];
      const list = Array.isArray(raw) ? raw : [];
      const filteredList = list.filter(member => member.userRole !== "Development" && member.user_type !== 51);
      setTeamMembersOptions(filteredList);
      setAllTeamMembers(filteredList);
    } catch (error) {
      console.log(error, 'Error fetching team members for collaborators');
      setTeamMembersOptions([]);
    } finally {
      setTeamMembersLoading(false);
    }
  }

  // const filteredOptions = useMemo(() => {
  //   return filteredServices?.filter((item) => item?.status === 1) || [];
  // }, [filteredServices]);

  // useEffect(() => {
  //   fetchRequestDetails()
  //   fetchAllClients()
  //   fetchAllServices()
  // }, [id, refresh])

  useEffect(() => {
    if (Array.isArray(jobNoteMembers) && user?.user_id) {
      const found = jobNoteMembers?.some(member => member.user_id === user.user_id);
      console.log('jobNoteMembers:', jobNoteMembers);
      console.log('user.user_id:', user.user_id);
      console.log('isMember found:', found);
      setIsMember(found);
    }
  }, [jobNoteMembers, user?.user_id]);

  useEffect(() => {
    if (popupOn || !id) return;
    if (location?.state?.fromReopen || location?.state?.fromEstimate) {
      setOpenEdit(true);
      setRefresh((prev) => !prev);
    }
  }, [location?.state?.fromReopen, location?.state?.fromEstimate, id, popupOn]);

  useEffect(() => {
    if (!id) return;
    const fetchAll = async () => {
      await Promise.all([
        fetchRequestDetails(),
        fetchAllClients(),
        fetchAllServices(),
        fetchMembers(),
        fetchTeamMembersForCollaborators(),
        fetchAllProductsForDesignOrder(),
      ])
    }

    fetchAll()
  }, [id, refresh])

  useEffect(() => {
    if (!allProducts?.length) return
    setProductRows((prev) =>
      prev.map((row) => {
        if (row.entryMode !== 'choose' || !row.catalogProduct) return row
        const cp = row.catalogProduct
        const pid = cp.product_id ?? cp.id
        if (!pid) return row
        const match = allProducts.find((item) => String(item.id) === String(pid))
        if (!match) return row
        return {
          ...row,
          catalogProduct: {
            ...match,
            ...cp,
            expected_material_cost_with_markup:
              cp.expected_material_cost_with_markup ?? match.expected_material_cost_with_markup,
            expected_service_cost_with_markup:
              cp.expected_service_cost_with_markup ?? match.expected_service_cost_with_markup,
            expected_install_labor_cost_with_markup:
              cp.expected_install_labor_cost_with_markup ?? match.expected_install_labor_cost_with_markup,
            install_formula_cost_each:
              cp.install_formula_cost_each != null && cp.install_formula_cost_each !== ''
                ? Number(cp.install_formula_cost_each)
                : Number(
                    cp.expected_install_labor_cost_with_markup ??
                      match.expected_install_labor_cost_with_markup ??
                      0,
                  ),
            expected_formula_price:
              cp.expected_formula_price ?? match.expected_formula_price ?? match.expected_cost,
            sub_contract_price: cp.sub_contract_price ?? match.sub_contract_price,
            sub_contract_markup: cp.sub_contract_markup ?? match.sub_contract_markup,
            inhouse: cp.inhouse ?? match.inhouse,
          },
        }
      }),
    )
  }, [allProducts])

  // Fetch saved form data when entering edit mode
  useEffect(() => {
    if (openEdit && id) {
      fetchSavedDesignFormData();
    } else {
      // Reset form data when exiting edit mode
      setSavedDesignFormData({});
      setEditTab(0);
    }
  }, [openEdit, id])

  // Rebuild product rows when entering edit if fetch populated designOrderProducts but rows stayed empty
  useEffect(() => {
    if (!openEdit || !designOrderProducts?.length) return
    if (productRowsHydratedRef.current) return
    if (!isOnlyEmptyDesignOrderProductRow(productRows)) {
      productRowsHydratedRef.current = true
      return
    }

    const projectCommunity = communities?.find((c) => c.id === details?.community)
    const { mappedRows, productAttachmentsByIndex, indexCounter } =
      buildDesignOrderProductRowsFromApi(
        designOrderProducts,
        loadedProductGroupsRef.current,
        projectCommunity,
      )
    setProductRows(mappedRows)
    setProductIndexCounter(indexCounter)
    setProductAttachments(productAttachmentsByIndex)
    setOpenProductAttachment({})
    setIsUploadingProduct({})
    productRowsHydratedRef.current = true
  }, [openEdit, designOrderProducts, productRows, communities, details?.community])

  useEffect(() => {
    if (!openEdit) {
      productRowsHydratedRef.current = false
    }
  }, [openEdit])

  // Sync collaborators when team members load
  useEffect(() => {
    if (teamMembersOptions && teamMembersOptions.length > 0) {
      const collaboratorsData = details?.collaborators || currentRFQData?.collaborators || '';
      if (collaboratorsData) {
        const collaboratorIds = String(collaboratorsData).split(',').map(id => id.trim()).filter(Boolean);
        const matchedCollaborators = teamMembersOptions.filter(member => collaboratorIds.includes(String(member.id)));
        setCollaborators(matchedCollaborators);
      } else {
        setCollaborators([]);
      }
    }
  }, [teamMembersOptions, details, currentRFQData]);

  useEffect(() => {
    const hasSavedSalesRepIds = details && Object.prototype.hasOwnProperty.call(details, 'sales_rep_ids');
    const initialSalesRepIdRaw = hasSavedSalesRepIds
      ? details.sales_rep_ids
      : (currentRFQData?.sales_rep_ids ?? null);
    const hasSavedSalesRepNames = details && Object.prototype.hasOwnProperty.call(details, 'sales_rep_names');
    const initialSalesRepNameRaw = hasSavedSalesRepNames
      ? (details.sales_rep_names ?? '')
      : (currentRFQData?.sales_rep_names ?? '');

    const parsedInitialSalesRepId = Array.isArray(initialSalesRepIdRaw)
      ? (initialSalesRepIdRaw[0] ?? null)
      : typeof initialSalesRepIdRaw === 'string'
        ? (initialSalesRepIdRaw.split(',').map((v) => v.trim()).filter(Boolean)[0] ?? null)
        : initialSalesRepIdRaw;

    const parsedInitialSalesRepName = Array.isArray(initialSalesRepNameRaw)
      ? (initialSalesRepNameRaw[0] ?? '')
      : typeof initialSalesRepNameRaw === 'string'
        ? (initialSalesRepNameRaw.split(',').map((v) => v.trim()).filter(Boolean)[0] ?? '')
        : (initialSalesRepNameRaw || '');

    setSalesRepId(parsedInitialSalesRepId);
    setSalesRepName(parsedInitialSalesRepName);
  }, [details?.sales_rep_ids, details?.sales_rep_names, currentRFQData?.sales_rep_ids, currentRFQData?.sales_rep_names]);

  const handleSendEmail = async () => {
    try {
      let orderId = details?.id
      const res = await axios.post(`${REST_API}webservice/settings/send-mail`, {
        id: orderId,
      })

      if (res.data.status === 1) {
        enqueueSnackbar('Email send successfully', { variant: 'success' })
        setOpenInvoice(false)
      }
      return res.data
    } catch (error) {
      console.error('Error fetching request details:', error)
      throw error
    }
  }
  const addingInitialdataRFQ = async () => {
    // setLoading(true)
    try {
      if (openEdit) {
        let rfqCustomerData = allClientsEdit?.find(
          (cat) => cat?.id === customerData?.id,
        )
        let rfqCommunity = communities?.find(
          (com) => details?.community === com?.id,
        )
        setCurrentRFQdata({
          name: details?.name,
          description: details?.description,
          notes: details?.notes,
          client: rfqCustomerData,
          start: details?.start_date,
          community: rfqCommunity,
          end: details?.due_date,
          welcome_message: details?.welcome_message == 1 ? true : false || null,
          draft: details?.status == 4 ? true : false || null,
          order_id: invoice?.id,
          subject: details?.subject || null,
          email_content: details?.email_content || null,
          // designer_email_sent: details?.designer_email_sent || 0,
          // designer_sms_sent: details?.designer_sms_sent || 0,
          // avatarUrl:details?.thumbnail||null
          // referenceFiles:details?.thumbnail||null
        })

        // Map the services data
        let result = initialSelectedServices
          .map((val) => {
            // Find the matching service in filteredServices
            let matchedService = filteredServices.find(
              (service) => service.id === val.labour_cost_service_id,
            )

            if (matchedService) {
              // Create a new object with updated quantity and total
              return {
                ...matchedService,
                quantity: val.quantity,
                total: val.total,
                addedByUserType: val.addedByUserType ?? val.added_by_user_type ?? null,
              }
            }
            return null // Return null for unmatched services (optional)
          })
          .filter((item) => item !== null) // Remove any null entries

        // Set the matched and updated services to additionalSelectedServices
        setAdditionalSelectedServices(result)
      }
    } catch (error) {
      console.error('Error adding initial data for Sales Order:', error)
    } finally {
      // setTimeout(() => {
      //   setLoading(false)
      // }, 3000);
    }
  }
  // const handleDesignCount = async () => {
  //   try {
  //     const response = await axios.post(
  //       `${REST_API}webservice/design/reduce-count`,
  //       {
  //         userId,
  //         design_order_id: id,
  //       },
  //     )
  //   } catch (error) {
  //     console.error('Error reducing design order count:', error)
  //   }
  // }
  // useEffect(() => {
  //   handleDesignCount()
  // }, [])

  useEffect(() => {
    if (!openEdit) return
    // setLoading(true)
    addingInitialdataRFQ()
    setTimeout(() => {
      // setLoading(false)
    }, 3000)
  }, [
    openEdit,
    filteredServices,
    initialSelectedServices,
    allClientsEdit,
    communities,
    details,
    customerData,
  ])
  // }, [openEdit])

  const invoiceDate = formatDateOnly(details?.timestamp)

  //edit rfq
  const handleEditClick = () => {
    setOpenEdit(!openEdit)
  }
  const handleDeleteMenu = () => {
    setOpenDelete(!openDelete)
  }
  const handleReopen = () => {
    setReopen(!reOpen)
  }
  const handleOpenReopenDesignOrderDuplicate = () => {
    setOpenReopenDesignOrderDuplicate(!openReopenDesignOrderDuplicate)
  }
  const handleOpenDesignOrderDuplicate = () => {
    setOpenDesignOrderDuplicate(!openDesignOrderDuplicate)
  }

  const roundToThreeDecimals = (num) => Math.round(num * 1000) / 1000

  const mapCatalogProductForSubmit = (p, attachmentsByIndex = {}) => {
    const withMemberMarketing = resolveGroupMemberMarketingForSave(p, markupType)
    const adjusted = getCatalogProductWithAdjustment(withMemberMarketing)
    const price = adjusted.max_price ? adjusted.max_price : (adjusted.actual_retail_price || adjusted.retail_price)
    const installCost = parseFloat(adjusted?.install_cost) || 0

    const formulaCost = (adjusted.inhouse === 0
      ? parseFloat(adjusted?.sub_contract_price) || 0
      : (
        (parseFloat(adjusted?.expected_material_cost_with_markup) || 0) +
        (parseFloat(adjusted?.expected_service_cost_with_markup) || 0)
      )) || parseFloat(adjusted?.expected_formula_price) || parseFloat(adjusted?.expected_cost) || 0

    const productMarkup =
      adjusted.inhouse === 0
        ? ((adjusted?.sub_contract_markup ?? adjusted?.markup) != null &&
          (adjusted?.sub_contract_markup ?? adjusted?.markup) !== ''
          ? Number(adjusted.sub_contract_markup ?? adjusted.markup)
          : 0)
        : null

    const retailPriceEach = Number(adjusted.actual_retail_price || adjusted.retail_price || price || 0)
    const qty = Number(adjusted.quantity) || 1
    const installQty = Number(adjusted.install_quantity) || 1
    const productSubTotal = retailPriceEach * qty
    const installSubTotal = installCost > 0 ? installCost * installQty : 0
    const productTotal = productSubTotal + installSubTotal

    return {
      ...adjusted,
      id: adjusted.id || adjusted.product_id || null,
      product_id: adjusted.product_id || adjusted.id || null,
      expected_formula_price: formulaCost,
      unit_cost: formulaCost,
      markup: productMarkup,
      retail_price: Number(adjusted.retail_price || retailPriceEach),
      actual_retail_price: retailPriceEach,
      price: adjusted.price ?? formulaCost,
      quantity: qty,
      locationQuantity: qty,
      product_sub_total: Number(productSubTotal.toFixed(2)),
      product_total: Number(productTotal.toFixed(2)),
      location: typeof adjusted.location === 'string' ? adjusted.location : JSON.stringify(adjusted.location || [{ address: '', city: '', state: '', zip: '' }]),
      product_notes: adjusted.product_notes || '',
      install_notes: adjusted.install_notes || '',
      install_quantity: installQty,
      install_cost: installCost || null,
      attachments: attachmentsByIndex[adjusted.indexId] || [],
      is_product_row: 0,
      markup_type: markupType,
      product_name: adjusted.name || adjusted.product_name || '',
      product_desc: adjusted.description || adjusted.product_desc || '',
    }
  }

  const buildDesignOrderGroupMarketingPayload = (groups) => ({
    groupProductMarketingData: groups
      ? groups.map((group) => ({
          group_id: group.id,
          group_name: group.name,
          group_description: group.description,
          quantity: group.groupQuantity || 1,
          adj_value_type: group.groupAdjValueType ?? true,
          adjustment: Number(group.groupAdjustment ?? 0),
          total_formula_each: Number((group.totalProductFormulaEach || 0).toFixed(2)),
          total_retail_each: Number((group.totalProductRetailEach || 0).toFixed(2)),
          adjusted_retail_each: Number((group.adjustedGroupRetailEach || 0).toFixed(2)),
          adjusted_subtotal: Number((group.adjustedGroupSubtotal || 0).toFixed(2)),
        }))
      : [],
    groupInstallMarketingData: groups
      ? groups.map((group) => ({
          group_id: group.id,
          group_name: group.name,
          group_description: group.description,
          quantity: group.groupInstallQuantity || 1,
          adj_value_type: group.groupInstallAdjValueType ?? true,
          adjustment: Number(group.groupInstallAdjustment ?? 0),
          total_formula_each: Number((group.totalInstallFormulaEach || 0).toFixed(2)),
          total_retail_each: Number((group.totalInstallRetailEach || 0).toFixed(2)),
          adjusted_retail_each: Number((group.adjustedGroupInstallRetailEach || 0).toFixed(2)),
          adjusted_subtotal: Number((group.adjustedGroupInstallSubtotal || 0).toFixed(2)),
        }))
      : [],
  })

  const getRowsWithCommunityProductLocations = (rows = productRows) =>
    rows.map((row) => {
      if (row.entryMode === 'choose' && row.catalogProduct) {
        return {
          ...row,
          catalogProduct: withCommunityLocationIfMissing(
            row.catalogProduct,
            values?.community,
          ),
        }
      }
      return row
    })

  const buildDesignOrderProductsPayload = (rows = productRows) =>
    getRowsWithCommunityProductLocations(rows)
      .filter((row) => {
        if (row.entryMode === 'choose') {
          return Boolean(row.catalogProduct)
        }
        return String(row.product_name || '').trim() !== ''
      })
      .map((row) => {
        if (row.entryMode === 'choose' && row.catalogProduct) {
          return mapCatalogProductForSubmit(
            {
              ...row.catalogProduct,
              indexId: row.indexId,
              addedByUserType: row.addedByUserType ?? row.catalogProduct?.addedByUserType ?? userTypeOriginal,
            },
            productAttachments,
          )
        }
        return {
          indexId: row.indexId,
          product_name: row.product_name,
          product_desc: row.product_desc,
          product_notes: row.product_notes || '',
          install_notes: row.install_notes || '',
          attachments: productAttachments[row.indexId] || [],
          is_product_row: 1,
          product_id: null,
          catalogId: null,
          addedByUserType: row.addedByUserType ?? userTypeOriginal,
        }
      })

  const calculateServiceTotal = (price, quantity, discount, location = 1) => {
    const parsedQuantity = parseFloat(quantity) || 1
    const parsedDiscount = parseFloat(discount) || 0
    const locationQuantity = parseFloat(location) || 1
    const subtotal = price * parsedQuantity * locationQuantity
    if (discount) {
      const totalDiscount = subtotal - discount
      return totalDiscount
    } else {
      return subtotal
    }
  }

  const mapDesignAttachmentForSubmit = (file) => ({
    extension: file.extension,
    file_type: file.file_type,
    size: file.file_size || file.size,
    url: file.name || file.url,
    added_by: file.added_by || null,
    approved: file.approved || null,
    approved_by: file.approved_by || null,
    status: file.status || 1,
    isChat: file.isChat || 0,
    isDesign: file.isDesign ? file.isDesign : userType === 11 ? 1 : 2,
    isNew: file.isNew ? file.isNew : userType === 11 ? 1 : 2,
    reason: file.reason || null,
  })

  const getSubmitDesignAttachments = () =>
    filterDesignOnlyAttachments([...avatarUrl, ...allAvatarUrl], productAttachments).map(
      mapDesignAttachmentForSubmit,
    )

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: true,
    initialValues: {
      name: currentRFQData.name || '',
      description: currentRFQData.description || '',
      notes: currentRFQData.notes || '',
      clients: currentRFQData.client || null,
      start: toDateOnlyUnix(currentRFQData.start) ?? localTodayDateOnlyUnix(),
      end: toDateOnlyUnix(currentRFQData.end) ?? localTodayDateOnlyUnix(),
      community: currentRFQData?.community || null,
      welcome_message: currentRFQData.welcome_message || false,
      draft: currentRFQData.draft || false,
      client_approve: clientApprove == 0 ? false : true,
      order_id: currentRFQData.order_id || '',
      subject: currentRFQData.subject || '',
      email_content: currentRFQData.email_content || '',
      // designer_email_sent: currentRFQData.designer_email_sent || 0,
      // designer_sms_sent: currentRFQData.designer_sms_sent || 0,
      editReq: true,
      quantityFieldName: null,
      split_catalog_type: splitOrderCatalogTypes.find((type) => type.id === 'all'),
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        values.name = orderTextFields.name || ''
        values.description = orderTextFields.description || ''
        values.notes = orderTextFields.notes || ''

        if ((userType === 3 || isClient) && !isClientEdited && details?.send_client_app_req == 1) {
          const hasFieldChanges =
            values.name !== currentRFQData.name ||
            values.description !== currentRFQData.description ||
            values.notes !== currentRFQData.notes ||
            values.start !== currentRFQData.start ||
            values.end !== currentRFQData.end ||
            values.community?.id !== currentRFQData?.community?.id;

          const currentFileUrls = filterDesignOnlyAttachments(avatarUrl, productAttachments).map(
            (f) => f.name || f.url,
          )
          const hasFileChanges =
            currentFileUrls?.length !== initialAvatarUrls?.length ||
            !currentFileUrls?.every((url) => initialAvatarUrls?.includes(url));
          const currentFileUrlsReference = referenceFiles?.map((f) => f.name || f.url);
          const hasReferenceFileChanges =
            currentFileUrlsReference?.length !== initialReferenceUrls?.length ||
            !currentFileUrlsReference?.every((url) => initialReferenceUrls?.includes(url));
            console.log('initialAvatarUrls', initialAvatarUrls)
            console.log('initialReferenceUrls', initialReferenceUrls)
            console.log('currentFileUrls', currentFileUrls)
            console.log('currentFileUrlsReference', currentFileUrlsReference)
            console.log('hasFileChanges', hasFileChanges)
            console.log('hasReferenceFileChanges', hasReferenceFileChanges)
            console.log('hasFieldChanges', hasFieldChanges)

          if (hasFieldChanges || hasFileChanges || hasReferenceFileChanges) {
            setShowApprovalPopup(true);
            setSubmitting(false);
            return; // Stop submission
          }
        }
        const productRowsWithLocations = getRowsWithCommunityProductLocations()
        setProductRows(productRowsWithLocations)
        let errors = {}
        productRowsWithLocations.forEach((row) => {
          if (row.entryMode === 'choose') {
            if (!row.catalogProduct) {
              errors[row.indexId] = 'Please select a catalog product'
            }
          } else if (!row.product_name.trim() && row.product_desc.trim()) {
            errors[row.indexId] = 'Product name is required when description is provided'
          }
        })
        if (Object.keys(errors).length > 0) {
          setRowErrors(errors)
          enqueueSnackbar('Please fill in all required product names if a description is provided.', { variant: 'error' })
          return
        }
        if (additionalSelectedServices?.length <= 0 && (userType !== 3 && !isClient)) {
          enqueueSnackbar('Please choose atleast one service', {
            variant: 'error',
          })
          return
        }
        if (designers?.length <= 0 &&( userType !== 3 && !isClient)) {
          enqueueSnackbar('Please choose atleast one designer', {
            variant: 'error',
          })
          return
        }
        setIsSubmitted(true)
        const design_order_id = id
        // Save Order always saves as New (status 1), never as Draft - only "Save as Draft" button sets draft
        values.draft = false
        const clientsArray = values.clients ? [values.clients] : []
        values.clientsData = clientsArray
        values.userName = user.first_name
        values.avatarUrl = getSubmitDesignAttachments()
        values.referenceFiles = referenceFiles?.map((file) => ({
          
          extension: file.extension,
          file_type: file.file_type,
          size: file.file_size || file.size,
          url: file.name || file.url,

          added_by: file.added_by || null,
          approved: file.approved || null,
          approved_by: file.approved_by || null,
          status: file.status || 1,
          isChat: file.isChat || 0,
          isDesign: file.isDesign ? file.isDesign : userType === 11 ? 1 : 2 ,
          isNew: file.isNew ? file.isNew : userType === 11 ? 1 : 2 ,
          reason: file.reason || null,
        }))
        values.markup_type = markupType
        values.products = buildDesignOrderProductsPayload(productRowsWithLocations)
        values.productRows = values.products.filter((p) => p.is_product_row === 1)

        let selectedServicesTotalCost = additionalSelectedServices?.reduce(
          (total, service, index) => {
            const serviceTotal = calculateServiceTotal(
              service?.total_cost,
              service?.quantity,
              0,
              1,
            )
            // return total + Number(service?.total);
            return total + Number(serviceTotal)
          },
          0,
        )
        selectedServicesTotalCost = roundToThreeDecimals(
          selectedServicesTotalCost,
        )

        const data = {
          values,
          isClientEdited,
          userId,
          userType,
          design_order_id,
          salesRepName,
          salesRepId,
          selectedServices: additionalSelectedServices,
          totalCost: selectedServicesTotalCost,
          designers: designers,
          collaborators: Array.isArray(collaborators) ? collaborators.map((c) => (typeof c === 'object' && c?.id != null ? c.id : c)).filter(Boolean).join(',') : (collaborators || ''),
          isClient:isClient,
          ...buildDesignOrderGroupMarketingPayload(groupedProducts),
        }
        setFormValues(values)
        setFormDatas(data)
        handleConfirmSubmit(values, data)
      } catch (error) {
        console.error(error)
      }
    },
  })

  const handleConfirmSubmit = async (values = null, data = null) => {
    setIsSubmitting(true)
    try {
      const formValuesData = values || formValues
      const formDatasData = data || formDatas
      console.log('Form Values:', formValuesData)
      console.log('Form Data:', formDatasData)
      
      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const requestData = {
        ...formDatasData,
        socketId: null // Will be set by the progress modal
      };

      setProgressHeading(formValuesData?.draft ? "Saving Design Order" : "Updating Design Order");
      setProgressRequestData(requestData);
      setShowProgressModal(true);
      
      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }
      
      await axios
        .post(`${REST_API}webservice/design/update-design-order`, requestData)
        .then(async (res) => {
          // Save design forms if any form data exists - using batch save API (single call)
          if (id && savedDesignFormData && Object.keys(savedDesignFormData).length > 0) {
            try {
              // Normalize form data - convert objects to strings for backend compatibility
              // This prevents [object Object] from being saved to the database
              const normalizeFormData = (formData) => {
                const normalized = { ...formData }
                Object.keys(normalized).forEach(key => {
                  const field = normalized[key]
                  
                  // Remove checkboxgroup key to prevent duplicate saves (checkbox values are stored in field-specific arrays)
                  if (key === 'checkboxgroup') {
                    delete normalized[key]
                    return
                  }
                  
                  // For checkbox groups (arrays), remove duplicates based on field_id and value
                  if (Array.isArray(field) && field.length > 0) {
                    const seen = new Set()
                    const uniqueArray = field.filter(item => {
                      if (!item || typeof item !== 'object') return false
                      const key = `${item.field_id}_${item.value}`
                      if (seen.has(key)) {
                        return false // Duplicate, filter it out
                      }
                      seen.add(key)
                      return true
                    })
                    normalized[key] = uniqueArray
                    return // Skip further processing for checkbox arrays
                  }
                  
                  // Handle object fields (text, textarea, number, select, autocomplete, date, etc.)
                  if (field && typeof field === 'object' && !Array.isArray(field)) {
                    if (field.content === 'autocomplete') {
                      // Convert autocomplete object to string (label) for backend
                      if (typeof field.value === 'object' && field.value !== null) {
                        normalized[key] = {
                          ...field,
                          value: field.value.label || field.value.value || ''
                        }
                      }
                    } else if (field.value !== undefined) {
                      // For other field types, ensure value is a string (not an object)
                      // This prevents [object Object] from being saved
                      if (typeof field.value === 'object' && field.value !== null && !Array.isArray(field.value)) {
                        // If value is an object, try to extract a string value
                        const stringValue = field.value?.label || field.value?.value || String(field.value) || ''
                        normalized[key] = {
                          ...field,
                          value: stringValue
                        }
                      } else if (field.value !== null && field.value !== undefined) {
                        // Ensure value is converted to string for text/textarea/number/select fields
                        normalized[key] = {
                          ...field,
                          value: String(field.value)
                        }
                      }
                    }
                  }
                })
                return normalized
              }

              // Prepare forms array for batch save with normalized data
              const forms = Object.entries(savedDesignFormData)
                .filter(([templateId, submitForm]) => submitForm && Object.keys(submitForm).length > 0)
                .map(([templateId, submitForm]) => ({
                  id: templateId,
                  submitForm: normalizeFormData(submitForm)
                }))

              if (forms.length > 0) {
                // Use deleteExisting: true to delete old submissions before saving new ones
                // This ensures clean updates when fields/options are added or edited
                await axios.post(`${REST_API_END_POINT}design-form/batch-save-templates`, {
                  forms,
                  design_order_id: id,
                  status: 1,
                  userId,
                  deleteExisting: true // Delete existing submissions before saving (prevents duplicates and handles field/option changes)
                })
                console.log(`Successfully saved ${forms.length} design form(s) in one API call`)
              }
            } catch (error) {
              console.error('Error saving design forms:', error)
              enqueueSnackbar('Order updated, but some form changes may not have been saved', { variant: 'warning' })
            }
          }
          
          setOpenEdit(false)
          setIsOpen(false)
          setCurrentRFQdata({})
          setAutoUpdateData({ 
            type: 'design_order_updated', 
            orderName: formValuesData.name,
            timestamp: Date.now()
          });
          setShowProgressModal(false);
          fetchRequestDetails()
          if (currentTab === 'Job Log') { handleJobLogUpdates() }
          if (edit) {
            if(popupOn){
              closeView()
              setRenderCardsValue(!renderCardsValue)
            }else{
              navigate(`/dashboard/design-order/order`)
            }
          }
          enqueueSnackbar('Update success', { variant: 'success' })
          formik.resetForm()
          setDesigners([])
          setAdditionalSelectedServices([])
          setSavedDesignFormData({})
          // resetForm();
        })
        .catch((errors) => {
          console.log(errors, 'error')
          enqueueSnackbar('Error updating design order', { variant: 'error' })
          setShowProgressModal(false);
        })
    } catch (error) {
      console.error('Error submitting form:', error)
      enqueueSnackbar('An error occurred during submission.', {
        variant: 'error',
      })
    } finally {
      setIsSubmitting(false)
      setFormValues({})
      setFormDatas({})
      setDesigners([])
      setTimeout(() => {
        setShowProgressModal(false)
      }, 100);
    }
  }

  const current = moment()

  const handleAcceptorRejectInvoice = async (value) => {
    try {
      if (value === 2 && reason === '') {
        enqueueSnackbar('Please fill rejected reason ', { variant: 'warning' })
        return
      }
      if (value === 2 && !rejectTypeId) {
        enqueueSnackbar('Please select reject type', { variant: 'warning' })
        return
      } else {
        let design_order_id = id
        let acceptStatus = value

        let newStatus = value == 1 ? 2 : 6
        const data = {
          design_order_id,
          acceptStatus,
          newStatus,
          userId,
          userType,
          reason,
          rejectType: rejectTypeId,
          requestedDueDate: requestedDueDate || null,
          rejectFiles
        }
        const res = await axios.post(
          `${REST_API}webservice/design/accept-or-reject-order`,
          data,
        )

        if (res.data.status == 1) {
          // setOpenInvoice(!openInvoice)
          setOpenInvoice(false)
          setConfirmInvoice(false)
          setRejectInvoice(false)
          enqueueSnackbar('Order Approved', { variant: 'success' })
          fetchRequestDetails()
          if (currentTab === 'Job Log') { handleJobLogUpdates() }
        } else if (res.data.status == 2) {
          setOpenInvoice(!openInvoice)
          setConfirmInvoice(false)
          setRejectInvoice(false)
          enqueueSnackbar('Order Rejected', { variant: 'error' })
          setReason('')
          setRejectTypeId('')
          setRequestedDueDate(null)
          if(popupOn){
            closeView()
            setRenderCardsValue(!renderCardsValue)
          }else{
            navigate(PATH_DASHBOARD.design.root)
          }
        } else {
          setOpenInvoice(!openInvoice)
          setConfirmInvoice(false)
          setRejectInvoice(false)
          enqueueSnackbar(res.data.message, { variant: 'error' })
        }
      }
    } catch (error) {
      console.log(error, 'error in accepting invoice')
      setConfirmInvoice(false)
      setRejectInvoice(false)
      enqueueSnackbar('Server Error', { variant: 'error' })
    }
  }

  const handleConvertToSalesOrder = async (existingJob = false) => {
    try {
      setOpenConvertToSalesOrder(false)
      setConvertToRFQ(true)
      let design_order_id = id
      let userName = user.first_name

      const data = {
        design_order_id,
        userId,
        userType,
        userName,
        salesOrder: true,
        isDesignOrder: true,
        socketId: null // Will be set by the progress modal
      }

      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      setProgressHeading("Converting Design Order to Sales Order");
      setProgressRequestData(data);
      setShowProgressModal(true);
      
      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }

      const res = await axios.post(
        `${REST_API}webservice/design/convert-design-to-sales-order`,
        data,
      )

      if (res.data.request_id) {
        const id = res.data.request_id
        if(popupOn){
          closeView()
        }
        setConfirmInvoice(false)
        setRejectInvoice(false)
        setShowProgressModal(false);
        enqueueSnackbar('Order converted to Sales Order successfully', {
          variant: 'success',
        })
        sessionStorage.setItem(`salesOrderSkipRibbonDismiss_${id}`, '1')
        navigate(`/dashboard/official-request/view/${id}`, { state: true })
      } else {
        setConfirmInvoice(false)
        setRejectInvoice(false)
        setShowProgressModal(false);
        enqueueSnackbar('Failed to convert Design to Sales Order', {
          variant: 'error',
        })
      }
    } catch (error) {
      console.log(error, 'error in Converting Design to Sales Order')
      setConfirmInvoice(false)
      setRejectInvoice(false)
      enqueueSnackbar('Server Error', { variant: 'error' })
    } finally {
      setConvertToRFQ(false)
      setShowProgressModal(false)
    }
  }

  const handleConvertToSplitEstimate = async (existingJob = false) => {
    try {
      setOpenConvertToSplitEstimate(false)
      setConvertToSplitEstimate(true)
      let design_order_id = id
      let userName = user.first_name

      const data = {
        design_order_id,
        userId,
        userType,
        userName,
        socketId: null, // Will be set by the progress modal
        currentFacilityId: currentFacilityId,
      }

      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      setProgressHeading("Converting Design Order to Split Estimate");
      setProgressRequestData(data);
      setShowProgressModal(true);
      
      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }

      const res = await axios.post(
        `${REST_API}webservice/design/convert-design-to-split-estimate`,
        data,
      )

      if (res?.data?.split_estimate_id) {
        const splitEstimateId = res.data.split_estimate_id
        setConfirmInvoice(false)
        setRejectInvoice(false)
        enqueueSnackbar('Order converted to Split Estimate successfully', {
          variant: 'success',
        })
        setShowProgressModal(false);
        navigate(`/dashboard/quick-bid/view-split-estimate/${splitEstimateId}`, { state: true })
      } else {
        setConfirmInvoice(false)
        setRejectInvoice(false)
        setShowProgressModal(false);
        enqueueSnackbar('Failed to convert Design to Split Estimate', {
          variant: 'error',
        })
      }
    } catch (error) {
      console.log(error, 'error in Converting Design to Split Estimate')
      setConfirmInvoice(false)
      setRejectInvoice(false)
      enqueueSnackbar('Server Error', { variant: 'error' })
    } finally {
      setConvertToSplitEstimate(false)
      setShowProgressModal(false)
    }
  }

  const handleConvertToEstimate = async (existingJob = false) => {
    try {
      setOpenConvertToEstimate(false)
      setConvertToRFQ(true)
      let design_order_id = id
      let userName = user.first_name

      const data = {
        design_order_id,
        userId,
        userType,
        userName,
        salesOrder: null,
        isDesignOrder: true,
        socketId: null // Will be set by the progress modal
      }

      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      setProgressHeading("Converting Design Order to Estimate");
      setProgressRequestData(data);
      setShowProgressModal(true);
      
      // Only wait briefly if socket is not ready yet (was a fixed 2–3s delay before)
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 400));
      }

      const res = await axios.post(
        `${REST_API}webservice/design/convert-design-to-sales-order`,
        data,
      )

      if (res.data.request_id) {
        const id = res.data.request_id
        if(popupOn){
          closeView()
        }
        setConfirmInvoice(false)
        setRejectInvoice(false)
        enqueueSnackbar('Order converted to Estimate successfully', {
          variant: 'success',
        })
        navigate(`/dashboard/quick-bid/view/${id}`, { state: { fromDesignConvert: true } })
      } else {
        setConfirmInvoice(false)
        setRejectInvoice(false)
        enqueueSnackbar('Failed to convert Design to Estimate', {
          variant: 'error',
        })
      }
    } catch (error) {
      console.log(error, 'error in Converting Design to Estimate')
      setConfirmInvoice(false)
      setRejectInvoice(false)
      setShowProgressModal(false);
      enqueueSnackbar('Server Error', { variant: 'error' })
    } finally {
      setConvertToRFQ(false)
      setShowProgressModal(false)
    }
  }

  const handleConvertToEstimateRequest = async (existingJob = false) => {
    try {
      setOpenConvertToEstimateRequest(false)
      setConvertToRFQ(true)
      let design_order_id = id
      let userName = user.first_name

      const data = {
        design_order_id,
        userId,
        userType,
        userName,
        salesOrder: null,
        isDesignOrder: true,
        socketId: null // Will be set by the progress modal
      }

      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      setProgressHeading("Converting Design Order to Estimate Request");
      setProgressRequestData(data);
      setShowProgressModal(true);
      
      // Only wait briefly if socket is not ready yet (was a fixed 2–3s delay before)
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 400));
      }

      const res = await axios.post(
        `${REST_API}webservice/design/convert-design-to-request-estimate`,
        data,
      )

      if (res.data.request_id) {
        const requestId = res.data.request_id
        const partnerId = res?.data?.partner_id
        setConfirmInvoice(false)
        setRejectInvoice(false)
        enqueueSnackbar('Order converted to Estimate successfully', {
          variant: 'success',
        })
        if (userType != 3) {
            await handleConvertToJob(requestId, partnerId)
          
        }
        // navigate(`/dashboard/quick-bid/view/${id}`, { state: true })
      } else {
        setConfirmInvoice(false)
        setRejectInvoice(false)
        enqueueSnackbar('Failed to convert Design to Estimate', {
          variant: 'error',
        })
      }
    } catch (error) {
      console.log(error, 'error in Converting Design to Estimate')
      setConfirmInvoice(false)
      setRejectInvoice(false)
      enqueueSnackbar('Server Error', { variant: 'error' })
    } finally {
      setConvertToRFQ(false)
      setShowProgressModal(false)
    }
  }

  const handleConvertToJob = async (reqId, partnerId) => {
    try {
      let requestId = reqId
      let requestPartnerId = partnerId

      const data = { requestId, userId, requestPartnerId }
      const res = await axios.post(`${REST_API}webservice/request/create-or-update-estimate-job`, data);

      if (res.data.status == 1) {
        enqueueSnackbar('Estimate Job created successfully', { variant: 'success' });
        // navigate(`/dashboard/quick-bid/estimate`)
        navigate(`/dashboard/quick-bid/view/${requestId}`, { state: { fromDesignConvert: true } })
      } else {
        enqueueSnackbar('Failed to create estimate job', { variant: 'error' });
      }
    } catch (error) {
      console.log(error, 'error in creating estimate job')
      enqueueSnackbar('Failed to create estimate job', { variant: 'error' });
    }
  }

  const handleReopeningRequest = async () => {
    try {
      let requestId = id

      const data = { requestId, userId }
      const res = await axios.post(`${REST_API}webservice/request/reopen`, data)
      if (res.data.status == 1) {
        enqueueSnackbar('Request reopened successfully', { variant: 'success' })
        setReopen(false)
        fetchRequestDetails()
      } else if (res.data.status == 0) {
        enqueueSnackbar('Request reopened failed', { variant: 'error' })
        setReopen(false)
      }
    } catch (error) {
      console.log(error, 'Error in reopen')
    }
  }

  const handleReopenDesignOrder = async () => {
    try {
      setIsDuplicatingDesignOrder(true)
      const res = await axios.post(`${REST_API}webservice/design/reopen-design-order`, {
        design_order_id: id,
        userId,
      })

      if (res?.data?.status === 1) {
        enqueueSnackbar('Design order reopened successfully', { variant: 'success' })
        setOpenReopenDesignOrderDuplicate(false)
        if (closeView) {
          closeView()
          setRenderCardsValue(!renderCardsValue)
          navigate(`/dashboard/design-order/view/${id}`, { state: { fromReopen: true } })
        } else {
          setOpenEdit(true)
          setRefresh((prev) => !prev)
          navigate(`/dashboard/design-order/view/${id}`, { replace: true, state: { fromReopen: true } })
        }
      } else {
        enqueueSnackbar(res?.data?.message || 'Failed to reopen design order', { variant: 'error' })
      }
    } catch (error) {
      console.log(error, 'Error in duplicating completed design order')
      enqueueSnackbar('Server Error', { variant: 'error' })
    } finally {
      setIsDuplicatingDesignOrder(false)
    }
  }

  // duplicate designorder function 
  const handleDuplicateDesignOrder = async () => {
    try {
      setIsDuplicatingDesignOrder(true)
      const res = await axios.post(`${REST_API}webservice/design/duplicate-design-order`, {
        design_order_id: id,
        userId,
      })

      if (res?.data?.status === 1 && res?.data?.data?.id) {
        enqueueSnackbar('Design order duplicated successfully', { variant: 'success' })
      setOpenDesignOrderDuplicate(false)
        if (closeView) { 
          closeView()
          setRenderCardsValue(!renderCardsValue)
        }
        // navigate(`/dashboard/design-order/view/${res.data.data.id}`, { state: { fromReopen: true } })
      } else {
        enqueueSnackbar(res?.data?.message || 'Failed to duplicate design order', { variant: 'error' })
      }
    } catch (error) {
      console.log(error, 'Error in duplicating  design order')
      enqueueSnackbar('Server Error', { variant: 'error' })
    } finally {
      setIsDuplicatingDesignOrder(false)
    }
  }
  const handleMergeToSalesOrder = async () => {
    try {
      setOpenMergeToSalesOrder(false)
      const res = await axios.post(
        `${REST_API}webservice/design/merge-duplicated-design-to-sales-order`,
        {
          duplicated_design_order_id: id,
          userId,
        },
      )

      if (res?.data?.status === 1 && res?.data?.request_id) {
        enqueueSnackbar('Merged to Sales Order successfully', { variant: 'success' })
        navigate(`/dashboard/official-request/view/${res.data.request_id}`, { state: true })
      } else {
        enqueueSnackbar(res?.data?.message || 'Failed to merge to Sales Order', {
          variant: 'error',
        })
      }
    } catch (error) {
      console.log(error, 'error in merge to sales order')
      enqueueSnackbar('Server Error', { variant: 'error' })
    }
  }

  const handleMergeToEstimate = async () => {
    try {
      setOpenMergeToEstimate(false)
      const res = await axios.post(
        `${REST_API}webservice/design/merge-duplicated-design-to-sales-order`,
        {
          duplicated_design_order_id: id,
          userId,
        },
      )

      if (res?.data?.status === 1 && res?.data?.request_id) {
        enqueueSnackbar('Merged to Estimate successfully', { variant: 'success' })
        navigate(`/dashboard/quick-bid/view/${res.data.request_id}`, { state: true })
      } else {
        enqueueSnackbar(res?.data?.message || 'Failed to merge to Estimate', {
          variant: 'error',
        })
      }
    } catch (error) {
      console.log(error, 'error in merge to estimate')
      enqueueSnackbar('Server Error', { variant: 'error' })
    }
  }

  const handleMergeToRequestEstimate = async () => {
    try {
      setOpenMergeToRequestEstimate(false)
      const res = await axios.post(
        `${REST_API}webservice/design/merge-duplicated-design-to-request-estimate`,
        {
          duplicated_design_order_id: id,
          userId,
        },
      )

      if (res?.data?.status === 1 && res?.data?.request_id) {
        enqueueSnackbar('Merged to Request Estimate successfully', { variant: 'success' })
        navigate(`/dashboard/quick-bid/view/${res.data.request_id}`, { state: true })
      } else {
        enqueueSnackbar(res?.data?.message || 'Failed to merge to Request Estimate', {
          variant: 'error',
        })
      }
    } catch (error) {
      console.log(error, 'error in merge to request estimate')
      enqueueSnackbar('Server Error', { variant: 'error' })
    }
  }

  const {
    errors,
    values,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
  } = formik

  const filteredProducts = useMemo(() => {
    return (allProducts || []).filter((option) => {
      const catalogType = values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')
      if (catalogType.id === 'all') return true
      switch (catalogType.id) {
        case 'in_stock': return option.inhouse === 4
        case 'client_owned': return option.inhouse === 5
        case 'traffic': return option.isTrafficCatalog == 1
        case 'production_catalog': return option.inhouse === 1 && option.isTrafficCatalog !== 1
        case 'split_catalog': return option.inhouse === 6
        case 'estimate_catalog': return option.inhouse === 7
        case 'sub_contract': return option.inhouse === 0
        default: return false
      }
    }).sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
  }, [allProducts, values.split_catalog_type])

  useEffect(() => {
    setOrderTextFields({
      name: currentRFQData?.name || '',
      description: currentRFQData?.description || '',
      notes: currentRFQData?.notes || '',
    })
    setOrderTextFieldErrors({})
  }, [currentRFQData])

  const handleFormSubmit = async (e) => {
    e.preventDefault()
    const textErrs = {}
    if (!orderTextFields.name?.trim()) {
      textErrs.name = 'Name is required.'
    }
    if (!orderTextFields.description?.trim()) {
      textErrs.description = 'Description is required.'
    }
    setOrderTextFieldErrors(textErrs)
    if (Object.keys(textErrs).length > 0) {
      enqueueSnackbar('Please fill all required fields in the form', {
        variant: 'error',
      })
      return
    }
    handleSubmit(e)
  }

  // const collaboratorOptions = useMemo(() => {
  //   const availableTeamMembers = Array.isArray(teamMembersOptions) ? teamMembersOptions : [];
  //   let filteredMembers = availableTeamMembers;
  //   const communitySalesRepIds = getCommunitySalesRepIds(values.community);

  //   if (values.community && communitySalesRepIds.length > 0) {
  //     const allowedIds = new Set(communitySalesRepIds.map((id) => String(id)));
  //     filteredMembers = availableTeamMembers.filter((member) => {
  //       const memberId = member?.id ?? member?.user_id;
  //       return memberId != null && allowedIds.has(String(memberId));
  //     });
  //   }

  //   if (collaborators?.length) {
  //     const filteredIds = new Set(
  //       filteredMembers.map((member) => String(member?.id ?? member?.user_id))
  //     );
  //     const missingSelections = collaborators.filter((member) => {
  //       const memberId = member?.id ?? member?.user_id;
  //       return memberId != null && !filteredIds.has(String(memberId));
  //     });
  //     if (missingSelections.length) {
  //       filteredMembers = [...filteredMembers, ...missingSelections];
  //     }
  //   }

  //   return filteredMembers;
  // }, [teamMembersOptions, values.community, collaborators]);

  const collaboratorOptions = useMemo(() => {
    const availableTeamMembers = Array.isArray(teamMembersOptions)
      ? teamMembersOptions
      : [];
  
    let filteredMembers = [...availableTeamMembers];
  
    // Keep already-selected collaborators even if they are not
    // currently present in teamMembersOptions.
    if (collaborators?.length) {
      const availableMemberIds = new Set(
        filteredMembers
          .map((member) => member?.id ?? member?.user_id)
          .filter((id) => id != null)
          .map(String)
      );
  
      const missingSelections = collaborators.filter((member) => {
        const memberId = member?.id ?? member?.user_id;
  
        return (
          memberId != null &&
          !availableMemberIds.has(String(memberId))
        );
      });
  
      if (missingSelections.length) {
        filteredMembers = [...filteredMembers, ...missingSelections];
      }
    }
  
    return filteredMembers;
  }, [teamMembersOptions, collaborators]);

  useEffect(() => {
    const repOptions = getSalesRepOptionsFromCommunity(values.community);
    setSalesRepOptions(repOptions);

    if (!repOptions.length) {
      setSalesRepName('');
      setSalesRepId(null);
      return;
    }

    const hasSelectedRep = repOptions.some((option) => {
      if (salesRepId != null && option?.id != null) {
        return String(option.id) === String(salesRepId);
      }
      return salesRepName && option?.name === salesRepName;
    });

    if (hasSelectedRep) {
      return;
    }

    // Prefer the order's saved sales rep. Do not fall back to community default
    // when details already has a sales_rep_ids value (effect race on hydrate used
    // to overwrite a non-default rep after estimate ↔ design convert).
    if (!isOrderSalesRepEmpty(details?.sales_rep_ids)) {
      const raw = details.sales_rep_ids;
      const savedId = Array.isArray(raw)
        ? (raw.filter(Boolean)[0] ?? null)
        : typeof raw === 'string'
          ? (raw.split(',').map((v) => v.trim()).filter(Boolean)[0] ?? null)
          : raw;
      const matched = repOptions.find(
        (opt) =>
          savedId != null &&
          opt?.id != null &&
          String(opt.id) === String(savedId),
      );
      if (matched) {
        setSalesRepName(matched.name || '');
        setSalesRepId(matched.id ?? null);
      }
      return;
    }

    setSalesRepName(repOptions[0]?.name || '');
    setSalesRepId(repOptions[0]?.id || null);
  }, [values.community, teamMembersOptions, details?.sales_rep_ids]);

  const setValuesToPreview = () => {
    const formattedDescription = (orderTextFields.description || '').replace(/\r?\n/g, '\n');
    const formattedNotes = (orderTextFields.notes || '').replace(/\r?\n/g, '\n');
    
    setPreviewData({
      ...values,
      name: orderTextFields.name,
      description: formattedDescription,
      notes: formattedNotes,
      description_lines: formattedDescription ? formattedDescription.split('\n') : [],
      notes_lines: formattedNotes ? formattedNotes.split('\n') : [],
    })
  }

  const handleRemoveAll = () => {
    const removed = [...avatarUrl]
    setAvatarUrl([])
    if (removed.length === 0) return
    setProductAttachments((prev) =>
      removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev),
    )
  }

  const handleRemove = (file) => {
    if (file?._productAttachment && file?.product_index_id != null && String(file.product_index_id) !== '') {
      handleProductRemove(file, file.product_index_id)
      return
    }

    setAvatarUrl((prev) => prev.filter((f) => !attachmentMatches(f, file)))
    setProductAttachments((prev) => pruneAttachmentMapsByFile(prev, file))
  }

  const handleRemoveAllReference = () => {
    setReferenceFiles([])
  }

  const handleRemoveReference = (file) => {
    const filteredItems = referenceFiles.filter((_file) => _file !== file)
    if (filteredItems) {
      setReferenceFiles(filteredItems)
    } else {
      setReferenceFiles([])
    }
  }

  ///////
  // const handleDrop = useCallback(
  //   (acceptedFiles) => {
  //     if (acceptedFiles && acceptedFiles.length > 0) {
  //       const file = acceptedFiles[0]
  //       const Filename = new Date().getTime() + file.name

  //       const StorageRef = imageref(storage, Filename)
  //       const uploadTask = uploadBytesResumable(StorageRef, file)

  //       uploadTask.on(
  //         'state_changed',
  //         (snapshot) => {
  //           const progress = Math.round(
  //             (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
  //           )
  //         },
  //         (error) => {
  //           console.error(error.message)
  //         },
  //         () => {
  //           getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //             setFieldValue('avatarUrl', downloadURL)
  //           })
  //         },
  //       )
  //     }
  //   },
  //   [setFieldValue],
  // )

  const handleDrop = useCallback(
    async (acceptedFiles) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return;

      setIsUploading(true);

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now();
          // This removes all #, %, &, + and other dangerous URL characters
const sanitizedName = file.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');;
          const fileName = `${timestamp}_${sanitizedName}`;
          const filePath = `design-order/designs/${fileName}`;   // 🔑 folder path

          // ---------- 1. Upload ----------
          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')                           // your bucket
            .upload(filePath, file);

          if (uploadError) throw uploadError;

          // Optionally flag progress done for this file
          setProgress(100);

          // ---------- 2. Public URL ----------
          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }

          // ---------- 3. Return metadata ----------
          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
          };
        });

        const uploadedFiles = await Promise.all(uploadPromises);

        setAvatarUrl((prev) => [...prev, ...uploadedFiles]);
      } catch (err) {
        console.error('Upload error:', err.message);
        enqueueSnackbar('Upload failed: ' + err.message, { variant: 'error' });
      } finally {
        setIsUploading(false);
        setProgress(null);   // clear progress bar
      }
    },
    [setAvatarUrl, setIsUploading, setProgress]
  ); // supabase integration

  const handleDropReference = useCallback(
    async (acceptedFiles) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return;

      setIsUploadingReference(true);

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now();
          // This removes all #, %, &, + and other dangerous URL characters
const sanitizedName = file.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');;
          const fileName = `${timestamp}_${sanitizedName}`;
          const filePath = `design-order/references/${fileName}`;   // 🔑 folder path

          // ---------- 1. Upload ----------
          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')                           // your bucket
            .upload(filePath, file);

          if (uploadError) throw uploadError;

          // Optionally flag progress done for this file
          setProgress(100);

          // ---------- 2. Public URL ----------
          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }

          // ---------- 3. Return metadata ----------
          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
          };
        });

        const uploadedFiles = await Promise.all(uploadPromises);

        setReferenceFiles((prev) => [...prev, ...uploadedFiles]);
      } catch (err) {
        console.error('Upload error:', err.message);
        enqueueSnackbar('Upload failed: ' + err.message, { variant: 'error' });
      } finally {
        setIsUploadingReference(false);
        setProgress(null);   // clear progress bar
      }
    },
    [setReferenceFiles, setIsUploadingReference, setProgress]
  );

  // const handleDrop = useCallback(
  //   (acceptedFiles) => {
  //     if (acceptedFiles && acceptedFiles.length > 0) {
  //       setIsUploading(true)
  //       const uploadPromises = acceptedFiles?.map((file) => {
  //         return new Promise((resolve, reject) => {
  //           const Filename = new Date().getTime() + file.name
  //           const StorageRef = imageref(storage, Filename)
  //           const uploadTask = uploadBytesResumable(StorageRef, file)

  //           uploadTask.on(
  //             'state_changed',
  //             (snapshot) => {
  //               const progress = Math.round(
  //                 (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
  //               )
  //               setProgress(progress)
  //             },
  //             (error) => {
  //               console.error(error.message)
  //               setIsUploading(false)
  //               reject(error)
  //             },
  //             () => {
  //               getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //                 resolve({
  //                   url: downloadURL,
  //                   file_type: file.type,
  //                   extension: file.name.split('.').pop(),
  //                   size: file.size,
  //                 })
  //               })
  //             },
  //           )
  //         })
  //       })

  //       Promise.all(uploadPromises)
  //         .then((downloadURLs) => {
  //           setAvatarUrl((prevAvatarUrls) => {
  //             const updatedFiles = downloadURLs.map((file) => ({
  //               url: file.url,
  //               file_type: file.file_type,
  //               extension: file.extension,
  //               size: file.size,
  //             }))
  //             return [...prevAvatarUrls, ...updatedFiles]
  //           })
  //           setIsUploading(false)
  //         })
  //         .catch((error) => {
  //           console.error(error.message)
  //           setIsUploading(false)
  //         })
  //     }
  //   },
  //   [setFieldValue],
  // )

  const handleRejectFileDrop = useCallback(
    async (acceptedFiles) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return;
  
      setIsUploadingRejectFile(true);
      setProgress(0);
  
      try {
        const uploadedFiles = [];
        const totalFiles = acceptedFiles.length;
        let completed = 0;
  
        for (const file of acceptedFiles) {
          const timestamp = Date.now();
          // This removes all #, %, &, + and other dangerous URL characters
const sanitizedName = file.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');;
          const fileName = `${timestamp}_${sanitizedName}`;
          const filePath = `design-order/rejected/${fileName}`;
  
          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);
  
          if (uploadError) throw uploadError;
  
          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);
  
          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }
  
          uploadedFiles.push({
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
            original_name: file.name
          });
  
          completed += 1;
          setProgress(Math.round((completed / totalFiles) * 100));
        }
  
        setRejectFiles((prev) => [...prev, ...uploadedFiles]);
  
      } catch (err) {
        console.error('Upload error:', err.message);
        enqueueSnackbar('Upload failed: ' + err.message, { variant: 'error' });
      } finally {
        setIsUploadingRejectFile(false);
        setProgress(null);
      }
    },
    [setRejectFiles, setIsUploadingRejectFile, setProgress]
  );  

  let subTotal = 0
  const ACCOUNT_TABS = [
    {
      value: `Order Details`,
      component: details ? (
        <ViewDesignOrderDetails
          teamMembers={teamMembers}
          rejectedAttachments={rejectedAttachments}
          clientDetails={invoice}
          products={invoice?.cust_product}
          fetchRequestDetails={fetchRequestDetails}
          user={user}
          designs={designs}
          referenceFiles={referenceFiles}
          setDesigns={setDesigns}
          details={details}
          designStatus={details?.status}
          isRequest={true}
          requestId={id}
          invoice={invoice}
          isDesign={true}
          setRefresh={setRefresh}
          refresh={refresh}
          allTeamMembers={allTeamMembers}
          onlineUsers={onlineUsers}
          designOrderProducts={designOrderProducts}
          designOrderServices={initialSelectedServices || []}
          customerOrderProductGroups={designOrderProductGroups}
        />
      ) : (
        ''
      ),
    },
    ...(user.user_type === 3 ||
    isAdminUser (user.user_type) ||
    explodedPermissions?.some((permission) =>
      ['View Design Order Client Message Board','Access Design Order Client Message Board'].includes(permission),
    )
      ? [
          {
            value: 'client message board',
            component: (
              <PublicMessageBoard
                products={invoice?.cust_product}
                requestDetails={details}
                requestId={id}
                acceptedClients={[customerData]}
                fromDesign={true}
                isDesignOrder={true}
                accessPublicMessageBoard={accessPublicMessageBoard}
              />
            ),
          },
        ]
      : []),
    ...(user.isVendor
      ? []
      : [
          {
            // value: 'change order',
            value: 'Job Log',
            component: (
              <Box
                sx={{
                  '& .MuiAvatar-root': {
                    width: 28,
                    height: 28,
                  },
                  '& .MuiTypography-subtitle2': {
                    fontSize: '0.75rem',
                  },
                  '& .MuiTypography-caption': {
                    fontSize: '0.65rem',
                  },
                  '& .MuiTypography-body2': {
                    fontSize: '0.8rem',
                  },
                  '& .MuiTypography-body1': {
                    fontSize: '0.8rem',
                  },
                }}
              >
                <RequestTabUpdates updates={updates?.length > 0 ? updates : []} details={details} searchable onSearchUpdates={handleJobLogSearch}/>
              </Box>
            ),
          },
        ]),
    ...(user.isVendor
      ? []
      : [
          {
            value: 'Design Notes',
            component: (
              <Card sx={{ height: '72vh', display: 'flex' }}>
                <JobNoteWindow
                  products={invoice?.cust_product}
                  allUser={jobNoteMembers}
                  requestIdd={null}
                  designOrderId={id}
                  requestDetails={details}
                  fromDesign={true}
                  isDesignOrder={true}
                  renderCards={renderCardsValue}
                  setRenderCards={setRenderCardsValue}
                  fetchRequestDetails={fetchRequestDetails}
                  details={details}
                  accessPublicMessageBoard={accessPublicMessageBoard}
                  convertedDesignRequestId={details?.converted_design_request_id}
                  noteType="design"
                />
              </Card>
            ),
          },
        ]),
    // Design Form Submissions Tab - Show submitted forms (always visible)
    {
      value: 'Design Forms',
      component: details && id ? (
        <ViewDesignFormSubmissions designOrderId={id} />
      ) : (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Loading design order details...
          </Typography>
        </Box>
      ),
    },
  ]

  const handleSaveDraft = async (e) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    try {
      if (userType !== 3 && !isClient && !formik.values.clients) {
        enqueueSnackbar('Please select a client to save draft', { variant: 'warning' })
        return
      }
      setIsSavingDraft(true)
      const values = { ...formik.values }
      values.name = orderTextFields.name || ''
      values.description = orderTextFields.description || ''
      values.notes = orderTextFields.notes || ''
      values.draft = true
      values.clientsData = values.clients ? [values.clients] : []
      values.userName = user.first_name
      values.avatarUrl = getSubmitDesignAttachments()
      values.referenceFiles = referenceFiles?.map((file) => ({
        extension: file.extension,
        file_type: file.file_type,
        size: file.file_size || file.size,
        url: file.name || file.url,
        added_by: file.added_by || null,
        approved: file.approved || null,
        approved_by: file.approved_by || null,
        status: file.status || 1,
        isChat: file.isChat || 0,
        isDesign: file.isDesign ? file.isDesign : userType === 11 ? 1 : 2,
        isNew: file.isNew ? file.isNew : userType === 11 ? 1 : 2,
        reason: file.reason || null,
      })) || []
      values.markup_type = markupType
      const draftProductRowsWithLocations = getRowsWithCommunityProductLocations()
      values.products = buildDesignOrderProductsPayload(draftProductRowsWithLocations)
      values.productRows = values.products.filter((p) => p.is_product_row === 1)

      const selectedServicesTotalCost = additionalSelectedServices?.reduce(
        (total, service) => total + Number(calculateServiceTotal(service?.total_cost, service?.quantity, 0, 1)),
        0,
      )

      const data = {
        values,
        isClientEdited,
        userId,
        userType,
        design_order_id: id,
        selectedServices: additionalSelectedServices || [],
        totalCost: roundToThreeDecimals(selectedServicesTotalCost || 0),
        designers: designers || [],
        collaborators: Array.isArray(collaborators) ? collaborators.map((c) => (typeof c === 'object' && c?.id != null ? c.id : c)).filter(Boolean).join(',') : (collaborators || ''),
        isClient,
        ...buildDesignOrderGroupMarketingPayload(groupedProducts),
      }
      await handleConfirmSubmit(values, data)
    } catch (error) {
      console.error(error)
      enqueueSnackbar('Failed to save draft', { variant: 'error' })
    } finally {
      setIsSavingDraft(false)
    }
  }

  const handleCancel = async () => {
    setOpenEdit(false)
    setIsOpen(false)
    setCurrentRFQdata({})
    setOrderTextFields({ name: '', description: '', notes: '' })
    setOrderTextFieldErrors({})
    fetchRequestDetails()
    setAvatarUrl([])
    setReferenceFiles([])
    setDesigners([])
    setAdditionalSelectedServices([])

    if (edit) {
      if(popupOn){
        closeView()
        setRenderCardsValue(!renderCardsValue)
      }else{
        navigate(PATH_DASHBOARD.design.root)
      }
    }
  }

  useEffect(() => {
    if (!popupOn || !headerStepBackRef) {
      return undefined;
    }
    const openedAsEditIntent = isEditDesignOrder === true || isEditDesignOrder === 'true';
    headerStepBackRef.current = () => {
      if (openEdit) {
        setOpenEdit(false);
        setIsOpen(false);
        setCurrentRFQdata({});
        setOrderTextFields({ name: '', description: '', notes: '' });
        setOrderTextFieldErrors({});
        fetchRequestDetails();
        setAvatarUrl([]);
        setReferenceFiles([]);
        setDesigners([]);
        setAdditionalSelectedServices([]);
        return true;
      }
      if (openedAsEditIntent) {
        onExitDesignOrderEditMode?.();
        return true;
      }
      return false;
    };
    return () => {
      headerStepBackRef.current = () => false;
    };
  }, [popupOn, openEdit, isEditDesignOrder, onExitDesignOrderEditMode, headerStepBackRef]);

  let selectedServicesTotalCost = additionalSelectedServices?.reduce(
    (total, service, index) => {
      const serviceTotal = calculateServiceTotal(
        service?.total_cost,
        service?.quantity,
        0,
        1,
      )

      // return total + Number(service?.total);
      return total + Number(serviceTotal)
    },
    0,
  )

  // selectedServicesTotalCost = roundToThreeDecimals(selectedServicesTotalCost);
  const handleChangeSort = (category) => {
    setSort(category)
    setSortOpen(false)
  }

  selectedServicesTotalCost = roundToThreeDecimals(selectedServicesTotalCost)
  const selectedServicesSubTotal = selectedServicesTotalCost
  const selectedProductsSubTotal = useMemo(
    () => computeDesignOrderProductsSubTotal(productRows, groupedProducts),
    [productRows, groupedProducts],
  )
  const selectedProductsAndServicesSubTotal = roundToThreeDecimals(
    (selectedServicesSubTotal || 0) + (selectedProductsSubTotal || 0),
  )

  const designPreviewFiles = useMemo(() => {
    const getAttachmentId = (file) =>
      file?.id ?? file?.ID ?? file?.attachment_id ?? file?.design_order_attachment_id ?? null

    const allProductAttachmentFiles = Object.values(productAttachments || {}).flat()
    const productAttachmentKeys = new Set(
      allProductAttachmentFiles.map(attachmentFileKey).filter(Boolean),
    )
    const productAttachmentIds = new Set(
      allProductAttachmentFiles
        .map((file) => getAttachmentId(file))
        .filter((id) => id !== null && id !== undefined)
        .map(String),
    )

    const availableAvatarFiles = (avatarUrl || []).filter((file) => {
      const fileKey = attachmentFileKey(file)
      const attachmentId = getAttachmentId(file)
      if (attachmentId != null && productAttachmentIds.has(String(attachmentId))) {
        return false
      }
      return !fileKey || !productAttachmentKeys.has(fileKey)
    })

    const productPreviewFiles = (productRows || []).flatMap((row) => {
      const rowAttachments = productAttachments[row.indexId] || []
      return rowAttachments.map((file) =>
        mapDesignOrderProductAttachmentForDisplay(file, row, groupedProductsMap),
      )
    })

    const seenKeys = new Set()
    const dedupedProductFiles = productPreviewFiles.filter((file) => {
      const key = attachmentFileKey(file)
      if (!key) return true
      if (seenKeys.has(key)) return false
      seenKeys.add(key)
      return true
    })

    return [...availableAvatarFiles, ...dedupedProductFiles]
  }, [avatarUrl, productAttachments, productRows, groupedProductsMap])

  let totalAmount = 0
  let totalMarkup = 0
  let totalProductFormula = 0
  let totalWholesalePrice = 0
  let totalRetailPrice = 0
  let originaltotalMarkup = 0
  let originaltotalServiceMarkup = 0
  let totalServiceMarkup = 0

  const memoizedRows = useMemo(() => {
    let totalServiceMarkup = 0
    let originaltotalServiceMarkup = 0
    let totalProductFormula = 0
    let totalWholesalePrice = 0
    let totalRetailPrice = 0

    // Map over additionalSelectedServices to calculate values without mutating
    const updatedRows = additionalSelectedServices.map((data, index) => {
      const quantity = Number(data?.quantity) || 1 // Default to 1 if undefined or 0
      const total = data.total_cost * quantity // Calculate total
      const markup = total > 0 ? (data.total_cost / total).toFixed(2) : 0

      // Calculate original markup
      const originalMarkup = data.originalMarkup || 0

      // Update totals
      totalServiceMarkup += Number(markup)
      originaltotalServiceMarkup += Number(originalMarkup)
      const productFormulaCost = (data.cost * quantity).toFixed(2)
      totalProductFormula += Number(productFormulaCost)
      totalWholesalePrice += Number(total)
      totalRetailPrice += Number(total)

      // Calculate quantityDifference (if needed)
      const quantityDifference = Number(quantity)

      // Return updated row without mutating the original object
      return {
        ...data,
        quantity,
        total: total.toFixed(2), // Include total
        markup,
        originalMarkup, // Include originalMarkup
        totalServiceMarkup: totalServiceMarkup.toFixed(2),
        quantityDifference, // Include quantityDifference
        jobcost_unit_cost: data.cost,
        jobcost_quantity: quantity,
        jobcost_total_cost: (data.cost * quantity).toFixed(2),
        quantity,
      }
    })

    // Update Formik values only once after calculations
    values['totalServiceMarkup'] = totalServiceMarkup.toFixed(2)
    values['totalProductFormula'] = totalProductFormula.toFixed(2)
    values['totalWholesalePrice'] = totalWholesalePrice.toFixed(2)
    values['totalRetailPrice'] = totalRetailPrice.toFixed(2)

    return updatedRows
  }, [additionalSelectedServices])

  // Product rows handlers
  const addNewProductRow = () => {
    const newIndexCounter = Math.max(...productRows.map((row) => row.indexId), 0) + 1
    setProductIndexCounter(newIndexCounter)
    setProductRows((prevRows) => [
      ...prevRows,
      {
        ...createEmptyProductRow(newIndexCounter),
        isNewlyAddedProductRow: true,
        addedByUserType: userTypeOriginal,
      },
    ])
  }

  const addCatalogProductsAsChooseRows = (products = []) => {
    const productsToAdd = products.filter(Boolean)
    if (!productsToAdd.length) return

    const currentMaxIndex = productRows.reduce(
      (maxIndex, row) => Math.max(maxIndex, row.indexId || 0),
      0,
    )
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = '',
    } = values?.community || {}

    const newRows = productsToAdd.map((product, productIndex) => {
      const indexId = currentMaxIndex + productIndex + 1
      const catalogLine = withCommunityLocationIfMissing(
        {
          ...product,
          indexId,
          quantity: product.quantity || 1,
          install_quantity: product.install_quantity || 1,
          product_notes: product.product_notes || '',
          install_notes: product.install_notes || '',
          location: product.location || [
            { address: projAddress, city: projCity, state: projState, zip: projZip },
          ],
          is_product_row: 0,
        },
        values?.community,
      )

      return {
        indexId,
        entryMode: 'choose',
        product_name: catalogLine.name || '',
        product_desc: catalogLine.description || catalogLine.product_desc || '',
        price: 0,
        retail_price: 0,
        is_product_row: 0,
        catalogProduct: catalogLine,
        product_notes: '',
      }
    })

    setProductRows((prevRows) => [...prevRows, ...newRows])
    setProductIndexCounter(currentMaxIndex + newRows.length + 1)
  }

  const selectedCatalogProductsForAutocomplete = useMemo(
    () =>
      collapseProductsForAutocompleteChips(
        (productRows || [])
          .filter((row) => row.entryMode === 'choose' && row.catalogProduct)
          .map((row) => row.catalogProduct),
        designOrderProductGroups,
      ),
    [productRows, designOrderProductGroups],
  )

  const handleAutocompleteCatalogProductsChange = (event, newValue) => {
    const currentProducts = selectedCatalogProductsForAutocomplete
    const currentKeys = new Set(
      currentProducts.map((product) => getAutocompleteSelectionKey(product)),
    )
    const nextKeys = new Set(
      (newValue || []).map((product) => getAutocompleteSelectionKey(product)),
    )

    if ((newValue || []).length > currentProducts.length) {
      const addedProducts = (newValue || [])
        .filter((product) => !currentKeys.has(getAutocompleteSelectionKey(product)))
        .map((product) => stripGroupFieldsFromCatalogOption(product))
      addCatalogProductsAsChooseRows(addedProducts)
      return
    }

    if ((newValue || []).length < currentProducts.length) {
      const nextRows = []
      productRows.forEach((row) => {
        if (row.entryMode !== 'choose' || !row.catalogProduct) {
          nextRows.push(row)
          return
        }
        const selectionKey = getAutocompleteSelectionKey(row.catalogProduct)
        if (nextKeys.has(selectionKey)) {
          nextRows.push(row)
        }
      })
      const finalRows = nextRows.length > 0 ? nextRows : [createEmptyProductRow(1)]
      const indexIdMap = {}
      finalRows.forEach((row, idx) => {
        indexIdMap[String(row.indexId)] = idx + 1
      })
      const renumberedRows = finalRows.map((row) => {
        const newIndexId = indexIdMap[String(row.indexId)]
        return {
          ...row,
          indexId: newIndexId,
          ...(row.catalogProduct
            ? { catalogProduct: { ...row.catalogProduct, indexId: newIndexId } }
            : {}),
        }
      })
      remapProductRowKeyedState(indexIdMap)
      setProductRows(renumberedRows)
      setProductIndexCounter(renumberedRows.length + 1)
    }
  }

  const remapProductRowKeyedState = (indexIdMap) => {
    const remapKeys = (prev) => {
      const next = {}
      Object.keys(prev || {}).forEach((oldKey) => {
        const install = String(oldKey).endsWith('_install')
        const base = install ? String(oldKey).replace('_install', '') : oldKey
        const newKey = indexIdMap[base]
        if (newKey !== undefined) {
          next[install ? `${newKey}_install` : String(newKey)] = prev[oldKey]
        }
      })
      return next
    }
    setRowErrors((prev) => {
      const next = {}
      Object.keys(prev || {}).forEach((oldKey) => {
        const newKey = indexIdMap[oldKey]
        if (newKey !== undefined) next[newKey] = prev[oldKey]
      })
      return next
    })
    setProductAttachments(remapKeys)
    setLocationStates(remapKeys)
    setOpenProductAttachment(remapKeys)
    setIsUploadingProduct(remapKeys)
    setOpenProductNote(remapKeys)
  }

  const handleDeleteProduct = (indexId) => {
    grouping.clearGroupSelectionForProduct(indexId)
    if (productRows?.length > 1) {
      const updatedRows = productRows?.filter((row) => row.indexId !== indexId)
      setRowErrors((prevErrors) => {
        const newErrors = { ...prevErrors }
        delete newErrors[indexId]
        return newErrors
      })
      const indexIdMap = {}
      updatedRows.forEach((row, idx) => {
        indexIdMap[String(row.indexId)] = idx + 1
      })
      const renumberedRows = updatedRows.map((row) => {
        const newIndexId = indexIdMap[String(row.indexId)]
        return {
          ...row,
          indexId: newIndexId,
          ...(row.catalogProduct
            ? { catalogProduct: { ...row.catalogProduct, indexId: newIndexId } }
            : {}),
        }
      })
      remapProductRowKeyedState(indexIdMap)
      setProductRows(renumberedRows)
      setProductIndexCounter(renumberedRows?.length + 1)
    } else {
      setProductRows([createEmptyProductRow(1)])
      setProductIndexCounter(1)
      setProductAttachments({})
      setLocationStates({})
      setOpenProductAttachment({})
      setIsUploadingProduct({})
      setOpenProductNote({})
    }
  }

  const handleProductRowsDragEnd = useCallback(
    (result) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }

      const renderOrder = [...productTableBodyRenderOrder]
      const [moved] = renderOrder.splice(result.source.index, 1)
      renderOrder.splice(result.destination.index, 0, moved)

      const orderedOldIds = []
      renderOrder.forEach((item) => {
        if (item.type === 'row') {
          orderedOldIds.push(item.indexId)
        } else if (item.type === 'group') {
          const group = groupedProductsMap.get(item.groupId)
          const groupProducts = [...(group?.products || [])].sort(
            (a, b) => (Number(a?.indexId) || 0) - (Number(b?.indexId) || 0),
          )
          groupProducts.forEach((p) => orderedOldIds.push(p.indexId))
        }
      })

      const orderedSet = new Set(orderedOldIds.map(String))
      ;(productRows || []).forEach((row) => {
        if (row?.indexId != null && !orderedSet.has(String(row.indexId))) {
          orderedOldIds.push(row.indexId)
        }
      })

      const indexIdMap = {}
      orderedOldIds.forEach((oldId, idx) => {
        indexIdMap[String(oldId)] = idx + 1
      })

      grouping.remapDesignOrderProductIndexIds(indexIdMap)
      setProductIndexCounter(orderedOldIds.length + 1)
    },
    [
      productTableBodyRenderOrder,
      groupedProductsMap,
      productRows,
      grouping,
    ],
  )

  const handleRowEntryModeChange = (indexId, mode) => {
    const targetRow = productRows.find((row) => row.indexId === indexId)
    if (targetRow && getProductToggleDisplayMode(targetRow) === mode) return

    setProductRows((prev) =>
      prev.map((row) => {
        if (row.indexId !== indexId) return row
        if (mode === 'choose') {
          return {
            indexId: row.indexId,
            entryMode: 'choose',
            product_name: '',
            product_desc: '',
            price: 0,
            retail_price: 0,
            is_product_row: 0,
            product_write: 0,
            catalogProduct: null,
            product_notes: '',
            isPersistedRow: row.isPersistedRow ?? false,
            designOrderProductId: row.designOrderProductId ?? null,
            isNewlyAddedProductRow: row?.isNewlyAddedProductRow,
            addedByUserType: row?.addedByUserType ?? userTypeOriginal,
          }
        }
        return {
          indexId: row.indexId,
          entryMode: 'write',
          product_name: '',
          product_desc: '',
          price: 0,
          retail_price: 0,
          is_product_row: 1,
          product_write: 1,
          catalogProduct: null,
          product_notes: '',
          isPersistedRow: row.isPersistedRow ?? false,
          designOrderProductId: row.designOrderProductId ?? null,
          isNewlyAddedProductRow: row?.isNewlyAddedProductRow,
          addedByUserType: row?.addedByUserType ?? userTypeOriginal,
        }
      }),
    )
    setRowErrors((prev) => {
      const next = { ...prev }
      delete next[indexId]
      return next
    })
  }

  const openCatalogPickerForRow = (indexId, existingCatalog = null) => {
    setCatalogPickerRowIndexId(indexId)
    if (existingCatalog?.id != null) {
      const base = filteredProducts.find((p) => p.id === existingCatalog.id) || existingCatalog
      setCatalogPickerDraft({
        ...base,
        quantity: existingCatalog.quantity ?? base.quantity ?? 1,
        install_quantity: existingCatalog.install_quantity ?? base.install_quantity ?? 1,
        product_notes: existingCatalog.product_notes ?? base.product_notes ?? '',
        install_notes: existingCatalog.install_notes ?? base.install_notes ?? '',
      })
    } else {
      setCatalogPickerDraft(null)
    }
    setCatalogPickerOpen(true)
  }

  const confirmCatalogPicker = () => {
    if (!catalogPickerDraft) {
      enqueueSnackbar('Please select a catalog product', { variant: 'warning' })
      return
    }
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = '',
    } = values?.community || {}
    const catalogLine = withCommunityLocationIfMissing(
      {
        ...catalogPickerDraft,
        ...getCatalogPickerOriginalPrices(catalogPickerDraft),
        indexId: catalogPickerRowIndexId,
        quantity: catalogPickerDraft.quantity || 1,
        install_quantity: catalogPickerDraft.install_quantity || 1,
        product_notes: catalogPickerDraft.product_notes || '',
        install_notes: catalogPickerDraft.install_notes || '',
        location:
          catalogPickerDraft.location || [
            { address: projAddress, city: projCity, state: projState, zip: projZip },
          ],
        is_product_row: 0,
        markAdjType: catalogPickerDraft.markAdjType ?? 1,
      },
      values?.community,
    )
    let shouldClearAttachments = false
    setProductRows((prev) =>
      prev.map((row) =>
        row.indexId === catalogPickerRowIndexId
          ? (() => {
            const currentCatalogId = row.catalogProduct?.product_id || row.catalogProduct?.id || null
            const nextCatalogId = catalogLine?.product_id || catalogLine?.id || null
            shouldClearAttachments =
              Boolean(currentCatalogId || nextCatalogId) &&
              String(currentCatalogId || '') !== String(nextCatalogId || '')
            return {
              ...row,
              entryMode: 'choose',
              product_write: 0,
              catalogProduct: {
                ...catalogLine,
                addedByUserType: row?.addedByUserType ?? userTypeOriginal,
              },
              product_name: catalogLine.name || '',
              product_desc: catalogLine.description || catalogLine.product_desc || '',
              is_product_row: 0,
              isNewlyAddedProductRow: row?.isNewlyAddedProductRow,
              addedByUserType: row?.addedByUserType ?? userTypeOriginal,
            }
          })()
          : row,
      ),
    )
    if (shouldClearAttachments) {
      setProductAttachments((prev) => ({ ...prev, [catalogPickerRowIndexId]: [] }))
      setOpenProductAttachment((prev) => ({ ...prev, [catalogPickerRowIndexId]: false }))
    }
    setCatalogPickerOpen(false)
    setCatalogPickerRowIndexId(null)
    setCatalogPickerDraft(null)
    setRowErrors((prev) => {
      const next = { ...prev }
      delete next[catalogPickerRowIndexId]
      return next
    })
  }

  const handleCatalogRowQuantityChange = (indexId, quantity) => {
    const val = Math.max(0, Number(quantity))
    setProductRows((prev) =>
      prev.map((row) => {
        if (row.indexId !== indexId || !row.catalogProduct) return row
        const installQuantity = row.manually_updated_install_quantity || row.catalogProduct?.manually_updated_install_quantity
          ? row.catalogProduct.install_quantity
          : val
        return {
          ...row,
          catalogProduct: {
            ...row.catalogProduct,
            quantity: val,
            locationQuantity: val,
            install_quantity: installQuantity,
          },
          
        }
      }),
    )
  }

  const getServiceLineKey = (service) =>
    String(service?.newIndexId ?? service?.indexId ?? service?.id ?? '')

  const remapServiceIndexIds = useCallback((indexIdMap) => {
    const remapKey = (oldKey) => {
      const mapped = indexIdMap[String(oldKey)]
      return mapped !== undefined ? String(mapped) : String(oldKey)
    }

    const remapKeyedState = (prev) => {
      const next = {}
      Object.keys(prev || {}).forEach((oldKey) => {
        const newKey = remapKey(oldKey)
        next[newKey] = prev[oldKey]
      })
      return next
    }

    setAdditionalSelectedServices((prev) =>
      (prev || []).map((service) => {
        const oldKey = getServiceLineKey(service)
        const newId = indexIdMap[oldKey]
        if (newId === undefined) return service
        return {
          ...service,
          newIndexId: newId,
          indexId: newId,
          product_index: newId,
        }
      }),
    )

    setServiceOnlyLocationStates(remapKeyedState)
  }, [])

  const handleServiceTableDragEnd = useCallback(
    (result) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }

      const sorted = [...(additionalSelectedServices || [])].sort(
        (a, b) =>
          (Number(a?.newIndexId ?? a?.indexId ?? a?.product_index) || 0) -
          (Number(b?.newIndexId ?? b?.indexId ?? b?.product_index) || 0),
      )
      const [moved] = sorted.splice(result.source.index, 1)
      sorted.splice(result.destination.index, 0, moved)

      const indexIdMap = {}
      sorted.forEach((s, idx) => {
        indexIdMap[getServiceLineKey(s)] = idx + 1
      })

      remapServiceIndexIds(indexIdMap)
    },
    [additionalSelectedServices, remapServiceIndexIds],
  )

  const handleProductNameChange = (indexId, value) => {
    setProductRows((prevRows) =>
      prevRows.map((row) =>
        row.indexId === indexId && row.entryMode !== 'choose'
          ? { ...row, product_name: value, price: 0, retail_price: 0, is_product_row: 1 }
          : row,
      ),
    )
  }

  const handleProductDescChange = (indexId, value) => {
    setProductRows((prevRows) =>
      prevRows.map((row) => {
        if (row.indexId !== indexId) return row
        if (row.entryMode === 'choose' && row.catalogProduct) {
          return {
            ...row,
            product_desc: value,
            catalogProduct: {
              ...row.catalogProduct,
              description: value,
              product_desc: value,
            },
          }
        }
        if (row.entryMode !== 'choose') {
          return { ...row, product_desc: value, price: 0, retail_price: 0, is_product_row: 1 }
        }
        return row
      }),
    )
  }

  const handleOpenLocation = (indexId) => {
    setLocationStates((prev) => ({ ...prev, [indexId]: true }))
  }

  const handleCloseLocation = (indexId) => {
    setLocationStates((prev) => ({ ...prev, [indexId]: false }))
  }

  const handleLocationFieldChange = (indexId, field, value) => {
    setProductRows((prevItems) =>
      prevItems.map((row) => {
        if (row.indexId !== indexId || !row.catalogProduct) return row
        const updatedLocation = Array.isArray(row.catalogProduct.location)
          ? [...row.catalogProduct.location]
          : [{ address: '', city: '', state: '', zip: '' }]
        if (!updatedLocation[0]) updatedLocation[0] = { address: '', city: '', state: '', zip: '' }
        updatedLocation[0] = { ...updatedLocation[0], [field]: value }
        return {
          ...row,
          catalogProduct: { ...row.catalogProduct, location: updatedLocation },
        }
      }),
    )
  }

  const handleOpenNote = (indexId, note) => {
    setCurrentNote(note || '')
    setOpenProductNote((prev) => ({ ...prev, [indexId]: true }))
  }

  const handleOpenGroupNote = (indexId, note) => {
    setCurrentNote(note || '')
    grouping.handleOpenGroupNote(indexId)
  }

  const handleOpenGroupInstallNote = (indexId, note) => {
    setCurrentNote(note || '')
    grouping.handleOpenGroupInstallNote(indexId)
    setOpenProductNote((prev) => ({ ...prev, [`${indexId}_install`]: true }))
  }

  const handleCloseNote = (indexId) => {
    const isInstall = typeof indexId === 'string' && indexId.endsWith('_install')
    const realIndexId = isInstall ? indexId.replace('_install', '') : indexId
    setOpenProductNote((prev) => ({
      ...prev,
      [indexId]: false,
      [realIndexId]: false,
      [`${realIndexId}_install`]: false,
    }))
    setCurrentNote('')
    setNoteError(false)
    grouping.setOpenGroupProductNoteIndex(null)
    grouping.setOpenGroupInstallNoteIndex(null)
  }

  const handleNoteChange = (event) => {
    const newNote = event.target.value
    if (newNote.length <= MAX_CHARACTERS) {
      setCurrentNote(newNote)
    }
  }

  const getNoteTargetIds = (indexId) => {
    const isInstall = typeof indexId === 'string' && indexId.endsWith('_install')
    const realIndexId = isInstall ? indexId.replace('_install', '') : indexId
    if (isInstall) {
      const fromInstallTargets =
        grouping.groupInstallNoteTargets?.[String(realIndexId)] ||
        grouping.groupInstallNoteTargets?.[String(indexId)]
      if (Array.isArray(fromInstallTargets) && fromInstallTargets.length) {
        return fromInstallTargets
      }
      const product = (productRows || []).find(
        (row) => Number(row?.indexId) === Number(realIndexId),
      )
      const groupId = product?.catalogProduct?.group_id ?? product?.group_id
      if (groupId != null && groupId !== '') {
        const memberIds = (productRows || [])
          .filter(
            (row) =>
              String(row?.catalogProduct?.group_id ?? row?.group_id ?? '') ===
              String(groupId),
          )
          .map((row) => row.indexId)
        if (memberIds.length) return memberIds
      }
      return [realIndexId]
    }
    const fromGroupTargets =
      grouping.groupNoteTargets?.[String(indexId)] ||
      grouping.groupNoteTargets?.[String(realIndexId)]
    if (Array.isArray(fromGroupTargets) && fromGroupTargets.length) {
      return fromGroupTargets
    }
    return [realIndexId]
  }

  const handleSaveNote = (indexId) => {
    if (!currentNote.trim()) {
      setNoteError('Note cannot be empty or just spaces')
      return
    }
    setIsSavingNote(true)
    setTimeout(() => {
      const isInstall = typeof indexId === 'string' && indexId.endsWith('_install')
      const targetIds = getNoteTargetIds(indexId)
      const targetIdSet = new Set(targetIds.map(String))

      setProductRows((prev) =>
        prev.map((row) => {
          if (!targetIdSet.has(String(row.indexId))) return row
          if (row.catalogProduct) {
            return {
              ...row,
              catalogProduct: isInstall
                ? { ...row.catalogProduct, install_notes: currentNote }
                : { ...row.catalogProduct, product_notes: currentNote },
            }
          }
          return isInstall
            ? { ...row, install_notes: currentNote }
            : { ...row, product_notes: currentNote }
        }),
      )
      setIsSavingNote(false)
      handleCloseNote(indexId)
    }, 100)
  }

  const handleClearNote = (indexId) => {
    setNoteError(false)
    setIsClearingNote(true)
    setTimeout(() => {
      const isInstall = typeof indexId === 'string' && indexId.endsWith('_install')
      const targetIds = getNoteTargetIds(indexId)
      const targetIdSet = new Set(targetIds.map(String))

      setProductRows((prev) =>
        prev.map((row) => {
          if (!targetIdSet.has(String(row.indexId))) return row
          if (row.catalogProduct) {
            return {
              ...row,
              catalogProduct: isInstall
                ? { ...row.catalogProduct, install_notes: '' }
                : { ...row.catalogProduct, product_notes: '' },
            }
          }
          return isInstall
            ? { ...row, install_notes: '' }
            : { ...row, product_notes: '' }
        }),
      )
      setIsClearingNote(false)
      handleCloseNote(indexId)
    }, 100)
  }

  const handleAddAttachment = (indexId) => {
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: true }))
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: 0 }))
    const currentAttachments = productAttachments[indexId] || productAttachments[String(indexId)] || []
    setSelectedUploadedImages((prev) => ({ ...prev, [String(indexId)]: [...currentAttachments] }))
  }

  const handleCloseAttachment = (indexId) => {
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }))
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: 0 }))
    setSelectedUploadedImages((prev) => ({ ...prev, [indexId]: [] }))
  }

  const handleAttachmentTabChange = (event, newValue, indexId) => {
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: newValue }))
  }

  const handleImageSelect = (file, indexId, isSelected) => {
    const key = String(indexId ?? '')
    setSelectedUploadedImages((prev) => {
      const current = prev[key] || prev[indexId] || []
      if (isSelected) {
        if (current.some((f) => attachmentMatches(f, file))) return prev
        return { ...prev, [key]: [...current, file] }
      }
      return { ...prev, [key]: current.filter((f) => !attachmentMatches(f, file)) }
    })
  }

  const getProductAttachmentsList = useCallback(
    (productIndexId) =>
      productAttachments[productIndexId] || productAttachments[String(productIndexId)] || [],
    [productAttachments],
  )

  const handleAddSelectedImages = (indexId) => {
    const key = String(indexId ?? '')
    const selected = selectedUploadedImages[key] || selectedUploadedImages[indexId] || []
    setProductAttachments((prev) => {
      const updatedFiles = selected.map((file) => ({
        ...file,
        product_index_id: indexId,
      }))
      return {
        ...prev,
        [key]: updatedFiles,
      }
    })
    setSelectedUploadedImages((prev) => ({ ...prev, [key]: [], [indexId]: [] }))
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }))
    enqueueSnackbar('Product attachments updated successfully', { variant: 'success' })
  }

  const renderProductAttachmentModalContent = (productIndexId) => (
    <Grid
      container
      spacing={3}
      sx={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Upload Attachment
        </Typography>
        <Tabs
          value={attachmentTabValue[productIndexId] || 0}
          onChange={(e, newValue) =>
            handleAttachmentTabChange(e, newValue, productIndexId)
          }
          sx={{ mb: 2 }}
        >
          <Tab label="Select from Uploaded" />
          <Tab label="Upload New" />
        </Tabs>

        {(attachmentTabValue[productIndexId] || 0) === 0 ? (
          <Box>
            {(() => {
              const allProductAttachmentFiles = Object.values(productAttachments).flat()

              const availableAvatarFiles = (avatarUrl || []).filter((file) => {
                return !allProductAttachmentFiles.some((pfile) => attachmentMatches(pfile, file))
              })

              const allFiles = [
                ...availableAvatarFiles,
                ...allProductAttachmentFiles.map((file) => {
                  const product = (productRows || []).find(
                    (p) => Number(p?.indexId) === Number(file.product_index_id),
                  )
                  if (product) {
                    return mapDesignOrderProductAttachmentForDisplay(
                      file,
                      product,
                      groupedProductsMap,
                    )
                  }
                  return file
                }),
              ]

              const allFilesUnique = (() => {
                const seen = []
                return allFiles.filter((file) => {
                  if (seen.some((f) => attachmentMatches(f, file))) return false
                  seen.push(file)
                  return true
                })
              })()

              if (allFilesUnique.length === 0) {
                return (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: 'center', py: 4 }}
                  >
                    No uploaded files available. Please upload files first.
                  </Typography>
                )
              }

              const availableImages = allFilesUnique.filter((file) => {
                const isAddedToOtherProduct = Object.entries(productAttachments).some(
                  ([productId, attachments]) => {
                    if (String(productId) === String(productIndexId)) return false
                    return (
                      attachments &&
                      attachments.some((f) => attachmentMatches(f, file))
                    )
                  },
                )
                return !isAddedToOtherProduct
              })

              if (availableImages.length === 0) {
                return (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: 'center', py: 4 }}
                  >
                    All images are added to other products. No images left in the uploaded
                    files.
                  </Typography>
                )
              }

              const selectionKey = String(productIndexId)
              const rowSelection =
                selectedUploadedImages[selectionKey] ||
                selectedUploadedImages[productIndexId] ||
                []

              const original = getProductAttachmentsList(productIndexId)
              const toLink = rowSelection.filter((file) => !original.some((orig) => attachmentMatches(orig, file)))
              const toUnlink = original.filter((file) => !rowSelection.some((sel) => attachmentMatches(sel, file)))
              const hasChanges = toLink.length > 0 || toUnlink.length > 0

              return (
                <>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    {availableImages.map((file, idx) => {
                      const isSelected = rowSelection.some((f) =>
                        attachmentMatches(f, file),
                      )
                      const isAlreadyAddedToCurrent = original.some((f) => attachmentMatches(f, file))
                      return (
                        <Grid item xs={6} sm={4} md={3} key={idx}>
                          <Card
                            sx={{
                              position: 'relative',
                              border:
                                isSelected ? '2px solid' : '1px solid',
                              borderColor:
                                isSelected
                                  ? 'primary.main'
                                  : 'divider',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              handleImageSelect(file, productIndexId, !isSelected)
                            }}
                          >
                            <Box
                              sx={{
                                position: 'relative',
                                width: '100%',
                                paddingTop: '100%',
                                overflow: 'hidden',
                              }}
                            >
                              {(() => {
                                const url = file.url || file.name
                                const preview = file.preview || url
                                const fileExt = (
                                  file.extension || url.split('.').pop().split('?')[0]
                                ).toLowerCase()
                                const isOffice = [
                                  'doc',
                                  'docx',
                                  'xls',
                                  'xlsx',
                                  'ppt',
                                  'pptx',
                                ].includes(fileExt)
                                const isDesign = ['ai', 'psd', 'eps', 'dwg', 'dxf'].includes(
                                  fileExt,
                                )
                                const isPdf =
                                  file.file_type === 'application/pdf' || fileExt === 'pdf'

                                return isPdf || isOffice || isDesign ? (
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setPdfLoading(true)
                                      setSelectedPDF(url)
                                      setOpenPDFModal(true)
                                      setUseOfficeViewer(true)
                                    }}
                                    aria-label="open file"
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      p: 0,
                                      borderRadius: 0,
                                    }}
                                  >
                                    <Box
                                      component="iframe"
                                      src={
                                        isPdf
                                          ? url
                                          : isOffice
                                          ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                                              url,
                                            )}`
                                          : `https://docs.google.com/gview?url=${encodeURIComponent(
                                              url,
                                            )}&embedded=true`
                                      }
                                      title="File Preview"
                                      frameBorder="0"
                                      // sandbox="allow-scripts allow-same-origin" before it was this caused pdf preview not working and fixed with below code, if any future issues came i have done only the pdf part that will only in me others i will be author
                                      sandbox={isPdf ? undefined : 'allow-scripts allow-same-origin'}
                                      sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        pointerEvents: 'none',
                                      }}
                                    />
                                  </IconButton>
                                ) : (
                                  <Box
                                    component="img"
                                    src={preview}
                                    alt={file.name || 'Uploaded file'}
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                    }}
                                    onError={(e) => {
                                      if (preview !== url) {
                                        e.target.src = url
                                      }
                                    }}
                                  />
                                )
                              })()}
                              <AttachmentDownloadIconButton
                                file={file}
                                fileIndex={idx}
                                hidden={isClient || userType === 3}
                                sx={{
                                  position: 'absolute',
                                  top: 4,
                                  left: 4,
                                  zIndex: 2,
                                }}
                              />
                              <Checkbox
                                checked={isSelected}
                                sx={{
                                  position: 'absolute',
                                  top: 4,
                                  right: 4,
                                  zIndex: 3,
                                  bgcolor: 'rgba(255, 255, 255, 0.8)',
                                }}
                                onChange={(e) => {
                                  e.stopPropagation()
                                  handleImageSelect(file, productIndexId, e.target.checked)
                                }}
                              />
                              {isAlreadyAddedToCurrent && isSelected && (
                                <Chip
                                  label="Added"
                                  size="small"
                                  color="success"
                                  sx={{
                                    position: 'absolute',
                                    bottom: 4,
                                    left: 4,
                                  }}
                                />
                              )}
                            </Box>
                          </Card>
                        </Grid>
                      )
                    })}
                  </Grid>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <AttachmentDownloadAllButton
                      files={rowSelection}
                      allFiles={availableImages}
                      onToggleSelectAll={(checked) => {
                        const key = String(productIndexId)
                        setSelectedUploadedImages((prev) => ({
                          ...prev,
                          [key]: checked ? [...availableImages] : [],
                          [productIndexId]: checked ? [...availableImages] : [],
                        }))
                      }}
                      label="Download Selected"
                      hidden={isClient || userType === 3}
                    />
                    <Button
                      variant="contained"
                      onClick={() => handleAddSelectedImages(productIndexId)}
                      disabled={!hasChanges}
                    >
                      Save Selection ({rowSelection.length})
                    </Button>
                  </Box>
                </>
              )
            })()}
          </Box>
        ) : (
          <UploadMultiFile
            showPreview
            multiple
            maxSize={1024 * 1024 * 1024}
            files={getProductAttachmentsList(productIndexId).map((file) =>
              enrichDesignOrderAttachmentForDisplay(
                file,
                productIndexId,
                productRows,
                groupedProductsMap,
              ),
            )}
            onDrop={(acceptedFiles) => handleProductDrop(acceptedFiles, productIndexId)}
            onRemove={(file) => handleProductRemove(file, productIndexId)}
            onRemoveAll={() => handleProductRemove(null, productIndexId)}
            isUploading={isUploadingProduct[productIndexId] || false}
            showProductLabels
          />
        )}
      </Grid>
    </Grid>
  )

  const handleProductDrop = useCallback(
    async (acceptedFiles, productIndexId) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return

      setIsUploadingProduct((prev) => ({ ...prev, [productIndexId]: true }))

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now()
          const sanitizedFileName = file.name.replace(/\s+/g, '_')
          const fileName = `${timestamp}_${sanitizedFileName}`
          const filePath = `design-order/product-attachments/${fileName}`

          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file)

          if (uploadError) throw uploadError

          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath)

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL')
          }

          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
            name: file.name,
            product_index_id: productIndexId,
          }
        })

        const uploadedFiles = await Promise.all(uploadPromises)

        setProductAttachments((prev) => {
          const current = prev[productIndexId] || []
          const existingKeys = current.map(attachmentFileKey)
          const newFiles = uploadedFiles.filter(
            (file) => !existingKeys.includes(attachmentFileKey(file)),
          )
          return {
            ...prev,
            [productIndexId]: [...current, ...newFiles],
          }
        })

        setAvatarUrl((prev) => {
          const existingKeys = prev.map(attachmentFileKey)
          const newFiles = uploadedFiles.filter(
            (file) => !existingKeys.includes(attachmentFileKey(file)),
          )
          return [...prev, ...newFiles]
        })
      } catch (error) {
        console.error('Error uploading product file:', error)
        enqueueSnackbar('Failed to upload file', { variant: 'error' })
      } finally {
        setIsUploadingProduct((prev) => ({ ...prev, [productIndexId]: false }))
      }
    },
    [enqueueSnackbar]
  )

  const getDragTransferTypes = (dataTransfer) => {
    if (!dataTransfer?.types) return []
    const { types } = dataTransfer
    if (typeof types.includes === 'function') return [...types]
    const list = []
    for (let i = 0; i < types.length; i += 1) {
      list.push(types[i])
    }
    return list
  }

  const isExternalFileDragEvent = (e) => {
    const types = getDragTransferTypes(e.dataTransfer)
    if (types.some((type) => String(type).toLowerCase().includes('react-beautiful-dnd'))) {
      return false
    }
    return (
      types.includes('Files') ||
      types.includes('application/x-moz-file') ||
      Array.from(e.dataTransfer?.items || []).some((item) => item.kind === 'file')
    )
  }

  const handleProductIconDragOver = (e, productIndexId) => {
    if (!isExternalFileDragEvent(e)) return
    e.preventDefault()
    e.stopPropagation()
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = 'copy'
    }
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: true }))
  }

  const handleProductIconDragLeave = (e, productIndexId) => {
    e.preventDefault()
    e.stopPropagation()
    const related = e.relatedTarget
    if (related && e.currentTarget.contains(related)) return
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: false }))
  }

  const handleProductIconDrop = (e, productIndexId) => {
    e.preventDefault()
    e.stopPropagation()
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: false }))
    const files = Array.from(e.dataTransfer?.files || [])
    if (files.length > 0) {
      handleProductDrop(files, productIndexId)
    }
  }

  const handleProductRemove = (file, productIndexId) => {
    if (!file) {
      setProductAttachments((prev) => ({
        ...prev,
        [productIndexId]: [],
      }))
      return
    }
    setProductAttachments((prev) => {
      const current = prev[productIndexId] || []
      return {
        ...prev,
        [productIndexId]: current.filter((item) => !attachmentMatches(item, file)),
      }
    })
    setAvatarUrl((prev) => prev.filter((f) => !attachmentMatches(f, file)))
    setSelectedUploadedImages((prev) => pruneAttachmentMapsByFile(prev, file))
  }

  const getProductAttachmentRowProps = useCallback(
    (productIndexId) => ({
      eventHandlers: {
        onDragEnterCapture: (e) => handleProductIconDragOver(e, productIndexId),
        onDragOverCapture: (e) => handleProductIconDragOver(e, productIndexId),
        onDragLeave: (e) => handleProductIconDragLeave(e, productIndexId),
        onDropCapture: (e) => handleProductIconDrop(e, productIndexId),
      },
      sx: productAttachmentDragOver[productIndexId]
        ? {
            backgroundColor: 'action.hover',
            outline: `2px dashed ${theme.palette.primary.main}`,
            outlineOffset: -2,
          }
        : {},
    }),
    [
      handleProductIconDragOver,
      handleProductIconDragLeave,
      handleProductIconDrop,
      productAttachmentDragOver,
      theme.palette.primary.main,
    ],
  )

  const renderProductAttachmentModal = useCallback(
    (productIndexId) => {
      const key = String(productIndexId)
      return (
        <Dialog
          key={`group-product-attachment-dialog-${key}`}
          open={Boolean(openProductAttachment[productIndexId] || openProductAttachment[key])}
          onClose={() => handleCloseAttachment(productIndexId)}
          maxWidth="md"
          fullWidth
          disableScrollLock
        >
          <DialogContent>
            {renderProductAttachmentModalContent(productIndexId)}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleCloseAttachment(productIndexId)}>Close</Button>
          </DialogActions>
        </Dialog>
      )
    },
    [openProductAttachment],
  )

  const handleInstallQuantityChange = (indexId, quantity) => {
    const val = Math.max(0, Number(quantity))
    setProductRows((prev) =>
      prev.map((row) => {
        if (row.indexId !== indexId || !row.catalogProduct) return row
        return {
          ...row,
          catalogProduct: {
            ...row.catalogProduct,
            install_quantity: val,
            manually_updated_install_quantity: true,
          },
          manually_updated_install_quantity: true,
        }
      }),
    )
  }

  const applyCatalogInstallUpdate = (catalog, updates) =>
    normalizeProductForSave({ ...catalog, ...updates })

  const updateCatalogProduct = (indexId, updater) => {
    setProductRows((prev) =>
      prev.map((row) => {
        if (String(row.indexId) !== String(indexId) || !row.catalogProduct) return row
        const updatedCatalog = typeof updater === 'function'
          ? updater(row.catalogProduct)
          : { ...row.catalogProduct, ...updater }
        return { ...row, catalogProduct: updatedCatalog }
      }),
    )
  }

  const handleRetailPriceChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        updateCatalogProduct(indexId, { retail_price_draft: undefined })
      } else {
        updateCatalogProduct(indexId, { retail_price_draft: limitedValue })
      }
      return
    }

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      updateCatalogProduct(indexId, { retail_price_draft: limitedValue })
      return
    }

    updateCatalogProduct(indexId, (catalog) => {
      const editResult = applyRetailPriceEdit(
        ensureCatalogBaselines(catalog),
        valueToApply,
        markupType ?? 2,
        {
          hasNegativePermission: explodedPermissions?.some((permission) =>
            ['Allow Negative Marketing Adjustment Design'].includes(permission),
          ),
        },
      )

      if (!editResult) {
        return { ...catalog, retail_price_draft: limitedValue }
      }

      if (editResult.error) {
        if (!isBlur) {
          return { ...catalog, retail_price_draft: limitedValue }
        }
        enqueueSnackbar(editResult.error, { variant: 'error' })
        return { ...catalog, retail_price_draft: undefined }
      }

      const reconciled = reconcileCatalogMarketingPrices({
        ...catalog,
        ...editResult,
        adjustment_draft: undefined,
      })

      return {
        ...reconciled,
        retail_price_draft: isBlur ? undefined : limitedValue,
      }
    })
  }

  const handleInstallPriceChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        updateCatalogProduct(indexId, { install_price_draft: undefined })
      } else {
        updateCatalogProduct(indexId, { install_price_draft: limitedValue })
      }
      return
    }

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      updateCatalogProduct(indexId, { install_price_draft: limitedValue })
      return
    }

    updateCatalogProduct(indexId, (catalog) => {
      const editResult = applyInstallPriceEdit(
        ensureCatalogBaselines(catalog),
        valueToApply,
        {
          hasNegativePermission: explodedPermissions?.some((permission) =>
            [
              'Allow Negative Marketing Adjustment Sales Order',
              'Allow Negative Marketing Adjustment Design',
            ].includes(permission),
          ),
        },
      )

      if (!editResult) {
        return { ...catalog, install_price_draft: limitedValue }
      }

      if (editResult.error) {
        if (!isBlur) {
          return { ...catalog, install_price_draft: limitedValue }
        }
        enqueueSnackbar(editResult.error, { variant: 'error' })
        return { ...catalog, install_price_draft: undefined }
      }

      const normalized = normalizeProductForSave({
        ...catalog,
        ...editResult,
      })

      return {
        ...normalized,
        install_price_draft: isBlur ? undefined : limitedValue,
        install_adjustment_draft: undefined,
      }
    })
  }

  const handleCatalogAdjValueTypeChange = (indexId, data, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Design'].includes(permission),
    )
    if (newValue === false) {
      const formulaEach = Number(
        (data?.expected_material_cost_with_markup || 0) +
          (data?.expected_service_cost_with_markup || 0),
      )
      const retailEachBase = Math.max(
        0,
        Number(
          data.original_actual_retail_price ??
            data.original_retail_price ??
            data.actual_retail_price ??
            data.retail_price ??
            0,
        ),
      )
      if (retailEachBase <= formulaEach && !hasPermission) {
        enqueueSnackbar(
          'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
          { variant: 'error' },
        )
        return
      }
    }
    const maxNegative = getMaxNegativeAdjustment(data, hasPermission)
    const adjustment = Number(data.adjustment) || 0
    if (Number(adjustment) >= maxNegative && newValue === false && hasPermission) {
      enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      return
    }
    if (Number(adjustment) > maxNegative && newValue === false && !hasPermission) {
      enqueueSnackbar(
        `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
        { variant: 'error' },
      )
      return
    }
    updateCatalogProduct(indexId, (catalog) =>
      applyProductAdjValueTypeChange(catalog, newValue),
    )
  }

  const handleCatalogAdjustmentChange = (indexId, data, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Design'].includes(permission),
    )
    const maxNegative = getMaxNegativeAdjustment(data, hasPermission)
    if (Number(newValue) >= maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && hasPermission) {
      enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      return
    }
    if (Number(newValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && !hasPermission) {
      enqueueSnackbar(
        `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
        { variant: 'error' },
      )
      return
    }
    updateCatalogProduct(indexId, (catalog) =>
      applyMarketingAdjustmentChange(catalog, newValue),
    )
  }

  const handleInstallAdjValueTypeChange = (indexId, data, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
    )
    if (newValue === false) {
      const formulaEach = Number(data?.expected_install_labor_cost_with_markup || 0)
      const retailEachBase = Math.max(0, Number(data.install_cost || 0))
      if (retailEachBase <= formulaEach && !hasPermission) {
        enqueueSnackbar(
          'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
          { variant: 'error' },
        )
        return
      }
    }
    const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
    const adjustment = Number(data.install_adjustment) || 0
    if (Number(adjustment) >= maxNegative && newValue === false && hasPermission) {
      enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      return
    }
    if (Number(adjustment) > maxNegative && newValue === false && !hasPermission) {
      enqueueSnackbar(
        `Negative Adjustment Amount cannot reduce below $${Number(maxNegative).toFixed(2)} (Install Formula Limit)`,
        { variant: 'error' },
      )
      return
    }
    updateCatalogProduct(indexId, (catalog) =>
      applyInstallAdjValueTypeChange(catalog, newValue),
    )
  }

  const handleInstallAdjustmentChange = (indexId, data, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
    )
    const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
    if (Number(newValue) >= maxNegative && data.install_adj_value_type === false && hasPermission) {
      enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      return
    }
    if (Number(newValue) > maxNegative && data.install_adj_value_type === false && !hasPermission) {
      enqueueSnackbar(
        `Negative Adjustment Amount cannot reduce below $${Number(maxNegative).toFixed(2)} (Install Formula Limit)`,
        { variant: 'error' },
      )
      return
    }
    updateCatalogProduct(indexId, (catalog) =>
      applyInstallMarketingAdjustmentChange(catalog, newValue),
    )
  }

  const handleDeleteInstallCost = (indexId) => {
    setProductRows((prev) =>
      prev.map((row) => {
        if (row.indexId !== indexId || !row.catalogProduct) return row
        return {
          ...row,
          catalogProduct: clearCatalogInstallCost(row.catalogProduct),
          manually_updated_install_cost: true,
        }
      }),
    )
  }

  const handleDeleteService = (id) => {
    const updatedServices = additionalSelectedServices.filter(
      (service) => service.id !== id,
    )

    // Update selected services
    setAdditionalSelectedServices(updatedServices)

    // Optional: Update options if necessary
    // setFilteredServices((prevServices) =>
    //   prevServices.filter((service) => service.id !== id)
    // );
  }

  const fetchAllProjectMembers = async (services) => {
    setMembersLoading(true)

    const workflowIds = services
      .map((service) => service.workflow)
      .filter((id) => id !== null && id !== undefined)

    const uniqueWorkflowIds = [...new Set(workflowIds)]

    try {
      const res = await axios.post(
        `${REST_API}webservice/workflow/project-members`,
        {
          workflow: uniqueWorkflowIds,
        },
      )

      if (res.data?.projectManagers) {
        // Sort designers alphanumerically by name
        const sortedDesigners = [...(res.data.projectManagers || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        setDesigners(sortedDesigners)
      }
    } catch (error) {
      console.error('Error in fetching project members:', error)
      setDesigners([])
    } finally {
      setMembersLoading(false)
    }
  }
  useEffect(() => {
    if(fromEstimate || (additionalSelectedServices?.length > 0 && designers.length === 0)){
      fetchAllProjectMembers(additionalSelectedServices)
    }
  }, [fromEstimate, additionalSelectedServices])

  const handleUpdateHoldStatus = async (reason) => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}project/update-design-order-job-hold-status`,
        {
          projectId: details?.id,
          userId: user.user_id,
          reason: reason || '',
          designOrder: true,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        fetchRequestDetails()
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  };

  const filteredDesigns = details?.send_client_app_req === 1 
    ? designs?.filter((item) => item.isDesign === 1) 
    : designs;
  const imageDesigns = filteredDesigns?.filter(
    (item) => item.file_type?.startsWith('image/') || item.file_type === 'img' || item.file_type === 'image'
  );

  const isAwaitingApprovalDesignOrder =
    details?.status === 1 &&
    details?.hold !== 1 &&
    details?.send_client_app_req == 1 &&
    designs?.length > 0;

  const handleOpenReopenConfirm = () => {
    setOpenReopenConfirm(true);
  };
  
  const handleCloseReopenConfirm = () => {
    setOpenReopenConfirm(false);
  };
  
  const handleConfirmReopen = async () => {
    setOpenReopenConfirm(false);
    const jobID = details?.id;
    if (!jobID) return;
  
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}design/update-design-order-job-by-id`,
        {
          jobId: jobID,
          status: 1,
          design_order_job_status: 7,
          userId,
        },
      );
  
      if (res.data?.status === 1) {
        setRefresh((prev) => !prev);
        enqueueSnackbar('Job reopened successfully', { variant: 'success' });
      } else {
        enqueueSnackbar(res.data?.message || 'Failed to reopen job', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error reopening job:', error);
      enqueueSnackbar('Failed to reopen job', { variant: 'error' });
    }
  };

  const handleCloseDesignOrder = async () => {
    if (isClosingDesignOrder) return;
    try {
      setIsClosingDesignOrder(true);
      const res = await axios.post(`${REST_API}webservice/design/close-design-order`, {
        design_order_id: id,
        userId,
      });

      if (res.data?.status === 1) {
        enqueueSnackbar(res.data.message || 'Design order closed successfully', { variant: 'success' });
        setOpenCloseConfirm(false);
        if (popupOn) {
          closeView?.();
          setRenderCardsValue(!renderCardsValue);
        } else {
          navigate(`/dashboard/design-order/view/${id}`, { replace: true, state: { fromProjects: true } });
          fetchRequestDetails();
        }
      } else {
        enqueueSnackbar(res.data?.message || 'Failed to close design order', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error closing design order:', error);
      enqueueSnackbar('Failed to close design order', { variant: 'error' });
    } finally {
      setIsClosingDesignOrder(false);
    }
  };
  return (
    <Page title="View Request: View | Sign Wise Solutions">
      {loading || convertToRFQ || convertToSplitEstimate ? (
        <Stack
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
          }}
        >
          <LoadingScreen />
        </Stack>
      ) : (
        <Container>
          <Button
            variant="outlined"
           type="button"
            onClick={() => {
              if (openEdit) {
                handleCancel()
              } else if (popupOn) {
                closeView && closeView()
                onDataChange && onDataChange()
              } else if (isFromProjects && location.state?.projectId) {
                navigate(`/dashboard/design-order/jobs/view-design-job/${location.state.projectId}`, {
                  state: { currentTab: location.state?.currentTab },
                })
              } else {
                navigate(PATH_DASHBOARD.design.root)
              }
            }}
            sx={{ alignItems: 'flex-end', mt: 3, mb: 4 }}
            startIcon={
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>
            }
          >
            Back
          </Button>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ mt: 5 }}
          >
            <HeaderBreadcrumbs heading={details?.name} />
            {!openEdit && (
              <Stack marginBottom={5} flexDirection={'column'}>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  spacing={1}
                ></Stack>
                {(userType != 3 ) ? (
                  <Stack>
                    <Stack flexDirection={'row'} gap={2}>
                      {/* {details?.design_order_job_status === 3 || details?.status === 3 || details?.hold == 1 ? ( */}
                      {details?.status === 3 ||
                      details?.status === 2 ||
                      // details?.design_order_job_status === 3 ||
                      details?.hold == 1 ? (
                        ''
                      ) : (
                        details?.status != 6 ? ( <Tooltip title="Edit">
                          <IconButton
                            sx={{
                              backgroundColor: theme.palette.mode === 'light' ? "#BDBDBD" : theme.palette.divider,
                              '&:hover': {
                                backgroundColor: theme.palette.mode === 'light' ? "#858585" : theme.palette.divider
                              }
                            }}
                            onClick={() => {
                              explodedPermissions?.some((permission) =>
                                ['Edit Design Order'].includes(permission),
                              )
                                ? handleEditClick()
                                : enqueueSnackbar(
                                    'Access Denied: You do not have sufficient permissions2',
                                    { variant: 'error' },
                                  )
                            }}
                          >
                            <Icon
                              icon={editFill}
                              width={24}
                              height={24}
                              color="#ffffff"
                            />
                          </IconButton>
                        </Tooltip>):(
                          <Tooltip>
                            <Button
                              
                               variant="contained"
                               color="success"
                               sx={{color:"white"}}
                               onClick={() => {
                                handleOpenReopenConfirm()
                              }}
                            >
                              Reopen
                              </Button>
                          </Tooltip>
                        )
                        
                      )}
                               {/* Reopen Confirm Dialog */}
                                  <Dialog
  open={openReopenConfirm}
  onClose={handleCloseReopenConfirm}
>
  <DialogTitle>
    Confirm Reopen
  </DialogTitle>

  <DialogContent>
    <DialogContentText>
      Are you sure you want to reopen this job?
    </DialogContentText>
  </DialogContent>

  <DialogActions>
    <Button onClick={handleCloseReopenConfirm}>
      Cancel
    </Button>

    <Button
      variant="contained"
      color="primary"
      onClick={handleConfirmReopen}
    >
      Yes, Reopen
    </Button>
  </DialogActions>
</Dialog>
                      {/* {details?.design_order_job_status === 3 || details?.status === 3 || details?.hold == 1 ? ( */}
                      {details?.status === 3 ? (
                        ''
                      ) : (
                        <Tooltip title="Delete">
                          <IconButton
                            sx={{
                              backgroundColor: theme.palette.mode === 'light' ? "#BDBDBD" : theme.palette.divider,
                              '&:hover': {
                                backgroundColor: theme.palette.mode === 'light' ? "#858585" : theme.palette.divider
                              }
                            }}
                            onClick={() => {
                              explodedPermissions?.some((permission) =>
                                ['Delete Design Order'].includes(permission),
                              )
                                ? handleDeleteMenu()
                                : enqueueSnackbar(
                                    'Access Denied: You do not have sufficient permissions',
                                    { variant: 'error' },
                                  )
                            }}
                          >
                            <Icon
                              icon={trash2Outline}
                              width={24}
                              height={24}
                              color="#ffffff"
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                      {(explodedPermissions?.some((permission) =>
                        [
                          'Create Design Order',
                          'Edit Design Order',
                          'Delete Design Order',
                        ].includes(permission),
                      ) && !isClient && userType !==3)
                        ? details?.status === 2 &&
                          details?.hold == 0 &&
                           (
                            <AnimatedButton
                              title={'Convert to Estimate'}
                              onClick={() => {
                                setOpenConvertToEstimate(true)
                              }}
                            />
                          )
                        : ''}
                        {/* {(explodedPermissions?.some((permission) =>
                        [
                          'Create Design Order',
                          'Edit Design Order',
                          'Delete Design Order',
                        ].includes(permission),
                      ) && !isClient && userType !==3)
                        ? details?.status === 2 &&
                          details?.hold == 0 &&
                          details?.isreopened == 0 && (
                            <AnimatedButton
                              title={'Convert to Estimate Request'}
                              onClick={() => {
                                setOpenConvertToEstimateRequest(true)
                              }}
                            />
                          )
                        : ''} */}
                      {/* {(explodedPermissions?.some((permission) =>
                        [
                          'Create Design Order',
                          'Edit Design Order',
                          'Delete Design Order',
                        ].includes(permission),
                      ) && !isClient && userType !==3)
                        ? details?.status === 2 &&
                          details?.hold == 0 && details?.isreopened == 0 && (
                            <AnimatedButton
                              title={'Convert to Split Estimate'}
                              onClick={() => {
                                setOpenConvertToSplitEstimate(true)
                              }}
                            />
                          )
                        : ''} */}
                      {(explodedPermissions?.some((permission) =>
                        [
                          'Create Design Order',
                          'Edit Design Order',
                          'Delete Design Order',
                        ].includes(permission),
                      )  && !isClient && userType !==3)
                        ? details?.status === 2 &&
                          details?.hold == 0 && 
                          !hasDesignOrderWriteProductsBlockingConvert(
                            productRows,
                            designOrderProducts,
                          ) && (
                            <AnimatedButton
                              title={'Convert to Sales Order'}
                              onClick={() => {
                                setOpenConvertToSalesOrder(true)
                              }}
                            />
                          )
                        : ''}
                      {(explodedPermissions?.some((permission) =>
                        [
                          'Create Design Order',
                          'Edit Design Order',
                          'Delete Design Order',
                        ].includes(permission),
                      )  && !isClient && userType !==3)
                        ? details?.status === 2 && details?.converted_design_request_id &&
                          details?.isreopened == 1 && (details.quotation == 0 || details.quotation == null) && (details?.is_request_estimate == 0 || details?.is_request_estimate == null) &&(
                            <AnimatedButton
                              title={'Merge to Sales Order'}
                              onClick={() => {
                                setOpenMergeToSalesOrder(true)
                              }}
                            />
                          )
                        : ''}
                      {(explodedPermissions?.some((permission) =>
                        [
                          'Create Design Order',
                          'Edit Design Order',
                          'Delete Design Order',
                        ].includes(permission),
                      )  && !isClient && userType !==3)
                        ? details?.status === 2 && details?.converted_design_request_id &&
                          details?.isreopened == 1 &&(details.quotation == 1 ) && (details?.is_request_estimate == 0 || details?.is_request_estimate == null) &&(
                            <AnimatedButton
                              title={'Merge to Estimate'}
                              onClick={() => {
                                setOpenMergeToEstimate(true)
                              }}
                            />
                          )
                        : ''}
                      {(explodedPermissions?.some((permission) =>
                        [
                          'Create Design Order',
                          'Edit Design Order',
                          'Delete Design Order',
                        ].includes(permission),
                      )  && !isClient && userType !==3)
                        ? details?.status === 2 && details?.converted_design_request_id &&
                          details?.isreopened == 1 && details.quotation == 1 && details?.is_request_estimate == 1 &&(
                            <AnimatedButton
                              title={'Merge to Request Estimate'}
                              onClick={() => {
                                setOpenMergeToRequestEstimate(true)
                              }}
                            />
                          )
                        : ''}
                    </Stack>
                  </Stack>
                ) : details?.status === 3 ||
                  details?.status === 2 ||
                  details?.hold == 1 ? (
                  ''
                ) : (
                  <Tooltip title="Edit">
                    <IconButton
                      sx={{ backgroundColor: theme.palette.divider }}
                      onClick={() => {
                        explodedPermissions?.some((permission) =>
                          ['Edit Design Order'].includes(permission),
                        ) || (userType == 3)
                          ? handleEditClick()
                          : enqueueSnackbar(
                              'Access Denied: You do not have sufficient permissions',
                              { variant: 'error' },
                            )
                      }}
                    >
                      <Icon
                        icon={editFill}
                        width={24}
                        height={24}
                        color="#ffffff"
                      />
                    </IconButton>
                  </Tooltip>
                )}
              </Stack>
            )}
          </Stack>
          {openEdit && (
            <FormikProvider value={formik}>
              <Form noValidate autoComplete="off" onSubmit={handleFormSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <Card sx={{ p: 3 }}>
                      {/* Edit Mode Tabs */}
                      <Tabs
                        value={editTab}
                        onChange={(e, newValue) => setEditTab(newValue)}
                        sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
                      >
                        <Tab label="Design Order"  sx={{ fontSize: '1.1rem', fontWeight: 600 }}/>
                        <Tab label="Design Forms" sx={{ fontSize: '1.1rem', fontWeight: 600 }}/>
                      </Tabs>

                      {/* Design Order Tab */}
                      {editTab === 0 && (
                        <Stack spacing={3}>
                        <Stack
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={{ xs: 3, sm: 2 }}
                        >
                          <Stack flexDirection={'column'}>
                            {/* <LabelStyle>Name</LabelStyle> */}
                            <TextField
                              //   fullWidth
                              sx={{ width: 400 }}
                              label="Order Name"
                              name="name"
                              value={orderTextFields.name}
                              onChange={(e) => {
                                const v = e.target.value
                                setOrderTextFields((prev) => ({ ...prev, name: v }))
                                if (v.trim()) {
                                  setOrderTextFieldErrors((prev) => {
                                    const next = { ...prev }
                                    delete next.name
                                    return next
                                  })
                                }
                              }}
                              error={Boolean(orderTextFieldErrors.name)}
                              helperText={orderTextFieldErrors.name || ''}
                            />
                          </Stack>
                        </Stack>
                        {/* <LabelStyle>Description</LabelStyle> */}
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          maxRows={7}
                          label="keep the summary brief and make it communicates"
                          name="description"
                          value={orderTextFields.description}
                          onChange={(e) => {
                            const v = e.target.value
                            setOrderTextFields((prev) => ({ ...prev, description: v }))
                            if (v.trim()) {
                              setOrderTextFieldErrors((prev) => {
                                const next = { ...prev }
                                delete next.description
                                return next
                              })
                            }
                          }}
                          error={Boolean(orderTextFieldErrors.description)}
                          helperText={orderTextFieldErrors.description || ''}
                        />
                        <LabelStyle>Upload Reference</LabelStyle>
                        {/* <UploadAvatar
                          accept="image/*"
                          file={values.referenceFiles}
                          maxSize={1024 * 1024 * 1024}
                          onDrop={handleDrop}
                          error={Boolean(touched.referenceFiles && errors.referenceFiles)}
                        /> */}
                        <UploadMultiFile
                          showPreview
                          // maxSize={1024 * 1024 * 1024}
                          maxSize={1024 * 1024 * 1024}
                          // accept="image/*,application/pdf"
                          files={referenceFiles}
                          onDrop={handleDropReference}
                          onRemove={handleRemoveReference}
                          onRemoveAll={handleRemoveAllReference}
                          isUploading={isUploadingReference}
                          // error={Boolean(touched.referenceFiles && errors.referenceFiles)}
                        />
                        {(userType != 3 && !isClient) ?
                          <>
                            <LabelStyle>Upload Design</LabelStyle>
                            {/* <UploadAvatar
                              accept="image/*"
                              file={values.avatarUrl}
                              maxSize={1024 * 1024 * 1024}
                              onDrop={handleDrop}
                              error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                            /> */}
                            <UploadMultiFile
                              showPreview
                              // maxSize={1024 * 1024 * 1024}
                              maxSize={1024 * 1024 * 1024}
                              // accept="image/*,application/pdf"
                              files={designPreviewFiles}
                              onDrop={handleDrop}
                              onRemove={handleRemove}
                              onRemoveAll={handleRemoveAll}
                              isUploading={isUploading}
                              showProductLabels
                              // error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                            />
                          </>
                        : '' }
                        <Stack
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={{ xs: 3, sm: 2 }}
                        >
                          {(userType !== 3 || !isClient) && (
                            <Autocomplete
                              // multiple
                              // fullWidth
                              // disabled={true}
                              sx={{ width: '50%' }}
                              id="combo-box-demo"
                              options={allClientsEdit}
                              value={values.clients || null}
                              onChange={(event, newValue) => {
                                if (newValue) {
                                  setFieldValue('clients', newValue)
                                  setFieldValue('community', null)
                                  fetchAllCommunityByClient(newValue)
                                } else {
                                  setFieldValue('clients', null)
                                  setFieldValue('community', null)
                                  setCommunities([])
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  required
                                  {...params}
                                  label="Clients"
                                  error={Boolean(
                                    touched.clients && errors.clients,
                                  )}
                                  helperText={touched.clients && errors.clients}
                                />
                              )}
                              getOptionLabel={(option) => option.name}
                            />
                          )}
                          {isCommunityLoading ? (
                            <Stack
                              flexDirection={'row'}
                              alignItems="center"
                              justifyContent="center"
                            >
                              <CircularProgress
                                color="primary"
                                variant="indeterminate"
                              />
                              <Typography variant="body2">
                                Loading projects...
                              </Typography>
                            </Stack>
                          ) : communities?.length > 0 ? (
                            <Autocomplete
                              // fullWidth
                              sx={{ width: '50%' }}
                              id="community"
                              options={(communities || []).sort((a, b) => 
                                alphanumericCompare(a?.name || '', b?.name || '')
                              )}
                              value={values?.community || null}
                              onChange={(event, newValue) => {
                                if (newValue) {
                                  setFieldValue('community', newValue)
                                  setCollaborators([])
                                  const repOptions = getSalesRepOptionsFromCommunity(newValue);
                                  setSalesRepOptions(repOptions);
                                  if (repOptions.length > 0) {
                                    setSalesRepName(repOptions[0]?.name || '');
                                    setSalesRepId(repOptions[0]?.id || null);
                                  } else {
                                    setSalesRepName('');
                                    setSalesRepId(null);
                                  }
                                } else {
                                  setFieldValue('community', null)
                                  setSalesRepName('');
                                  setSalesRepId(null);
                                  setSalesRepOptions([]);
                                }
                              }}
                              renderInput={(params) => (
                                <Tooltip
                                  title={
                                    values.community
                                      ? formatProjectAddress(values.community)
                                      : ''
                                  }
                                >
                                  <TextField
                                    required
                                    {...params}
                                    label="Project"
                                    error={Boolean(
                                      touched.community && errors.community,
                                    )}
                                    helperText={
                                      touched.community && errors.community
                                    }
                                  />
                                </Tooltip>
                              )}
                              getOptionLabel={(option) => option?.name || ''}
                              renderOption={(props, option) => {
                                const { style, ...liProps } = props
                                return (
                                  <li
                                    {...liProps}
                                    style={{
                                      ...style,
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <Tooltip title={formatProjectAddress(option)}>
                                      <span
                                        style={{
                                          flex: 1,
                                          minWidth: 0,
                                          display: 'block',
                                        }}
                                      >
                                        <span
                                          style={{
                                            display: 'block',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                          }}
                                        >
                                          {option?.name || ''}
                                        </span>
                                        {/* <span
                                          style={{
                                            display: 'block',
                                            fontSize: 12,
                                            color: '#6b7280',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                          }}
                                        >
                                          {formatProjectAddress(option)}
                                        </span> */}
                                      </span>
                                    </Tooltip>
                                    <span style={{ display: 'none' }}>{option?.name || ''}</span>
                                  </li>
                                )
                              }}
                            />
                          ) : (
                            <Stack
                              sx={{ width: '50%' }}
                              justifyContent={'center'}
                            >
                              {values?.clients ? (
                                <Typography sx={{ color: 'red' }}>
                                  The selected client does not have any projects
                                  yet. Please create a new project for them!
                                </Typography>
                              ) : (
                                <Typography sx={{ color: 'red' }}>
                                  No client selected. Please choose a client
                                  from the list.
                                </Typography>
                              )}
                            </Stack>
                          )}
                        </Stack>
                        {salesRepOptions?.length > 0 && (
                          <Stack sx={{ width: '100%' }}>
                            <Autocomplete
                              id="sales-rep"
                              options={salesRepOptions}
                              value={
                                salesRepOptions.find((opt) => {
                                  if (salesRepId != null && opt?.id != null) {
                                    return String(opt.id) === String(salesRepId);
                                  }
                                  return salesRepName && opt?.name === salesRepName;
                                }) || null
                              }
                              onChange={(event, newValue) => {
                                setSalesRepName(newValue?.name || '');
                                setSalesRepId(newValue?.id || null);
                              }}
                              isOptionEqualToValue={(option, value) =>
                                (option?.id != null && value?.id != null && String(option.id) === String(value.id)) ||
                                option?.name === value?.name
                              }
                              getOptionLabel={(option) => option?.name || ''}
                              renderInput={(params) => (
                                <TextField {...params} label="Sales Rep" fullWidth />
                              )}
                            />
                          </Stack>
                        )}
                        {/* {(values.community?.id != null && (values.community?.all_sales_rep_names != null || values.community?.sales_rep_names != null)) && ( */}
                        <Stack sx={{ width: '100%' }}>
                              <Autocomplete
                                multiple
                                id="collaborators"
                                options={collaboratorOptions}
                                value={collaborators}
                                onChange={(event, newValue) => setCollaborators(newValue || [])}
                                loading={teamMembersLoading}
                                isOptionEqualToValue={(option, value) => (option?.id != null && value?.id != null && String(option.id) === String(value.id))}
                                getOptionLabel={(option) => {
                                  if (!option) return '';
                                  const name = option.name || [option.first_name, option.last_name].filter(Boolean).join(' ').trim();
                                  return name || String(option.id || '');
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Collaborators"
                                    fullWidth
                                    placeholder="Select Collaborators"
                                  />
                                )}
                              />
                            </Stack>
                        {/* )} */}

                        <Stack
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={{ xs: 3, sm: 2 }}
                        >
                          <Box
                            component={MobileDatePicker}
                            label="Start Date"
                            // minDate={moment()}
                            defaultValue={moment
                              .unix(values.start)
                              .format('MM/DD/YYYY')}
                            value={moment.unix(values.start)}
                            onChange={(date) =>
                              setFieldValue('start', moment(date).unix())
                            }
                            renderInput={(params) => (
                              <TextField size="small" {...params} fullWidth />
                            )}
                          />

                          <Box
                            component={MobileDatePicker}
                            label="Due Date"
                            minDate={moment.unix(values.start)}
                            defaultValue={moment
                              .unix(values.end)
                              .format('MM/DD/YYYY')}
                            value={moment.unix(values.end)}
                            onChange={(date) =>
                              setFieldValue('end', moment(date).unix())
                            }
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                {...params}
                                fullWidth
                                error={Boolean(touched.end && errors.end)}
                                helperText={touched.end && errors.end}
                              />
                            )}
                          />
                        </Stack>

                        {(userType !== 3 && !isClient) && (
                          <>
                          <LabelStyle>Products</LabelStyle>
                          <DesignOrderGroupDialogs
                            openAddToGroupModal={grouping.openAddToGroupModal}
                            setOpenAddToGroupModal={grouping.setOpenAddToGroupModal}
                            addToGroupOptions={grouping.addToGroupOptions}
                            addToGroupId={grouping.addToGroupId}
                            setAddToGroupId={grouping.setAddToGroupId}
                            handleAddToExistingGroup={grouping.handleAddToExistingGroup}
                            groupSelectedProductIds={grouping.groupSelectedProductIds}
                            openGroupCatalogSourceModal={grouping.openGroupCatalogSourceModal}
                            resetGroupCatalogSourceModal={grouping.resetGroupCatalogSourceModal}
                            showGroupCatalogCreateForm={grouping.showGroupCatalogCreateForm}
                            groupCatalogCustomName={grouping.groupCatalogCustomName}
                            setGroupCatalogCustomName={grouping.setGroupCatalogCustomName}
                            groupCatalogCustomDescription={grouping.groupCatalogCustomDescription}
                            setGroupCatalogCustomDescription={grouping.setGroupCatalogCustomDescription}
                            groupCatalogCreateError={grouping.groupCatalogCreateError}
                            setGroupCatalogCreateError={grouping.setGroupCatalogCreateError}
                            getCatalogSourceDropdownOptions={grouping.getCatalogSourceDropdownOptions}
                            groupCatalogSourceInputValue={grouping.groupCatalogSourceInputValue}
                            setGroupCatalogSourceInputValue={grouping.setGroupCatalogSourceInputValue}
                            setGroupCatalogSourceIndexId={grouping.setGroupCatalogSourceIndexId}
                            setGroupCatalogCustomSourceId={grouping.setGroupCatalogCustomSourceId}
                            setShowGroupCatalogCreateForm={grouping.setShowGroupCatalogCreateForm}
                            groupCatalogCustomSourceId={grouping.groupCatalogCustomSourceId}
                            customCatalogGroupSources={grouping.customCatalogGroupSources}
                            groupCatalogSourceIndexId={grouping.groupCatalogSourceIndexId}
                            getSelectedLineCatalogProducts={grouping.getSelectedLineCatalogProducts}
                            handleCancelGroupCatalogCreate={grouping.handleCancelGroupCatalogCreate}
                            handleCreateCustomCatalogGroup={grouping.handleCreateCustomCatalogGroup}
                            buildGroupFromSelection={grouping.buildGroupFromSelection}
                          />
                          <DesignOrderGroupActionBar
                            groupSelectedProductIds={grouping.groupSelectedProductIds}
                            groupEditMode={grouping.groupEditMode}
                            selectedProducts={catalogProducts}
                            handleCreateGroupFromSelection={grouping.handleCreateGroupFromSelection}
                            setOpenAddToGroupModal={grouping.setOpenAddToGroupModal}
                          />
                          <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center" spacing={{ xs: 3, sm: 2 }}>
                            <Autocomplete
                              sx={{ width: { xs: '100%', sm: '50%' } }}
                              multiple
                              id="view-design-order-product-autocomplete"
                              options={filteredProducts}
                              value={selectedCatalogProductsForAutocomplete}
                              onChange={handleAutocompleteCatalogProductsChange}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  error={Boolean(touched.products && errors.products)}
                                  helperText={touched.products && errors.products}
                                  label="Select a product"
                                />
                              )}
                              renderOption={(props, option) => {
                                const { style, ...liProps } = props
                                const description = option.description
                                const name = getCatalogAutocompleteDisplayName(option)
                                const suffix = getCatalogProductSuffix(option)
                                return (
                                  <li
                                    {...liProps}
                                    style={{
                                      ...style,
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                      {option?.syncWithQuickbooks === 1 && (
                                        <img
                                          src={quickbookLogo}
                                          width="40px"
                                          height="20px"
                                          alt="QuickBooks"
                                        />
                                      )}
                                    </div>
                                    <Tooltip title={`${description || ''} ${suffix}`}>
                                      <span
                                        style={{
                                          flex: 1,
                                          minWidth: 0,
                                          display: 'block',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                        }}
                                      >
                                        {`${name || ''} ${suffix}`}
                                      </span>
                                    </Tooltip>
                                    <span style={{ display: 'none' }}>{option.name}</span>
                                  </li>
                                )
                              }}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                  const name = getCatalogAutocompleteDisplayName(option)
                                  const suffix = getCatalogProductSuffix(option)
                                  return (
                                    <Tooltip key={index} title={getCatalogAutocompleteTooltip(option, suffix)}>
                                      <Chip
                                        {...getTagProps({ index })}
                                        label={`${name} ${suffix}`}
                                      />
                                    </Tooltip>
                                  )
                                })
                              }
                              isOptionEqualToValue={() => false}
                              getOptionLabel={(option) => {
                                const name = getCatalogAutocompleteDisplayName(option)
                                const description = option.description || ''
                                const suffix = getCatalogProductSuffix(option)
                                return `${description} ${suffix} \u200B${name}`
                              }}
                              filterOptions={(options, { inputValue }) =>
                                options.filter((option) => {
                                  const searchText = inputValue.toLowerCase()
                                  return (
                                    option.name?.toLowerCase().includes(searchText) ||
                                    option.description?.toLowerCase().includes(searchText) ||
                                    String(option.tags || '').toLowerCase().includes(searchText) ||
                                    String(option.id).includes(searchText)
                                  )
                                })
                              }
                            />
                            <Autocomplete
                              sx={{ width: { xs: '100%', sm: '50%' } }}
                              id="view-design-order-catalog-type"
                              options={splitOrderCatalogTypes}
                              value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                              onChange={(event, newValue) => {
                                const finalValue = newValue || splitOrderCatalogTypes.find((type) => type.id === 'all')
                                setFieldValue('split_catalog_type', finalValue)
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Catalog Type" placeholder="Select catalog type" />
                              )}
                              getOptionLabel={(option) => option.label}
                            />
                          </Stack>
                          <TableContainer component={Paper} sx={{ mt: 2, overflowX: 'auto' }}>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell padding="checkbox" sx={{ width: 40 }} />
                                  <TableCell padding="checkbox" sx={{ width: 40 }} />
                                  <TableCell align="center">Sl No</TableCell>
                                  <TableCell align="center">Mode</TableCell>
                                  {/* <TableCell align="center">Qb</TableCell> */}
                                  <TableCell align="center" sx={PRODUCT_TABLE_PRODUCT_COL_SX}>
                                    Products
                                  </TableCell>
                                  <TableCell align="center" sx={PRODUCT_TABLE_DESCRIPTION_COL_SX}>
                                    Description
                                  </TableCell>
                                  <TableCell align="center">Note</TableCell>
                                  <TableCell align="center">Attachments</TableCell>
                                  <TableCell align="center">Product formula cost Each</TableCell>
                                  <TableCell align="center">Markup (%)</TableCell>
                                  <TableCell align="center">Retail Price Each</TableCell>
                                  <TableCell align="center">Quantity</TableCell>
                                  <TableCell align="center">Location</TableCell>
                                  <TableCell align="center">Marketing Adjustment Type</TableCell>
                                  <TableCell align="center">Marketing Adjustment</TableCell>
                                  <TableCell align="center">Subtotal</TableCell>
                                  <TableCell align="center">Product Total</TableCell>
                                  <TableCell align="center" />
                                </TableRow>
                              </TableHead>
                              <DragDropContext onDragEnd={handleProductRowsDragEnd}>
                                <Droppable droppableId="view-design-order-product-rows">
                                  {(droppableProvided) => (
                                    <TableBody
                                      ref={droppableProvided.innerRef}
                                      {...droppableProvided.droppableProps}
                                    >
                                      {tableBodyRenderItems.map((bodyItem, index) => {
                                        if (bodyItem.type === 'group') {
                                          const group = groupedProductsMap.get(String(bodyItem.groupId))
                                          if (group) {
                                            const isGroupOpen = grouping.openGroupedRows[group.id] === true
                                            return (
                                              <DesignOrderGroupSummaryRow
                                                key={`design-group-${group.id}`}
                                                group={group}
                                                index={index}
                                                isGroupOpen={isGroupOpen}
                                                tableVariant="design"
                                                getGroupAnchorIndexId={getGroupAnchorIndexId}
                                                selectedProducts={catalogProducts}
                                                getGroupLosingMoneyFlags={grouping.getGroupLosingMoneyFlags}
                                                getLosingMoneyRowSx={grouping.getLosingMoneyRowSx}
                                                setOpenGroupedRows={grouping.setOpenGroupedRows}
                                                groupEditMode={grouping.groupEditMode}
                                                handleGroupFieldChange={grouping.handleGroupFieldChange}
                                                handleOpenGroupNote={handleOpenGroupNote}
                                                handleOpenAttachment={handleAddAttachment}
                                                getProductAttachmentsList={getProductAttachmentsList}
                                                theme={theme}
                                                handleGroupQuantityChange={grouping.handleGroupQuantityChange}
                                                setGroupLocationStates={grouping.setGroupLocationStates}
                                                handleGroupMarketingTypeChange={grouping.handleGroupMarketingTypeChange}
                                                handleGroupMarketingAdjustmentChange={grouping.handleGroupMarketingAdjustmentChange}
                                                hasMarkupPermission={hasMarkupPermission}
                                                markupType={markupType ?? 2}
                                                hasNegativeMarketingPermission={hasNegativeDesignMarketingPermission}
                                                handleDeleteGroup={grouping.handleDeleteGroup}
                                                setGroupEditMode={grouping.setGroupEditMode}
                                                groupSelectedProductIds={grouping.groupSelectedProductIds}
                                                setGroupSelectedProductIds={grouping.setGroupSelectedProductIds}
                                                enqueueSnackbar={enqueueSnackbar}
                                                getSelectedLineCatalogCount={grouping.getSelectedLineCatalogCount}
                                                setSelectedProducts={setCatalogProducts}
                                                groupProductQuantityDrafts={grouping.groupProductQuantityDrafts}
                                                clearGroupLineQuantityDrafts={grouping.clearGroupLineQuantityDrafts}
                                                resetGroupMarketingAdjustments={grouping.resetGroupMarketingAdjustments}
                                                openGroupProductNoteIndex={grouping.openGroupProductNoteIndex}
                                                setOpenGroupProductNoteIndex={grouping.setOpenGroupProductNoteIndex}
                                                currentNote={currentNote}
                                                setCurrentNote={setCurrentNote}
                                                handleNoteChange={handleNoteChange}
                                                handleSaveNote={handleSaveNote}
                                                handleClearNote={handleClearNote}
                                                isSavingNote={isSavingNote}
                                                isClearingNote={isClearingNote}
                                                MAX_CHARACTERS={MAX_CHARACTERS}
                                                expandedTableProps={{
                                                  VALUE: designOrderGroupValueColumns,
                                                  markupType: markupType ?? 2,
                                                  hasMarkupPermission,
                                                  theme,
                                                  tableVariant: 'design',
                                                  productColSx: DESIGN_ORDER_PRODUCT_TABLE_PRODUCT_COL_SX,
                                                  descriptionColSx: DESIGN_ORDER_PRODUCT_TABLE_DESCRIPTION_COL_SX,
                                                  groupProductQuantityDrafts: grouping.groupProductQuantityDrafts,
                                                  groupEditMode: grouping.groupEditMode,
                                                  groupSelectedProductIds: grouping.groupSelectedProductIds,
                                                  toggleGroupProductSelection: grouping.toggleGroupProductSelection,
                                                  handleOpenNote,
                                                  handleOpenAttachment: handleAddAttachment,
                                                  handleOpenProductFormula: () => {},
                                                  handleOpenInstallNote: (idx, note) =>
                                                    handleOpenNote(`${idx}_install`, note),
                                                  handleOpenGroupInstallNote,
                                                  getProductAttachmentsList,
                                                  isUploadingProduct,
                                                  getProductAttachmentRowProps,
                                                  handleGroupLineQuantityDraftChange:
                                                    grouping.handleGroupLineQuantityDraftChange,
                                                  handleGroupInstallQuantityChange:
                                                    grouping.handleGroupInstallQuantityChange,
                                                  handleGroupInstallMarketingTypeChange:
                                                    grouping.handleGroupInstallMarketingTypeChange,
                                                  handleGroupInstallMarketingAdjustmentChange:
                                                    grouping.handleGroupInstallMarketingAdjustmentChange,
                                                  handleGroupAllLocationSameChange:
                                                    grouping.handleGroupAllLocationSameChange,
                                                  handleGroupSingleCardChange: grouping.handleGroupSingleCardChange,
                                                  handleGroupLocationFieldChange:
                                                    grouping.handleGroupLocationFieldChange,
                                                  groupLocationStates: grouping.groupLocationStates,
                                                  setGroupLocationStates: grouping.setGroupLocationStates,
                                                  setSelectedProducts: setCatalogProducts,
                                                  setRefreshCalculation: grouping.setRefreshCalculation,
                                                  handleDeleteGroupInstall: grouping.handleDeleteGroupInstall,
                                                  renderProductAttachmentModal,
                                                }}
                                              />
                                            )
                                          }
                                        }

                                        const row = productRows.find(
                                          (r) => Number(r.indexId) === Number(bodyItem.indexId),
                                        )
                                        if (!row) return null
                                        const isWrite = row.entryMode !== 'choose'
                                        const rawData = row.catalogProduct
                                        const hasCatalog = !isWrite && rawData
                                        const data = hasCatalog ? getCatalogProductWithAdjustment(rawData) : rawData
                                        const price = hasCatalog
                                          ? (data.max_price ? data.max_price : (data.actual_retail_price || data.retail_price))
                                          : 0
                                        const installCost = hasCatalog ? parseFloat(data?.install_cost) || 0 : 0
                                        const formulaCost = hasCatalog
                                          ? ((data.inhouse === 0
                                            ? parseFloat(data?.sub_contract_price) || 0
                                            : (
                                              (parseFloat(data?.expected_material_cost_with_markup) || 0) +
                                              (parseFloat(data?.expected_service_cost_with_markup) || 0)
                                            )) || parseFloat(data?.expected_formula_price) || parseFloat(data?.expected_cost) || 0)
                                          : 0
                                        const qty = hasCatalog ? (data.quantity || 1) : null
                                        const productSubTotal = hasCatalog
                                          ? (data.actual_retail_price || 0) * (qty || 1)
                                          : null
                                        const installSubTotal = hasCatalog && installCost > 0
                                          ? installCost * (data.install_quantity || 1)
                                          : 0
                                        const productTotal = hasCatalog
                                          ? (productSubTotal || 0) + installSubTotal
                                          : null
                                        const hasNegativeMarketingPermission = explodedPermissions?.some((permission) =>
                                          ['Allow Negative Marketing Adjustment Design'].includes(permission),
                                        )
                                        const hasNegativeInstallMarketingPermission = explodedPermissions?.some((permission) =>
                                          ['Allow Negative Marketing Adjustment Sales Order'].includes(permission),
                                        )
                                        const productFormulaEach = hasCatalog
                                          ? (data?.inhouse === 0
                                            ? Number(data?.sub_contract_price || 0)
                                            : Number(
                                              (data?.expected_material_cost_with_markup || 0) +
                                                (data?.expected_service_cost_with_markup || 0),
                                            ))
                                          : 0
                                        const retailPriceMin = hasNegativeMarketingPermission
                                          ? 0.01
                                          : Math.max(0.01, productFormulaEach)
                                        const dataActualRetail = Number(
                                          data?.actual_retail_price ?? price ?? 0,
                                        )
                                        const signedInstallAdj = data?.install_adj_value_type
                                          ? (Number.isFinite(Number(data?.install_adjustment))
                                              ? Number(data.install_adjustment)
                                              : 0)
                                          : -(Number.isFinite(Number(data?.install_adjustment))
                                              ? Number(data.install_adjustment)
                                              : 0)
                                        const productRetailEach = hasCatalog
                                          ? Math.max(0, Number(data?.actual_retail_price ?? data?.retail_price ?? 0))
                                          : 0
                                        const isNegativeProductAdjustmentMode =
                                          data?.adj_value_type === false ||
                                          data?.adj_value_type === 0 ||
                                          data?.adj_value_type === '0' ||
                                          data?.adj_value_type === 'false'
                                        const isProductLosingMoney =
                                          hasCatalog &&
                                          isNegativeProductAdjustmentMode &&
                                          productRetailEach < productFormulaEach
                                        const installRetailEach = Math.max(0, Number(data?.install_cost || 0))
                                        const isNegativeInstallAdjustmentMode =
                                          data?.install_adj_value_type === false ||
                                          data?.install_adj_value_type === 0 ||
                                          data?.install_adj_value_type === '0' ||
                                          data?.install_adj_value_type === 'false'
                                        const isInstallLosingMoney =
                                          hasCatalog &&
                                          installRetailEach > 0 &&
                                          isNegativeInstallAdjustmentMode &&
                                          installRetailEach < Number(data?.expected_install_labor_cost_with_markup || 0)
                                        const isLosingMoneyItem = isProductLosingMoney || isInstallLosingMoney
                                        const losingMoneyRowSx = getDesignOrderLosingMoneyRowSx(
                                          theme,
                                          isLosingMoneyItem,
                                        )
                                        const productGroupBorderSx = {
                                          '& > .MuiTableCell-root': {
                                            borderBottom: (t) => `solid 1px ${t.palette.divider}`,
                                          },
                                        }

                                        return (
                                          <Fragment key={`product-row-group-${row.indexId}`}>
                                            <Draggable
                                              draggableId={`view-design-order-product-row-${row.indexId}`}
                                              index={index}
                                            >
                                              {(provided, snapshot) => (
                                                <TableRow
                                                  ref={provided.innerRef}
                                                  {...provided.draggableProps}
                                                  onDragEnterCapture={(e) => handleProductIconDragOver(e, row.indexId)}
                                                  onDragOverCapture={(e) => handleProductIconDragOver(e, row.indexId)}
                                                  onDragLeave={(e) => handleProductIconDragLeave(e, row.indexId)}
                                                  onDropCapture={(e) => handleProductIconDrop(e, row.indexId)}
                                                  sx={{
                                                    ...losingMoneyRowSx,
                                                    ...(installCost > 0 ? undefined : productGroupBorderSx),
                                                    ...(productAttachmentDragOver[row.indexId] && {
                                                      backgroundColor: 'action.hover',
                                                      outline: `2px dashed ${theme.palette.primary.main}`,
                                                      outlineOffset: -2,
                                                    }),
                                                  }}
                                                  style={{
                                                    ...provided.draggableProps.style,
                                                    ...(snapshot.isDragging ? { backgroundColor: theme.palette.action.hover } : {}),
                                                  }}
                                                >
                                                  <TableCell
                                                    padding="checkbox"
                                                    {...provided.dragHandleProps}
                                                    sx={{ width: 40, cursor: 'grab', verticalAlign: 'middle' }}
                                                  >
                                                    <DragIndicator fontSize="small" color="action" />
                                                  </TableCell>
                                                  <TableCell padding="checkbox">
                                                    {(() => {
                                                      const isAnyGroupInEditMode = Object.values(
                                                        groupEditMode || {},
                                                      ).some(Boolean)
                                                      const gid = row?.catalogProduct?.group_id
                                                        ? String(row.catalogProduct.group_id)
                                                        : null
                                                      const isGroupRow = Boolean(gid)
                                                      const canSelectUngrouped =
                                                        !isAnyGroupInEditMode && !isGroupRow && row.entryMode === 'choose'
                                                      const canSelectGrouped =
                                                        isGroupRow && !!groupEditMode?.[gid]
                                                      const show = canSelectUngrouped || canSelectGrouped
                                                      if (!show || row.entryMode !== 'choose' || !hasCatalog) return null
                                                      return (
                                                        <Checkbox
                                                          checked={isIndexIdInList(groupSelectedProductIds, row.indexId)}
                                                          onChange={() => toggleGroupProductSelection({
                                                            ...row.catalogProduct,
                                                            indexId: row.indexId,
                                                            entryMode: 'choose',
                                                          })}
                                                        />
                                                      )
                                                    })()}
                                                  </TableCell>
                                                  <TableCell align="center">#{index + 1}</TableCell>
                                                  <TableCell align="center">
                                                    <ProductLineEntryToggle
                                                      mode={getProductToggleDisplayMode(row)}
                                                      lockDisplay={isDesignOrderLockedProductToggle(row, userTypeOriginal)}
                                                      disabled={isDesignOrderLockedProductToggle(row, userTypeOriginal)}
                                                      onChange={(mode) => handleRowEntryModeChange(row.indexId, mode)}
                                                    />
                                                  </TableCell>
                                                  {/* {isWrite ? (
                                                    <TableCell align="center">-</TableCell>
                                                  ) : (
                                                    <TableCell align="center">
                                                      {hasCatalog && data?.syncWithQuickbooks === 1 ? (
                                                        <img src={quickbookLogo} alt="QuickBooks" style={{ width: 40, height: 40, objectFit: 'contain' }} />
                                                      ) : '-'}
                                                    </TableCell>
                                                  )} */}
                                                  <TableCell align="center" sx={PRODUCT_TABLE_PRODUCT_COL_SX}>
                                                    {isWrite ? (
                                                      <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        value={row.product_name}
                                                        onChange={(e) => handleProductNameChange(row.indexId, e.target.value)}
                                                        placeholder="Product Name"
                                                        error={Boolean(rowErrors[row.indexId])}
                                                        helperText={rowErrors[row.indexId]}
                                                        sx={{ width: '100%', minWidth: 0 }}
                                                      />
                                                    ) : hasCatalog ? (
                                                      <Box>
                                                        <Typography sx={{ fontWeight: 600, textAlign: 'center' }}>{data.name}</Typography>
                                                        {data.product_notes ? (
                                                          <Typography sx={{ color: 'error.main', fontSize: '0.8rem', whiteSpace: 'pre-wrap' }}>
                                                            Note: {data.product_notes}
                                                          </Typography>
                                                        ) : null}
                                                      </Box>
                                                    ) : (
                                                      <Button size="small" variant="outlined" color="primary" onClick={() => openCatalogPickerForRow(row.indexId)}>
                                                        Select Product
                                                      </Button>
                                                    )}
                                                    {isWrite && row.product_notes ? (
                                                      <Typography sx={{ color: 'error.main', fontSize: '0.8rem', whiteSpace: 'pre-wrap' }}>
                                                        Note: {row.product_notes}
                                                      </Typography>
                                                    ) : null}
                                                  </TableCell>
                                                  <TableCell align="center" sx={PRODUCT_TABLE_DESCRIPTION_COL_SX}>
                                                    {isWrite ? (
                                                      <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        value={row.product_desc}
                                                        onChange={(e) => handleProductDescChange(row.indexId, e.target.value)}
                                                        placeholder="Product Description"
                                                        multiline
                                                        minRows={2}
                                                        maxRows={3}
                                                        sx={{ width: '100%', minWidth: 0 }}
                                                      />
                                                    ) : hasCatalog ? (
                                                      <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        value={data.description || data.product_desc || ''}
                                                        onChange={(e) => handleProductDescChange(row.indexId, e.target.value)}
                                                        placeholder="Product Description"
                                                        multiline
                                                        minRows={2}
                                                        maxRows={3}
                                                        sx={{ width: '100%', minWidth: 0 }}
                                                      />
                                                    ) : '-'}
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    <IconButton
                                                      onClick={() =>
                                                        handleOpenNote(
                                                          row.indexId,
                                                          hasCatalog ? data.product_notes : row.product_notes,
                                                        )
                                                      }
                                                    >
                                                      <NoteAdd
                                                        sx={{
                                                          color: (hasCatalog ? data.product_notes : row.product_notes)
                                                            ? theme.palette.primary.main
                                                            : '',
                                                        }}
                                                      />
                                                    </IconButton>
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    {/* {hasCatalog ? ( */}
                                                      <Tooltip title="Drop files on row or click to open attachments">
                                                        <IconButton onClick={() => handleAddAttachment(row.indexId)}>
                                                          {isUploadingProduct[row.indexId] ? (
                                                            <CircularProgress size={34} />
                                                          ) : (
                                                            <UploadFile
                                                              sx={{
                                                                color:
                                                                  !productAttachments[row.indexId] || productAttachments[row.indexId]?.length === 0
                                                                    ? 'error.main'
                                                                    : theme.palette.primary.main,
                                                              }}
                                                            />
                                                          )}
                                                        </IconButton>
                                                      </Tooltip>
                                                    {/* ) : '-'} */}
                                                  </TableCell>
                                                  <TableCell align="center">{hasCatalog ? `$${fUSPrice(formulaCost)}` : '-'}</TableCell>
                                                  <TableCell align="center">
                                                    {hasCatalog && data.inhouse === 0
                                                      ? ((data?.sub_contract_markup ?? data?.markup) != null &&
                                                        (data?.sub_contract_markup ?? data?.markup) !== ''
                                                        ? `${Number(data.sub_contract_markup ?? data.markup).toFixed(2)}`
                                                        : '0.00')
                                                      : '-'}
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    {hasCatalog ? (
                                                      <TextField
                                                        required
                                                        fullWidth
                                                        type="number"
                                                        size="small"
                                                        label="Retail Price Each"
                                                        sx={{ width: 120 }}
                                                        value={
                                                          data.retail_price_draft !== undefined
                                                            ? limitDecimalInput(data.retail_price_draft)
                                                            : formatRetailPriceDisplay(
                                                                dataActualRetail ?? 0,
                                                              )
                                                        }
                                                        onFocus={selectInputValue}
                                                        onClick={selectInputValue}
                                                        onKeyPress={(event) => {
                                                          if (event.key === '-') {
                                                            event.preventDefault()
                                                          }
                                                          if (event.key === 'e') {
                                                            event.preventDefault()
                                                          }
                                                        }}
                                                        onKeyDown={(event) => {
                                                          if (
                                                            event.key === 'ArrowUp' ||
                                                            event.key === 'ArrowDown'
                                                          ) {
                                                            event.preventDefault()
                                                            const current =
                                                              data.retail_price_draft !== undefined
                                                                ? data.retail_price_draft
                                                                : formatRetailPriceDisplay(
                                                                    dataActualRetail ?? 0,
                                                                  )
                                                            handleRetailPriceChange(
                                                              row.indexId,
                                                              stepRetailPriceByArrow(
                                                                current,
                                                                event.key === 'ArrowUp'
                                                                  ? 'up'
                                                                  : 'down',
                                                                retailPriceMin,
                                                              ),
                                                              { isBlur: true },
                                                            )
                                                          }
                                                        }}
                                                        inputProps={{ min: retailPriceMin, step: 1 }}
                                                        onChange={(event) => {
                                                          const current =
                                                            data.retail_price_draft !== undefined
                                                              ? data.retail_price_draft
                                                              : formatRetailPriceDisplay(
                                                                  dataActualRetail ?? 0,
                                                                )
                                                          handleRetailPriceChange(
                                                            row.indexId,
                                                            normalizeRetailArrowChange(
                                                              current,
                                                              event.target.value,
                                                              retailPriceMin,
                                                            ),
                                                          )
                                                        }}
                                                        onBlur={(event) => {
                                                          handleRetailPriceChange(
                                                            row.indexId,
                                                            event.target.value,
                                                            { isBlur: true },
                                                          )
                                                        }}
                                                      />
                                                    ) : '-'}
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    {hasCatalog ? (
                                                      <TextField
                                                        required
                                                        type="number"
                                                        size="small"
                                                        value={qty}
                                                        style={{ width: 80 }}
                                                        onChange={(e) => handleCatalogRowQuantityChange(row.indexId, e.target.value)}
                                                        InputProps={{ inputProps: { min: 0 } }}
                                                      />
                                                    ) : '-'}
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    {hasCatalog ? (
                                                      <>
                                                        <IconButton onClick={() => handleOpenLocation(row.indexId)}>
                                                          <LocationOn sx={{ color: (Array.isArray(data.location) && data.location[0]?.address) ? theme.palette.primary.main : '' }} />
                                                        </IconButton>
                                                        <Modal open={locationStates[row.indexId] || false} handleClose={() => handleCloseLocation(row.indexId)}>
                                                          <Grid container spacing={3} sx={{ p: 2 }}>
                                                            <Grid item xs={12}><Typography variant="h6">Location</Typography></Grid>
                                                            <Grid item xs={12}>
                                                              <TextField fullWidth label="Address" value={data.location?.[0]?.address || ''} onChange={(e) => handleLocationFieldChange(row.indexId, 'address', e.target.value)} sx={{ mb: 2 }} />
                                                              <Stack direction="row" spacing={2}>
                                                                <TextField fullWidth label="City" value={data.location?.[0]?.city || ''} onChange={(e) => handleLocationFieldChange(row.indexId, 'city', e.target.value)} />
                                                                <TextField fullWidth label="State" value={data.location?.[0]?.state || ''} onChange={(e) => handleLocationFieldChange(row.indexId, 'state', e.target.value)} />
                                                                <TextField fullWidth label="Zip" value={data.location?.[0]?.zip || ''} onChange={(e) => handleLocationFieldChange(row.indexId, 'zip', e.target.value)} />
                                                              </Stack>
                                                            </Grid>
                                                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                                              <Button variant="contained" onClick={() => handleCloseLocation(row.indexId)}>Save</Button>
                                                            </Grid>
                                                          </Grid>
                                                        </Modal>
                                                      </>
                                                    ) : '-'}
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    {hasCatalog ? (
                                                      <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                                        <Remove
                                                          fontSize="small"
                                                          style={{ cursor: 'pointer' }}
                                                          onClick={() => {
                                                            const formulaEach = Number(
                                                              (data?.expected_material_cost_with_markup || 0) +
                                                                (data?.expected_service_cost_with_markup || 0),
                                                            )
                                                            const retailEachBase = Math.max(
                                                              0,
                                                              Number(
                                                                data.original_actual_retail_price ??
                                                                  data.original_retail_price ??
                                                                  data.actual_retail_price ??
                                                                  data.retail_price ??
                                                                  0,
                                                              ),
                                                            )
                                                            if (retailEachBase <= formulaEach && !hasNegativeMarketingPermission) {
                                                              enqueueSnackbar(
                                                                'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
                                                                { variant: 'error' },
                                                              )
                                                              return
                                                            }
                                                            const maxNegative = getMaxNegativeAdjustment(data, hasNegativeMarketingPermission)
                                                            const adjustment = Number(data.adjustment) || 0
                                                            if (Number(adjustment) >= maxNegative && hasNegativeMarketingPermission) {
                                                              enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                              return
                                                            }
                                                            if (Number(adjustment) > maxNegative && !hasNegativeMarketingPermission) {
                                                              enqueueSnackbar(
                                                                `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
                                                                { variant: 'error' },
                                                              )
                                                              return
                                                            }
                                                            handleCatalogAdjValueTypeChange(row.indexId, data, false)
                                                          }}
                                                        />
                                                        <FormControlLabel
                                                          control={
                                                            <Switch
                                                              checked={Boolean(data.adj_value_type)}
                                                              onChange={(event) =>
                                                                handleCatalogAdjValueTypeChange(row.indexId, data, event.target.checked)
                                                              }
                                                            />
                                                          }
                                                          label=""
                                                        />
                                                        <Add
                                                          fontSize="small"
                                                          style={{ cursor: 'pointer' }}
                                                          onClick={() => handleCatalogAdjValueTypeChange(row.indexId, data, true)}
                                                        />
                                                      </Stack>
                                                    ) : '-'}
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    {hasCatalog ? (
                                                      <TextField
                                                        type="number"
                                                        size="small"
                                                        inputProps={{ min: 0 }}
                                                        label="$"
                                                        value={Number(data.adjustment) || ''}
                                                        onWheel={(e) => e.target.blur()}
                                                        onBeforeInput={(e) => {
                                                          const inputElement = e.target
                                                          const nextValue = inputElement.value
                                                          const maxNegative = getMaxNegativeAdjustment(data, hasNegativeMarketingPermission)
                                                          if (
                                                            Number(nextValue) >= maxNegative &&
                                                            (data.adj_value_type === false || data.adj_value_type === 0) &&
                                                            hasNegativeMarketingPermission
                                                          ) {
                                                            e.preventDefault()
                                                            enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                          } else if (
                                                            Number(nextValue) > maxNegative &&
                                                            (data.adj_value_type === false || data.adj_value_type === 0) &&
                                                            !hasNegativeMarketingPermission
                                                          ) {
                                                            e.preventDefault()
                                                            enqueueSnackbar(
                                                              `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
                                                              { variant: 'error' },
                                                            )
                                                          }
                                                        }}
                                                        onChange={(event) => {
                                                          let newValue = event.target.value
                                                          const numValue = parseFloat(newValue) || 0
                                                          if (numValue < 0) {
                                                            newValue = '0'
                                                          } else if (newValue.includes('.')) {
                                                            const parts = newValue.split('.')
                                                            if (parts[1].length > 2) {
                                                              newValue = `${parts[0]}.${parts[1].slice(0, 2)}`
                                                            }
                                                          } else {
                                                            newValue = String(numValue)
                                                          }
                                                          handleCatalogAdjustmentChange(row.indexId, data, newValue)
                                                        }}
                                                        onKeyDown={(event) => {
                                                          if (event.key === '-' || event.key === '+') {
                                                            event.preventDefault()
                                                          }
                                                        }}
                                                        style={{ width: 90 }}
                                                      />
                                                    ) : '-'}
                                                  </TableCell>
                                                  <TableCell align="center">{hasCatalog ? `$${fUSPrice(productSubTotal)}` : '-'}</TableCell>
                                                  <TableCell align="center">
                                                    {hasCatalog && data?.install_cost ? '' : hasCatalog ? `$${fUSPrice(productTotal)}` : '-'}
                                                  </TableCell>
                                              <TableCell align="center" sx={DESIGN_ORDER_ROW_ACTIONS_CELL_SX}>
                                                <Box sx={DESIGN_ORDER_ROW_ACTIONS_BOX_SX}>
                                                  <Box sx={DESIGN_ORDER_ROW_ACTIONS_LEADING_SLOT_SX}>
                                                    {!isWrite && hasCatalog ? (
                                                      <Tooltip title="Change product">
                                                        <IconButton disabled={userTypeOriginal === 11 && row?.addedByUserType !== 11} size="small" color="success" onClick={() => openCatalogPickerForRow(row.indexId, data)}>
                                                          <SwapHorizontalCircleOutlined fontSize="small" />
                                                        </IconButton>
                                                      </Tooltip>
                                                    ) : null}
                                                  </Box>
                                                    <IconButton
                                                    // disabled={
                                                    //   userTypeOriginal === 11 && row?.addedByUserType !== 11
                                                    //  }
                                                      onClick={() => handleDeleteProduct(row.indexId)}
                                                      color="error"
                                                    >
                                                      <Delete />
                                                    </IconButton>
                                                </Box>
                                                  </TableCell>
                                                </TableRow>
                                              )}
                                            </Draggable>
                                            {hasCatalog && data?.install_cost ? (
                                              <TableRow sx={{ ...losingMoneyRowSx, ...productGroupBorderSx }}>
                                                <TableCell />
                                                <TableCell />
                                                <TableCell align="center">#{index + 1}</TableCell>
                                                <TableCell align="center">-</TableCell>
                                                <TableCell align="center" sx={PRODUCT_TABLE_PRODUCT_COL_SX}>
                                                  <Box>
                                                    {data.install_notes ? (
                                                      <Typography sx={{ color: 'error.main', whiteSpace: 'pre-wrap' }}>
                                                        {data.install_notes}
                                                      </Typography>
                                                    ) : (
                                                      <Typography>Install Price</Typography>
                                                    )}
                                                  </Box>
                                                </TableCell>
                                                <TableCell align="center" sx={PRODUCT_TABLE_DESCRIPTION_COL_SX}>
                                                  -
                                                </TableCell>
                                                <TableCell align="center">
                                                  <IconButton onClick={() => handleOpenNote(`${row.indexId}_install`, data.install_notes)}>
                                                    <NoteAdd sx={{ color: data.install_notes ? theme.palette.primary.main : '' }} />
                                                  </IconButton>
                                                </TableCell>
                                                <TableCell align="center" />
                                                <TableCell align="center">${
                                                  data?.install_formula_cost_each != null &&
                                                  data?.install_formula_cost_each !== ''
                                                    ? fUSPrice(Number(data.install_formula_cost_each))
                                                    : fUSPrice(data?.expected_install_labor_cost_with_markup || 0)
                                                }</TableCell>
                                                <TableCell align="center">-</TableCell>
                                                <TableCell align="center">
                                                  {(() => {
                                                    const installFormulaEach = Number(
                                                      data?.expected_install_labor_cost_with_markup ||
                                                        0,
                                                    )
                                                    const installPriceMin =
                                                      hasNegativeInstallMarketingPermission
                                                        ? 0.01
                                                        : Math.max(
                                                            0.01,
                                                            installFormulaEach,
                                                          )
                                                    const dataInstallCost = getDisplayedInstallPrice(data)
                                                    return (
                                                  <TextField
                                                    required
                                                    fullWidth
                                                    type="number"
                                                    size="small"
                                                    label="Install Price Each"
                                                    sx={{ width: 120 }}
                                                    value={
                                                      data.install_price_draft !== undefined
                                                        ? limitDecimalInput(
                                                            data.install_price_draft,
                                                          )
                                                        : formatRetailPriceDisplay(
                                                            dataInstallCost,
                                                          )
                                                    }
                                                    onFocus={selectInputValue}
                                                    onClick={selectInputValue}
                                                    onKeyPress={(event) => {
                                                      if (event.key === '-') {
                                                        event.preventDefault()
                                                      }
                                                      if (event.key === 'e') {
                                                        event.preventDefault()
                                                      }
                                                    }}
                                                    onKeyDown={(event) => {
                                                      if (
                                                        event.key === 'ArrowUp' ||
                                                        event.key === 'ArrowDown'
                                                      ) {
                                                        event.preventDefault()
                                                        const current =
                                                          data.install_price_draft !== undefined
                                                            ? data.install_price_draft
                                                            : formatRetailPriceDisplay(
                                                                dataInstallCost,
                                                              )
                                                        handleInstallPriceChange(
                                                          row.indexId,
                                                          stepRetailPriceByArrow(
                                                            current,
                                                            event.key === 'ArrowUp'
                                                              ? 'up'
                                                              : 'down',
                                                            installPriceMin,
                                                          ),
                                                          { isBlur: true },
                                                        )
                                                      }
                                                    }}
                                                    inputProps={{
                                                      min: installPriceMin,
                                                      step: 1,
                                                    }}
                                                    onChange={(event) => {
                                                      const current =
                                                        data.install_price_draft !== undefined
                                                          ? data.install_price_draft
                                                          : formatRetailPriceDisplay(
                                                              dataInstallCost,
                                                            )
                                                      handleInstallPriceChange(
                                                        row.indexId,
                                                        normalizeRetailArrowChange(
                                                          current,
                                                          event.target.value,
                                                          installPriceMin,
                                                        ),
                                                      )
                                                    }}
                                                    onBlur={(event) => {
                                                      handleInstallPriceChange(
                                                        row.indexId,
                                                        event.target.value,
                                                        { isBlur: true },
                                                      )
                                                    }}
                                                  />
                                                    )
                                                  })()}
                                                </TableCell>
                                                <TableCell align="center">
                                                  <TextField type="number" size="small" value={data.install_quantity || 1} style={{ width: 80 }} onChange={(e) => handleInstallQuantityChange(row.indexId, e.target.value)} InputProps={{ inputProps: { min: 0 } }} />
                                                </TableCell>
                                                <TableCell align="center">-</TableCell>
                                                <TableCell align="center">
                                                  <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                                    <Remove
                                                      fontSize="small"
                                                      style={{ cursor: 'pointer' }}
                                                      onClick={() => {
                                                        const formulaEach = Number(data?.expected_install_labor_cost_with_markup || 0)
                                                        const retailEachBase = Math.max(0, Number(data.install_cost || 0))
                                                        if (retailEachBase <= formulaEach && !hasNegativeInstallMarketingPermission) {
                                                          enqueueSnackbar(
                                                            'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
                                                            { variant: 'error' },
                                                          )
                                                          return
                                                        }
                                                        handleInstallAdjValueTypeChange(row.indexId, data, false)
                                                      }}
                                                    />
                                                    <FormControlLabel
                                                      control={
                                                        <Switch
                                                          checked={Boolean(data.install_adj_value_type)}
                                                          onChange={(event) =>
                                                            handleInstallAdjValueTypeChange(row.indexId, data, event.target.checked)
                                                          }
                                                        />
                                                      }
                                                      label=""
                                                    />
                                                    <Add
                                                      fontSize="small"
                                                      style={{ cursor: 'pointer' }}
                                                      onClick={() => handleInstallAdjValueTypeChange(row.indexId, data, true)}
                                                    />
                                                  </Stack>
                                                </TableCell>
                                                <TableCell align="center">
                                                  <TextField
                                                    type="number"
                                                    size="small"
                                                    inputProps={{ min: 0 }}
                                                    label="$"
                                                    value={
                                                      data.install_adjustment_draft !== undefined
                                                        ? limitDecimalInput(
                                                            data.install_adjustment_draft,
                                                          )
                                                        : Number(data.install_adjustment) || ''
                                                    }
                                                    onWheel={(e) => e.target.blur()}
                                                    onBeforeInput={(e) => {
                                                      const inputElement = e.target
                                                      const nextValue = inputElement.value
                                                      const maxNegative = getMaxNegativeInstallAdjustment(
                                                        data,
                                                        hasNegativeInstallMarketingPermission,
                                                      )
                                                      if (
                                                        Number(nextValue) >= maxNegative &&
                                                        data.install_adj_value_type === false &&
                                                        hasNegativeInstallMarketingPermission
                                                      ) {
                                                        e.preventDefault()
                                                        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                      } else if (
                                                        Number(nextValue) > maxNegative &&
                                                        data.install_adj_value_type === false &&
                                                        !hasNegativeInstallMarketingPermission
                                                      ) {
                                                        e.preventDefault()
                                                        enqueueSnackbar(
                                                          `Negative Adjustment Amount cannot reduce below $${Number(maxNegative).toFixed(2)} (Install Formula Limit)`,
                                                          { variant: 'error' },
                                                        )
                                                      }
                                                    }}
                                                    onChange={(event) => {
                                                      let newValue = event.target.value
                                                      const numValue = parseFloat(newValue) || 0
                                                      if (numValue < 0) {
                                                        newValue = '0'
                                                      } else if (newValue.includes('.')) {
                                                        const parts = newValue.split('.')
                                                        if (parts[1].length > 2) {
                                                          newValue = `${parts[0]}.${parts[1].slice(0, 2)}`
                                                        }
                                                      } else {
                                                        newValue = String(numValue)
                                                      }
                                                      handleInstallAdjustmentChange(row.indexId, data, newValue)
                                                    }}
                                                    onKeyDown={(event) => {
                                                      if (event.key === '-' || event.key === '+') {
                                                        event.preventDefault()
                                                      }
                                                    }}
                                                    style={{ width: 90 }}
                                                  />
                                                </TableCell>
                                                <TableCell align="center">${fUSPrice(installSubTotal)}</TableCell>
                                                <TableCell align="center">${fUSPrice(productTotal)}</TableCell>
                                              <TableCell align="center" sx={DESIGN_ORDER_ROW_ACTIONS_CELL_SX}>
                                                <Box sx={DESIGN_ORDER_ROW_ACTIONS_BOX_SX}>
                                                  <Box sx={DESIGN_ORDER_ROW_ACTIONS_LEADING_SLOT_SX} />
                                                  <IconButton
                                                    color="error"
                                                    // disabled={
                                                    //   userTypeOriginal === 11 && row?.addedByUserType !== 11
                                                    // }
                                                    onClick={() => handleDeleteInstallCost(row.indexId)}
                                                  >
                                                    <Delete />
                                                  </IconButton>
                                                </Box>
                                                </TableCell>
                                              </TableRow>
                                            ) : null}
                                          </Fragment>
                                        )
                                      })}
                                      {droppableProvided.placeholder}
                                    </TableBody>
                                  )}
                                </Droppable>
                              </DragDropContext>
                            </Table>
                          </TableContainer>
                          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start' }}>
                            <Button variant="outlined" startIcon={<Icon icon={plusFill} />} onClick={addNewProductRow} sx={{ marginLeft: '20px' }}>
                              Add Row
                            </Button>
                         </Box>
                                <Typography variant="h6" align="right" sx={{ mt: 2, pr: 22 }}>
                                  Total Product Cost:{' '}
                                  ${fUSPrice(selectedProductsSubTotal?.toFixed(2))}
                                </Typography>
                            <Dialog
                            open={catalogPickerOpen}
                            onClose={() => {
                              setCatalogPickerOpen(false)
                              setCatalogPickerRowIndexId(null)
                              setCatalogPickerDraft(null)
                            }}
                            maxWidth="md"
                            fullWidth
                            disableScrollLock
                          >
                            <DialogTitle>
                              {productRows.find((r) => r.indexId === catalogPickerRowIndexId)?.catalogProduct
                                ? 'Change Catalog Product'
                                : 'Select Catalog Product'}
                            </DialogTitle>
                            <DialogContent>
                              <Stack spacing={2} sx={{ mt: 1 }}>
                                <Autocomplete
                                  options={filteredProducts}
                                  value={catalogPickerDraft}
                                  onChange={(event, newValue) => setCatalogPickerDraft(newValue)}
                                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                  renderInput={(params) => (
                                    <TextField {...params} required label="Select a product" />
                                  )}
                                  renderOption={(props, option) => {
                                    const { style, ...liProps } = props
                                    const suffix = getCatalogProductSuffix(option)
                                    return (
                                      <li {...liProps} style={{ ...style, display: 'flex', alignItems: 'center' }}>
                                        <Tooltip title={`${option.description || ''} ${suffix}`}>
                                          <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {`${option?.name || ''} ${suffix}`}
                                          </span>
                                        </Tooltip>
                                      </li>
                                    )
                                  }}
                                  getOptionLabel={(option) => option?.name || ''}
                                />
                                <Autocomplete
                                  options={splitOrderCatalogTypes}
                                  value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                                  onChange={(event, newValue) => {
                                    const finalValue = newValue || splitOrderCatalogTypes.find((type) => type.id === 'all')
                                    setFieldValue('split_catalog_type', finalValue)
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} label="Catalog Type" placeholder="Select catalog type" />
                                  )}
                                  getOptionLabel={(option) => option.label}
                                />
                              </Stack>
                            </DialogContent>
                            <DialogActions>
                              <Button
                                onClick={() => {
                                  setCatalogPickerOpen(false)
                                  setCatalogPickerRowIndexId(null)
                                  setCatalogPickerDraft(null)
                                }}
                              >
                                Cancel
                              </Button>
                              <Button variant="contained" onClick={confirmCatalogPicker}>Confirm</Button>
                            </DialogActions>
                          </Dialog>
                          <Modal
                            open={Object.keys(openProductNote).some((k) => openProductNote[k])}
                            handleClose={() => {
                              const openKey = Object.keys(openProductNote).find((k) => openProductNote[k])
                              if (openKey) handleCloseNote(openKey)
                            }}
                          >
                            <Grid container spacing={3} sx={{ justifyContent: 'center', width: '100%' }}>
                              <Grid item xs={12}>
                                <Typography variant="h5" sx={{ mb: 2 }}>Note</Typography>
                                <TextField
                                  fullWidth
                                  multiline
                                  rows={4}
                                  size="medium"
                                  value={currentNote}
                                  onChange={handleNoteChange}
                                  error={!!noteError}
                                  inputProps={{ maxLength: MAX_CHARACTERS }}
                                  helperText={noteError || `${currentNote.length}/${MAX_CHARACTERS} characters`}
                                />
                              </Grid>
                              <Grid container justifyContent="center" alignItems="center">
                                <Grid item xs={12} md={4}>
                                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                    <LoadingButton
                                      variant="contained"
                                      onClick={() => {
                                        const openKey = Object.keys(openProductNote).find((k) => openProductNote[k])
                                        if (openKey) handleSaveNote(openKey)
                                      }}
                                      loading={isSavingNote}
                                      disabled={!currentNote.trim()}
                                    >
                                      Save
                                    </LoadingButton>
                                    <LoadingButton
                                      variant="outlined"
                                      color="error"
                                      onClick={() => {
                                        const openKey = Object.keys(openProductNote).find((k) => openProductNote[k])
                                        if (openKey) handleClearNote(openKey)
                                      }}
                                      loading={isClearingNote}
                                      disabled={!currentNote.trim()}
                                    >
                                      Clear
                                    </LoadingButton>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Modal>
                          {productRows.map((row) => (
                            <Dialog
                              key={`catalog-attachment-dialog-${row.indexId}`}
                              open={Boolean(openProductAttachment[row.indexId])}
                              onClose={() => handleCloseAttachment(row.indexId)}
                              maxWidth="md"
                              fullWidth
                              disableScrollLock
                            >
                              <DialogContent>
                                {renderProductAttachmentModalContent(row.indexId)}
                              </DialogContent>
                              <DialogActions>
                                <Button onClick={() => handleCloseAttachment(row.indexId)}>Close</Button>
                              </DialogActions>
                            </Dialog>
                          ))}
                          </>
                        )}

                        {(userType !== 3 && !isClient) && (
                          <>
                            <Stack direction="row">
                              <LabelStyleHead>Services</LabelStyleHead>
                            </Stack>

                            <Stack
                              direction={{ xs: 'column', sm: 'row' }}
                              spacing={{ xs: 3, sm: 2 }}
                            >
                              <Autocomplete
                                sx={{ width: 400 }}
                                multiple
                                id="combo-box-demo"
                                options={
                                  [...(filteredServices || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
                                }
                                // value={additionalSelectedServices}
                                value={
                                  filteredServices?.filter((service) =>
                                    additionalSelectedServices?.some(
                                      (selected) => selected.id === service.id,
                                    ),
                                  ) || []
                                }
                                onChange={(event, newValue) => {
                                  if (newValue) {
                                    setAdditionalSelectedServices((prev) => {
                                      const prevById = new Map(
                                        (prev || []).map((s) => [s.id, s]),
                                      )
                                      return newValue.map((s) => ({
                                        ...s,
                                        addedByUserType:
                                          prevById.get(s.id)?.addedByUserType ??
                                          s.addedByUserType ??
                                          userType,
                                      }))
                                    })
                                    if (newValue.length > 0) {
                                      fetchAllProjectMembers(newValue)
                                    } else {
                                      setDesigners([])
                                    }
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    required
                                    error={Boolean(
                                      touched.services && errors.services,
                                    )}
                                    helperText={
                                      touched.services && errors.services
                                    }
                                    label="Select services"
                                  />
                                )}
                                getOptionLabel={(option) =>
                                  option.name ? option.name : ''
                                }
                              />
                              {membersLoading ? (
                                <Stack
                                  flexDirection={'row'}
                                  alignItems="center"
                                  justifyContent="center"
                                  gap={2}
                                >
                                  <CircularProgress
                                    color="primary"
                                    variant="indeterminate"
                                  />
                                  <Typography variant="body2">
                                    Loading Designers...
                                  </Typography>
                                </Stack>
                              ) : (
                                <Autocomplete
                                  sx={{ width: '50%' }}
                                  multiple
                                  id="designer-autocomplete"
                                  options={
                                    [...(filteredMembers || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
                                  }
                                  value={designers}
                                  onChange={(event, newValue) => {
                                    setDesigners(newValue)
                                  }}
                                  // isOptionEqualToValue={(option, value) => option.id === value.id}
                                  isOptionEqualToValue={(option, value) =>
                                    option.user_id === value.user_id
                                  }
                                  getOptionLabel={(option) => option.name || ''}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      required
                                      label="Choose Designer"
                                      error={Boolean(
                                        touched.services && errors.services,
                                      )}
                                      helperText={
                                        touched.services && errors.services
                                      }
                                    />
                                  )}
                                />
                              )}
                            </Stack>


                          {/* <Stack
                              direction={{ xs: 'column', sm: 'row' }}
                              spacing={{ xs: 3, sm: 2 }}
                            >
                            <FormControlLabel
                              control={
                                <Switch
                                  color="primary"
                                  checked={values.designer_email_sent}
                                  onChange={(event) => setFieldValue('designer_email_sent', event.target.checked ? 1 : 0)}
                                />
                              }
                              label="Send email to designers"
                            />
                            <FormControlLabel
                              control={
                                <Switch
                                  color="primary"
                                  checked={values.designer_sms_sent}
                                  onChange={(event) => setFieldValue('designer_sms_sent', event.target.checked ? 1 : 0)}
                                />
                              }
                              label="Send sms to designers"
                            />
                          </Stack> */}
                            <LabelStyle>Selected services</LabelStyle>

                            <Scrollbar>
                              <TableContainer sx={{ minWidth: 500 }}>
                                <Table>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell padding="checkbox" sx={{ width: 40 }} />
                                      {VALUE_SERVICES?.map((val) =>
                                        // ((values.project_categories?.name == 'Time & Material') && val.id === 6) ? <TableCell></TableCell> :
                                        (values.project_categories?.name ==
                                          'Service only' ||
                                          values.project_categories?.name ==
                                            'Time & Material') &&
                                        val.id === 0 ? null : ( //  || ((values.project_categories?.name !== 'Service only') && val.id === 6)
                                          <TableCell>{val.value}</TableCell>
                                        ),
                                      )}
                                    </TableRow>
                                  </TableHead>
                                  <DragDropContext onDragEnd={handleServiceTableDragEnd}>
                                    <Droppable droppableId="view-design-order-service-rows">
                                      {(droppableProvided) => (
                                  <TableBody
                                    ref={droppableProvided.innerRef}
                                    {...droppableProvided.droppableProps}
                                  >
                                    {[...(memoizedRows || [])]
                                      .sort(
                                        (a, b) =>
                                          (Number(a?.newIndexId ?? a?.indexId ?? a?.product_index) || 0) -
                                          (Number(b?.newIndexId ?? b?.indexId ?? b?.product_index) || 0),
                                      )
                                      .map((data, index) => {
                                        console.log('data...............', data)
                                      const serviceLineKey = getServiceLineKey(data);
                                      // const quantityFieldName = `service_quantity_${index}`;
                                      // const dataQuantity = data?.quantity ? data?.quantity : 1;
                                      // data['quantity'] = dataQuantity
                                      // const total = data.total_cost * data?.quantity
                                      // let markup = 0;
                                      // if (total > 0) {
                                      //   markup = data.total_cost / Number(total);
                                      //   data['markup'] = markup?.toFixed(2);
                                      // } else {
                                      //   markup = 0
                                      //   data['markup'] = 0;
                                      // }
                                      // totalServiceMarkup += markup

                                      // let originalMarkup = data.originalMarkup || 0
                                      // originaltotalServiceMarkup += originalMarkup
                                      // data['total'] = total?.toFixed(2)
                                      // data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                      // values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                      // const quantityDifference = Number(data.quantity)
                                      // data['quantityDifference'] = quantityDifference
                                      // data['jobcost_unit_cost'] = data.cost
                                      // data['jobcost_quantity'] = quantityDifference
                                      // data['jobcost_total_cost'] = (data.cost*Number(data.quantity) || 1)?.toFixed(2)

                                      // let newTotalCost = total?.toFixed(2)
                                      // let newTotalProductFormula = (data.cost*quantityDifference)?.toFixed(2)
                                      // totalProductFormula += Number(newTotalProductFormula)
                                      // totalWholesalePrice += Number(newTotalCost)
                                      // totalRetailPrice += Number(newTotalCost)
                                      // values['totalProductFormula'] = totalProductFormula
                                      // values['totalWholesalePrice'] = totalWholesalePrice
                                      // values['totalRetailPrice'] = totalRetailPrice

                                      return (
                                        <Draggable
                                          key={`service-${serviceLineKey}`}
                                          draggableId={`service-${serviceLineKey}`}
                                          index={index}
                                        >
                                          {(provided, snapshot) => (
                                        <>
                                          <TableRow
                                            key={data.id}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            style={{
                                              ...provided.draggableProps.style,
                                              ...(snapshot.isDragging
                                                ? { backgroundColor: theme.palette.action.hover }
                                                : {}),
                                            }}
                                          >
                                            <TableCell
                                              padding="checkbox"
                                              {...provided.dragHandleProps}
                                              sx={{ width: 40, cursor: 'grab' }}
                                            >
                                              <DragIndicator fontSize="small" color="action" />
                                            </TableCell>
                                            {/* {(values.project_categories?.name != 'Service only' && values.project_categories?.name != 'Time & Material') ? (
                                            <TableCell></TableCell>
                                          ) : null} */}
                                            <TableCell>{data.name}</TableCell>
                                            {/* <TableCell>{originalMarkup?.toFixed(2)}</TableCell> */}
                                            <TableCell>
                                              {data.originalMarkup?.toFixed(2)}
                                            </TableCell>
                                            <TableCell>{data.cost}</TableCell>
                                            <TableCell>
                                              {data.total_cost}
                                            </TableCell>
                                            <TableCell>
                                              <TextField
                                                type="number"
                                                // sx={{ width: 400 }}
                                                label={'Hours'}
                                                value={
                                                  Number(data.quantity) || 1
                                                }
                                                defaultValue={1}
                                                onFocus={selectInputValue}
                                                onClick={selectInputValue}
                                                onChange={(event) => {
                                                  let newValue =
                                                    event.target.value

                                                  if (
                                                    newValue.startsWith('-')
                                                  ) {
                                                    newValue = newValue.slice(1)
                                                  }
                                                  const normalizedQuantity = Number(newValue) || 1
                                                  data['quantity'] =
                                                    normalizedQuantity

                                                  setAdditionalSelectedServices(
                                                    (prevServices) =>
                                                      prevServices.map(
                                                        (service) =>
                                                          service.id === data.id
                                                            ? {
                                                                ...service,
                                                                quantity:
                                                                  normalizedQuantity,
                                                              } // Update quantity for the matching service
                                                            : service, // Keep other services unchanged
                                                      ),
                                                  )
                                                }}
                                              />
                                            </TableCell>
                                            {/*                                                                    
                                            <TableCell>
                                              <IconButton
                                                onClick={() => {
                                                  setServiceOnlyLocationStates({ ...serviceOnlyLocationStates, [data.indexId]: true });
                                                }}
                                              >
                                                <LocationOn sx={{
                                                  color: data?.addresses?.some(obj =>
                                                    Object.values(obj).some(value => value === '')
                                                  ) ? '' : theme.palette.primary.main
                                                }} />
                                              </IconButton>
                                            </TableCell> */}
                                            {/* ) : null} */}
                                            <TableCell>
                                              {(
                                                data.cost *
                                                data.quantityDifference?.toFixed(
                                                  2,
                                                )
                                              )?.toFixed(2)}
                                            </TableCell>
                                            {/* <TableCell>{(data.cost*quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell> */}
                                            <TableCell>{data?.total}</TableCell>
                                            <TableCell>${fUSPrice(data?.total)}</TableCell>
                                            <TableCell align="right">
                                              <IconButton
                                                onClick={() =>
                                                  handleDeleteService(data.id)
                                                }
                                                color="error"
                                                  // disabled={
                                                  //   Number(userTypeOriginal) === 11 &&
                                                  //   Number(data?.addedByUserType) !== 11
                                                // }
                                              >
                                                <Delete />
                                              </IconButton>
                                            </TableCell>
                                          </TableRow>
                                        </>
                                          )}
                                        </Draggable>
                                      );
                                    })}
                                    {droppableProvided.placeholder}
                                    <TableRow>
                                      <TableCell colSpan={8}>
                                        <Typography variant="h6" align="right">
                                          Total Additional Service Cost:{' '}
                                          ${fUSPrice(selectedServicesSubTotal?.toFixed(2))}
                                        </Typography>
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                      )}
                                    </Droppable>
                                  </DragDropContext>
                                </Table>
                              </TableContainer>
                            </Scrollbar>
                          </>
                        )}
                        <Divider />

                        <LabelStyle>Notes</LabelStyle>
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          maxRows={7}
                          label="Notes"
                          name="notes"
                          value={orderTextFields.notes}
                          onChange={(e) =>
                            setOrderTextFields((prev) => ({
                              ...prev,
                              notes: e.target.value,
                            }))
                          }
                          helperText={`${orderTextFields.notes?.length || 0}/${MAX_CHARACTERS} characters`}
                          inputProps={{
                            maxLength: MAX_CHARACTERS,
                          }}
                          InputProps={{
                            sx: {
                              color: 'error.main',
                            },
                          }}
                        />
                        {(userType !== 3 && !isClient) && (
                          <Typography variant="h6" align="right">
                            Total Cost: {fUSPrice(selectedProductsAndServicesSubTotal || 0)}
                          </Typography>
                        )}
                        <Stack
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={{ xs: 3, sm: 2 }}
                        >
                          {/* <FormControlLabel
                          control={
                            <Switch
                            {...getFieldProps('client_approve')}
                              color="primary"
                              checked={values.client_approve}
                              onChange={(event) => setFieldValue('client_approve', event.target.checked)}
                            />
                          }
                          labelPlacement="end"
                          label="Enable forClient  Approval"
                          sx={{ mt: 0 }}
                        /> */}
                        </Stack>

                        {/* <Stack
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={{ xs: 3, sm: 2 }}
                        >
                          <FormControlLabel
                            onChange={() => {
                              // Toggle the value of welcome_message using setCurrentRFQdata
                              setCurrentRFQdata((prevData) => ({
                                ...prevData,
                                welcome_message: !prevData.welcome_message,
                              }))
                            }}
                            control={
                              <Switch
                                {...getFieldProps('welcome_message')}
                                color="primary"
                                checked={values.welcome_message == 1}
                              />
                            }
                            labelPlacement="end"
                            label="Use Custom Welcome Message"
                            sx={{ mt: 5 }}
                          />
                        </Stack>
                        {values.welcome_message == true && (
                          <>
                            <Stack>
                              <LabelStyle>Subject</LabelStyle>
                              <TextField
                                //   fullWidth
                                type="text"
                                sx={{ width: 400 }}
                                defaultValue={values.subject}
                                {...getFieldProps('subject')}
                                error={Boolean(
                                  touched.subject && errors.subject,
                                )}
                                helperText={touched.subject && errors.subject}
                              />
                            </Stack>
                            <LabelStyle>Email Content</LabelStyle>
                            <TextField
                              fullWidth
                              multiline
                              minRows={3}
                              maxRows={7}
                              label="Email Content"
                              defaultValue={values.email_content}
                              {...getFieldProps('email_content')}
                              error={Boolean(
                                touched.email_content && errors.email_content,
                              )}
                              helperText={
                                touched.email_content && errors.email_content
                              }
                            />
                          </>
                        )}
                        <LabelStyle>Request state</LabelStyle>
                        <Typography>
                          While in draft mode, clients you add to request tasks
                          won't be notified
                        </Typography>
                        <FormControlLabel
                          onChange={() => {
                            setCurrentRFQdata((prevData) => ({
                              ...prevData,
                              draft: !prevData.draft,
                            }))
                          }}
                          control={
                            <Switch
                              {...getFieldProps('draft')}
                              color="primary"
                              checked={values.draft}
                            />
                          }
                          labelPlacement="end"
                          label="Draft"
                          sx={{ mt: 5 }}
                        /> */}
                        </Stack>
                      )}

                      {/* Design Forms Tab */}
                      {editTab === 1 && (
                        <Stack spacing={3}>
                          {isLoadingFormData ? (
                            <Box sx={{ textAlign: 'center', py: 3 }}>
                              <CircularProgress />
                              <Typography variant="body2" sx={{ mt: 2 }}>
                                Loading form data...
                              </Typography>
                            </Box>
                          ) : id ? (
                            <Box>
                              <DesignFormTabs
                                designOrderId={id}
                                savedFormData={savedDesignFormData}
                                onFormDataChange={(formData) => {
                                  // Store form data when user clicks "Save Form" button or makes changes
                                  setSavedDesignFormData(formData);
                                }}
                              />
                            </Box>
                          ) : (
                            <Box sx={{ textAlign: 'center', py: 3 }}>
                              <Typography variant="body2" color="text.secondary">
                                Design order ID is required
                              </Typography>
                            </Box>
                          )}
                        </Stack>
                      )}

                      {/* Common Save/Cancel Buttons for both tabs */}
                      <Box
                        sx={{
                          mt: 3,
                          display: 'flex',
                          justifyContent: 'flex-end',
                          gap: 1,
                        }}
                      >
                        {progress != null && progress < 100 ? (
                          <CircularProgress
                            color="primary"
                            variant="determinate"
                            value={progress}
                          />
                        ) : (
                          <>
                            <LoadingButton
                              type="submit"
                              variant="contained"
                              loading={isSubmitting}
                              disabled={isSavingDraft}
                            >
                              Save Order
                            </LoadingButton>
                            <LoadingButton
                              type="button"
                              variant="outlined"
                              loading={isSavingDraft}
                              disabled={isSubmitting}
                              onClick={handleSaveDraft}
                            >
                              Save as Draft
                            </LoadingButton>
                            <Button
                              variant="outlined"
                              onClick={() => handleCancel()}
                            >
                              Cancel
                            </Button>
                          </>
                        )}
                      </Box>
                    </Card>
                  </Grid>
                </Grid>
              </Form>
            </FormikProvider>
          )}
          {!openEdit && (
            <>
              <Stack
                direction={'row'}
                display={'flex'}
                alignItems={'center'}
                spacing={{ xs: 3, sm: 2 }}
              >
                {details?.id &&
                  invoice?.total !== 0 &&
                  !user.isVendor &&
                  (empty(details?.installation_acceptance) &&
                  !empty(details?.allInstallationCompleted) ? (
                    <AnimatedButton
                      title={'Details'}
                      onClick={() => setOpenInvoice(!openInvoice)}
                    />
                  ) : details?.status === 1 &&
                    designs?.length > 0 &&
                    details?.send_client_app_req == 1 ? (
                    <Badge badgeContent={'1'} color={'warning'}>
                      <AnimatedButton
                        title={'Details'}
                        onClick={() => setOpenInvoice(!openInvoice)}
                      />
                    </Badge>
                  ) : (
                    <AnimatedButton
                      title={'Details'}
                      onClick={() => setOpenInvoice(!openInvoice)}
                    />
                  ))}
                {/* BACKUP: previous Details link UI (replaced with AnimatedButton to match Estimate) */}
                {/* {details?.id &&
                  invoice?.total !== 0 &&
                  !user.isVendor &&
                  (empty(details?.installation_acceptance) &&
                  !empty(details?.allInstallationCompleted) ? (
                    <AnimatedButton
                      title={'Details'}
                      onClick={() => setOpenInvoice(!openInvoice)}
                    />
                  ) : (
                    <Link
                      color={theme.palette.success.dark}
                      onClick={() => setOpenInvoice(!openInvoice)}
                      // component={RouterLink}
                      to={''}
                    >
                      {details?.status === 1 &&
                      designs?.length > 0 &&
                      details?.send_client_app_req == 1 ? (
                        <Badge badgeContent={'1'} color={'warning'}>
                          <Typography fontSize={'1.09rem'} variant="overline">
                            <span style={{ textDecoration: 'underline' }}>
                              Details
                            </span>
                          </Typography>
                        </Badge>
                      ) : (
                        <Typography fontSize={'1.09rem'} variant="overline">
                          Details
                        </Typography>
                      )}
                    </Link>
                  ))} */}
                <Typography fontWeight={'0.09rem'} variant="overline">
                  <Label
                    sx={{ p: '12px' }}
                    variant={
                      theme.palette.mode === 'light' ? 'ghost' : 'filled'
                    }
                    color={
                      getStatusColorAndLabel(details?.status, details?.hold, details?.design_order_job_status, details?.send_client_app_req, designs, details?.is_from_client, details?.is_in_queue, details?.is_closed)
                        .color
                    }
                  >
                    {
                      getStatusColorAndLabel(details?.status, details?.hold, details?.design_order_job_status, details?.send_client_app_req, designs, details?.is_from_client, details?.is_in_queue, details?.is_closed)
                        .label
                    }
                  </Label>
                </Typography>

                {accessForSendDesignOrderToClient &&
                details?.send_client_app_req == 0 &&
                designs?.length > 0 &&
                details.status === 1 &&
                details.design_order_job_status === 3 &&
                details?.hold !== 1 &&
                initialSelectedServices?.length > 0 ? (
                  <Stack direction={'row'} alignItems={'center'} spacing={2}>
                    <Button
                      variant="contained"
                      // onClick={handleSendClientApproveReq}
                      onClick={() => setOpenDesignSelect(true)}
                    >
                      Send For Client Approval
                    </Button>
                    <Button
                      size="medium"
                      variant="outlined"
                      onClick={() => setRejectInvoice(true)}
                      sx={{ color: theme.palette.error.main }}
                    >
                      Reject
                    </Button>
                  </Stack>
                ) : (
                  ''
                )}

                {accessForApproveDesignOrderForClient &&
                userType !== 3 && !isClient &&
                details?.send_client_app_req == 1 &&
                designs?.length > 0 &&
                details?.hold !== 1 &&
                !(details?.status == 2 || details?.status == 3 || details?.status == 6) ? (
                  <Stack direction={'row'} alignItems={'center'} spacing={2}>
                    <Button
                      size="medium"
                      type="submit"
                      variant="contained"
                      onClick={() => setConfirmInvoice(true)}
                    >
                      Approve For Client
                    </Button>
                    <Button
                      size="medium"
                      variant="outlined"
                      onClick={() => setRejectInvoice(true)}
                      sx={{ color: theme.palette.error.main }}
                    >
                      Reject
                    </Button>
                  </Stack>
                ) : (
                  ''
                )}

                {(userType == 3 || isClient) &&
                designs?.length > 0 &&
                details?.hold !== 1 &&
                details?.send_client_app_req == 1
                  ? !(
                      details?.status == 2 ||
                      details?.status == 3 ||
                      details?.status == 6
                    ) && (
                      // &&
                      // (details?.design_order_job_status == 3)
                      <Box>
                      <Button
                        size="medium"
                        type="submit"
                        variant="contained"
                        sx={{ mr:1 }}
                        onClick={() => setConfirmInvoice(true)}
                      >
                        Approve
                      </Button>
                      <Button
                        size="medium"
                        variant="outlined"
                        onClick={() => setRejectInvoice(true)}
                        sx={{ color: theme.palette.error.main }}
                      >
                        Reject
                      </Button>
                      </Box>
                    )
                  : ''}

                  {(details?.status === 1 || details?.status === 6) && (userType !== 3 && !isClient) ?
                    <Stack
                      direction={'row'} alignItems={'center'} spacing={1}
                    >
                      <Button
                        onClick={() => {
                          setOpenHoldPopup(true)
                        }}
                        sx={{
                          borderRadius: 20,
                          backgroundColor: theme.palette.warning.main,
                          color: 'black',
                          boxShadow: 'none',
                          '&:hover': {
                            backgroundColor: theme.palette.warning.dark,
                            boxShadow: 'none',
                          },
                        }}
                        variant="contained"
                      >
                        {details?.hold === 0
                          ? 'Move to Hold'
                          : 'Release from Hold'}
                      </Button>
                      {isAwaitingApprovalDesignOrder ? (
                        <LoadingButton
                          variant="contained"
                          loading={isClosingDesignOrder}
                          onClick={() => setOpenCloseConfirm(true)}
                          sx={{
                            borderRadius: 20,
                            backgroundColor: theme.palette.error.main,
                            color: theme.palette.common.white,
                            boxShadow: 'none',
                            '&:hover': {
                              backgroundColor: theme.palette.error.dark,
                              boxShadow: 'none',
                            },
                          }}
                        >
                          Close 
                        </LoadingButton>
                      ) : ''}
                    </Stack> : ''
                  }

                  {(details?.status === 3 || details?.status === 2) && (userType !== 3 && !isClient) &&
                  (details?.old_design_order_id == null || details?.old_design_order_id !== null) ? (
                    <Stack direction={'row'} alignItems={'center'} spacing={1}>
                      <LoadingButton
                        variant="contained"
                        loading={isDuplicatingDesignOrder}
                        onClick={handleOpenReopenDesignOrderDuplicate}
                        sx={{
                          borderRadius: 20,
                          boxShadow: 'none',
                        }}
                      >
                        Reopen
                      </LoadingButton>
                    </Stack>
                  ) : ''}
                     {/* button for desing order duplication */}
                    <Stack direction={'row'} alignItems={'center'} spacing={1}>
                      <LoadingButton
                        variant="contained"
                        color="info"
                        loading={isDuplicatingDesignOrder}
                        onClick={handleOpenDesignOrderDuplicate}
                        sx={{
                          borderRadius: 20,
                          boxShadow: 'none',
                        }}
                      >
                        DUPLICATE
                      </LoadingButton>
                    </Stack>
              </Stack>

              <Grid container spacing={3}>
                <Grid sx={{ mt: 3 }} item xs={12} md={12}>
                  <Stack spacing={3}>
                    <Stack spacing={5}>
                      <Tabs
                        value={currentTab}
                        scrollButtons="auto"
                        variant="scrollable"
                        allowScrollButtonsMobile
                        onChange={handleChangeTab}
                      >
                        {ACCOUNT_TABS.map((tab) => (
                          <Tab
                            disableRipple
                            key={tab.value}
                            label={
                              <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
                                {capitalCase(tab.value)}
                                {tab.value === 'Design Notes' && designNotesHasNew && (
                                  <SalesOrderNewBadgeList>NEW</SalesOrderNewBadgeList>
                                )}
                              </Box>
                            }
                            value={tab.value}
                            sx={{
                              fontWeight:500
                            }}
                          />
                        ))}
                      </Tabs>

                      {ACCOUNT_TABS.map((tab) => {
                        const isMatched = tab.value === currentTab
                        return (
                          isMatched && (
                            <Box key={tab.value}>{tab.component}</Box>
                          )
                        )
                      })}
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </>
          )}
          {/* invoice modal */}
          <Modal
            modalTitle={'Order Details'}
            open={openInvoice === true}
            handleClose={() => setOpenInvoice(false)}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row', md: 'column' }}
              spacing={{ xs: 3, sm: 2 }}
            >
              <Stack
                direction="row"
                justifyContent={'flex-end'}
                alignItems="center"
                spacing={1}
              >
                {/* <ReactToPrint
                  trigger={() => (
                    <Button>
                      {' '}
                      <Print />
                      Print A3
                    </Button>
                  )}
                  content={() => componentRef.current}
                  copyStyles={false}
                  pageStyle={`
                    @media print {
                      body {
                        font-size: 12pt;
                      }
                      table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-bottom: 10px;
                      }

                      th, td {
                        border: 1px solid #ddd;
                        padding: 5px;
                        text-align: left;
                      }
                      #right {
                        text-align: right;
                        margin-top: -200px; 
                      }
                      #total {
                        text-align: right;
                        display:flex;
                        justify-content: flex-end;
                      }
                      #subtotal {
                        text-align: left;
                        
                      }
                      #discount {
                        text-align: left;
                        word-wrap: break-word;
                        margin-right: 100px;
                    }
                    
                      #totalmain {
                        text-align: left;
                        
                      }
                      #subtotal1 {
                        text-align: left;
                        
                      }
                      #discount1 {
                        text-align: left;
                        word-wrap: break-word;
                        margin-right: 30px;
                    }
                    
                      #totalmain1 {
                        text-align: left;
                        
                      }
                      #total1 {
                        text-align: right;
                        display:flex;
                        justify-content: flex-end;
                        margin-top: -220px; 
                        
                      }
                      #logoImage {
                        height: 100px;
                        width:100px;
                      }
                      #order{
                        margin-bottom:-20px
                      }
                      #title{
                        margin-bottom:-20px
                      }
                      #orderID {
                        margin-bottom:-20px
                      }
                      #to {
                        margin-bottom:-20px
                      }
                      
                    }
                  `}
                /> */}
                {(details?.status === 4 || details?.status === 3) &&
                  SEND_EMAIL && (
                    <Button onClick={handleSendEmail}>Send Email</Button>
                  )}
                {(userType !== 3 && !isClient) && (
                  <Tooltip title="Send Design Order PDF via Email">
                    <IconButton
                      onClick={handleSendDesignOrderInvoiceEmail}
                      color="primary"
                      sx={{
                        backgroundColor: (t) => t.palette.primary.main,
                        color: (t) => t.palette.primary.contrastText,
                        '&:hover': { backgroundColor: (t) => t.palette.primary.dark },
                      }}
                    >
                      <Icon icon={emailFillIcon} width={24} height={24} />
                    </IconButton>
                  </Tooltip>
                )}
                <Box sx={{ ml: 2, position: 'relative', zIndex: 10 }}>
                  <AnimatedButton
                    title={invoicePreviewReady ? 'Print' : 'Loading...'}
                    startIcon={invoicePreviewReady ? <Print /> : <CircularProgress size={14} color="inherit" />}
                    size="small"
                    onClick={() => {
                      if (!invoicePreviewReady) return;
                      handlePrintDesignOrder();
                    }}
                  />
                </Box>
                <div style={{ display: 'none' }}>
                  <DesignOrderInvoicePage
                    invoiceDate={invoiceDate}
                    openInvoice={openInvoice}
                    details={designOrderInvoiceDetails}
                    invoice={designOrderInvoiceForPrint}
                    subTotal={designOrderInvoiceTotals.subtotal}
                    groupedInvoiceProductTotal={designOrderInvoiceTotals.productTotal}
                    groupedInvoiceInstallTotal={designOrderInvoiceTotals.installTotal}
                    ref={designOrderInvoicePrintRef}
                    additionalSelectedServices={designOrderInvoiceAdditionalServices}
                    cartService={[]}
                    invoiceSelectedServices={[]}
                    data={data}
                    labourInstallService={[]}
                    userType={userType}
                    hasViewCostPermission={hasViewCostPermission}
                    customerOrderProductGroups={designOrderProductGroups}
                    designOrderProducts={designOrderProducts}
                    markupType={markupType}
                    groupProductMarketingValues={groupProductMarketingValues}
                    groupInstallMarketingValues={groupInstallMarketingValues}
                  />
                </div>
                <div style={{ display: 'none' }}>
                  <PrintFunction
                    invoiceDate={invoiceDate}
                    openInvoice={openInvoice}
                    details={details}
                    invoice={invoice}
                    ref={componentRef}
                    data={data}
                  />
                </div>
              </Stack>
            </Stack>
            {!invoicePreviewReady ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 240, width: '100%' }}>
                <CircularProgress />
              </Box>
            ) : (
            <>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                  <Box
                    component="img"
                    alt="logo"
                    src={COMPANY_LOGO}
                    sx={{ height: 98 }}
                  />
                </Grid>
                <Typography variant="body2">
                  {data?.address}, {data?.city}, {data?.state}, {data?.zipcode}
                </Typography>
                {/* <Typography variant="body2">Telephone: +15208362947</Typography> */}
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                  <Typography variant="body2" sx={{ textTransform: 'uppercase', }}>Telephone: {(data?.phone_country_code || data?.phone) ? `+${data?.phone_country_code}${data?.phone}` : '951-682-9660'}</Typography>
                  <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>|</Typography>
                  <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.company_fax_number ? `Fax: ${data?.company_fax_number}` : ''}</Typography>
                </Box>
                <Typography variant="body2" sx={{ textTransform: 'uppercase' }}>{data?.company_mail}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                <Typography variant="body2">
                  Order date: {invoiceDate}
                </Typography>
                <Label
                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                  color={
                    getStatusColorAndLabel(details?.status, details?.hold, details?.design_order_job_status, details?.send_client_app_req, designs, details?.is_from_client, details?.is_in_queue, details?.is_closed).color
                  }
                >
                  {getStatusColorAndLabel(details?.status, details?.hold, details?.design_order_job_status, details?.send_client_app_req, designs, details?.is_from_client, details?.is_in_queue, details?.is_closed).label}
                </Label>
                {/* </Stack> */}
                <Typography variant="body2">
                  Order Name:{details?.name}
                </Typography>
                <Typography variant="body2">Order ID:{details?.id}</Typography>
                <Typography
                  paragraph
                  variant="overline"
                  sx={{ color: '#ffffff', marginTop: '20px' }}
                >
                  TO {invoice?.customer_name}
                </Typography>
                <Typography variant="body2">
                  {designOrderInvoiceForPrint?.customer_address || invoice?.customer_address || ''}
                </Typography>
                <Typography variant="body2">
                  Phone: {invoice?.customer_phone}
                </Typography>
              </Grid>
            </Grid>
            <DesignOrderInvoiceModalSection
              showHeader={false}
              showActionBar={false}
              invoiceDate={invoiceDate}
              openInvoice={openInvoice}
              details={designOrderInvoiceDetails}
              invoice={designOrderInvoiceForPrint}
              data={data}
              designOrderProducts={designOrderProducts}
              designOrderServices={initialSelectedServices || []}
              communities={communities}
              hasViewCostPermission={hasViewCostPermission}
              userType={userType}
              isClient={isClient}
              customerOrderProductGroups={designOrderProductGroups}
              markupType={markupType}
              groupProductMarketingValues={groupProductMarketingValues}
              groupInstallMarketingValues={groupInstallMarketingValues}
            />
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 3 }}>
              <Typography
                variant="subtitle1"
                sx={{ color: '#ffffff' }}
              >
                {/* {designs?.length > 0 ? "Designs" : "No designs uploaded"} */}
                {( (userType === 3 || isClient ) ? details?.send_client_app_req : designs?.length > 0 ) ? 'Designs' : 'No designs uploaded'}
              </Typography>
              {selectedDesignsInModal.length > 0 && (
                <Tooltip title={`Send ${selectedDesignsInModal.length} design${selectedDesignsInModal.length !== 1 ? 's' : ''} to email`}>
                  <Badge badgeContent={selectedDesignsInModal.length} color="error">
                    <IconButton
                      color="primary"
                      onClick={handleSendSelectedDesignsToEmailModal}
                      sx={{
                        backgroundColor: (theme) => theme.palette.primary.main,
                        color: (theme) => theme.palette.primary.contrastText,
                        '&:hover': {
                          backgroundColor: (theme) => theme.palette.primary.dark,
                        },
                      }}
                    >
                      <Icon icon={emailFillIcon} width={24} height={24} />
                    </IconButton>
                  </Badge>
                </Tooltip>
              )}
            </Stack>
            <Grid container spacing={2}>
              <Scrollbar>
                {/* {designs?.length > 0 ? ( */}
                {(
                 ( userType === 3 || isClient)
                    ? details?.send_client_app_req
                    : designs?.length > 0
                ) ? (
                  // <Box sx={{border: '0.1px solid', borderColor: borderColor,padding:2, }}>
                  //   <Scrollbar sx={{ width: '100%', height: 450 }}>
                  <ImageList
                    gap={mdd ? 8 : xld ? 12 : 8}
                    cols={mdd ? 3 : xld ? 3 : xs ? 1 : 3}
                  >
                    {filteredDesigns?.map((item) => {
                      const { file_type, name, url, extension, id } = item
                      if (item.approved !== 1 && isClient) return;
                      const _fileExt3 = (name || '').split('.').pop()?.split('?')[0]?.toLowerCase();
                      const isImage =
                        !['eps','ai','ps','psd'].includes(_fileExt3) &&
                        (file_type?.startsWith('image/') || file_type === 'img' || file_type === 'image') &&
                        !['eps','ai','ps','psd','x-eps','x-ai','postscript'].includes((file_type || '').replace('image/','').toLowerCase())
                      const isActualPdf = file_type === 'pdf' || file_type === 'application/pdf' || (name || '').toLowerCase().split('?')[0].endsWith('.pdf')
                      const isPdf = !isImage
                      const isSelected = selectedDesignsInModal?.includes(id);
                      const handleToggle = () => {
                        setSelectedDesignsInModal((prev) =>
                          isSelected ? prev?.filter((n) => n !== id) : [...prev, id],
                        )
                      }
                      return (
                        <ImageListItem key={item.name} sx={{ position: 'relative' }}>
                          <Box position="relative">
                            <Checkbox
                              checked={isSelected}
                              onChange={handleToggle}
                              onClick={(e) => e.stopPropagation()}
                              sx={{
                                position: 'absolute',
                                top: 8,
                                left: 8,
                                zIndex: 10,
                                color: 'black',
                                backgroundColor: theme.palette.grey.A700,
                                boxShadow: 1
                              }}
                            />
                            {isImage ? (
                              <img
                                srcSet={`${item.name}?w=240&h=240&fit=crop&auto=format&dpr=2 2x`}
                                src={`${item.name}?w=240&h=240&fit=crop&auto=format`}
                                alt={item.title}
                                loading="lazy"
                                style={{ width: '240px', height: '240px' }}
                              />
                            ) : (
                              <Box display="flex" alignItems="center">
                                {/* Icon Button */}
                                <Tooltip title={isActualPdf ? "View PDF" : "View File"}>
                                  <IconButton
                                    onClick={() => {
                                      setPdfLoading(true)
                                      setSelectedPDF(name)
                                      setSelectedPDFItem(item)
                                      setOpenPDFModal(true)
                                      setUseOfficeViewer(true); // Reset to try Office viewer first
                                    }}
                                    aria-label="open file"
                                    sx={{
                                      position: 'absolute',
                                      top: 60,
                                      right: '50%',
                                      zIndex: 200,
                                      color: theme.palette.error.main,
                                      backgroundColor: theme.palette.text.primary,
                                    }}
                                  >
                                    {isActualPdf ? <PictureAsPdf style={{ fontSize: 40 }} /> : <Description style={{ fontSize: 40 }} />}
                                  </IconButton>
                                </Tooltip>

                                {/* Thumbnail: PDF gets iframe preview, other files get a file icon */}
                                {isActualPdf ? (
                                  <iframe
                                    src={name}
                                    title={name}
                                    style={{ width: '240px', height: '240px' }}
                                    frameBorder="0"
                                  />
                                ) : (() => {
                                  const fileName = name?.split('/').pop()?.split('?')[0] || 'File';
                                  const fileExt = fileName.split('.').pop()?.toLowerCase();
                                  const isOfficeFile = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);
                                  // Formats natively renderable in browser
                                  const isBrowserRenderable = ['svg','txt','html','htm'].includes(fileExt);
                                  // Formats renderable via Google Docs Viewer (includes eps, ai, psd, tiff, etc.)
                                  const googleViewerSupportedExt = ['eps','ai','psd','tif','tiff','bmp','ps'];
                                  const canUseGoogleViewer = !isOfficeFile && !isBrowserRenderable && googleViewerSupportedExt.includes(fileExt);
                                  const googleViewerThumbSrc = `https://docs.google.com/gview?url=${encodeURIComponent(name)}&embedded=true`;
                                  
                                  if (isOfficeFile) {
                                    return (
                                      <iframe
                                        src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(name)}`}
                                        title={fileName}
                                        style={{ width: '240px', height: '240px', borderRadius: '4px' }}
                                        frameBorder="0"
                                      />
                                    );
                                  }

                                  if (isBrowserRenderable) {
                                    return (
                                      <iframe
                                        src={name}
                                        title={fileName}
                                        style={{ width: '240px', height: '240px', borderRadius: '4px', pointerEvents: 'none' }}
                                        frameBorder="0"
                                      />
                                    );
                                  }

                                  if (canUseGoogleViewer) {
                                    return (
                                      <Box sx={{ position: 'relative', width: '240px', height: '240px' }}>
                                        <iframe
                                          src={googleViewerThumbSrc}
                                          title={fileName}
                                          style={{ width: '100%', height: '100%', borderRadius: '4px', pointerEvents: 'none', border: 'none' }}
                                          frameBorder="0"
                                         sandbox="allow-scripts allow-same-origin" />
                                        {/* Extension badge overlay */}
                                        <Box sx={{
                                          position: 'absolute', bottom: 6, left: '50%', transform: 'translateX(-50%)',
                                          backgroundColor: 'rgba(0,0,0,0.65)', borderRadius: '4px', px: 1, py: 0.25,
                                          pointerEvents: 'none'
                                        }}>
                                          <Typography variant="caption" sx={{ color: '#fff', fontWeight: 'bold', textTransform: 'uppercase', fontSize: 10 }}>
                                            .{fileExt}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    );
                                  }

                                  return (
                                    <Box
                                      sx={{
                                        width: '240px',
                                        height: '240px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: 'rgba(255,255,255,0.05)',
                                        borderRadius: 1,
                                        border: '1px dashed rgba(255,255,255,0.2)',
                                        gap: 1,
                                      }}
                                    >
                                      <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <Description style={{ fontSize: 60, color: theme.palette.text.secondary }} />
                                        <Box sx={{
                                          position: 'absolute',
                                          bottom: 10,
                                          backgroundColor: theme.palette.primary.main,
                                          borderRadius: '3px',
                                          px: 0.6,
                                          py: 0.1,
                                        }}>
                                          <Typography variant="caption" sx={{ color: '#fff', fontWeight: 'bold', textTransform: 'uppercase', fontSize: 9, lineHeight: 1 }}>
                                            {fileExt || 'file'}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Typography variant="caption" sx={{ color: theme.palette.text.secondary, textAlign: 'center', px: 1, wordBreak: 'break-all' }}>
                                        {fileName}
                                      </Typography>
                                    </Box>
                                  );
                                })()}


                                <DialogAnimate
                                  open={openPDFModal}
                                  onClose={() => setOpenPDFModal(false)}
                                >
                                  <Card className={classes.dialogContent}>
                                    <div style={{width:'90%', display:'flex',justifyContent:'space-between', marginBottom: '15px',marginLeft:'25px' }}>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          onClick={() => handleSendCurrentItemToEmailModal(selectedPDFItem)}
                                          disabled={!selectedPDFItem}
                                          startIcon={<Icon icon={emailFillIcon} width={20} height={20} />}
                                          sx={{
                                            fontSize:'14px'
                                          }}
                                        >
                                          Send to Email
                                        </Button>
                                        <Button
                                          variant="outlined"
                                          color="primary"
                                          onClick={() => {
                                            // Extract file extension and name
                                            const fileName = selectedPDF?.split('/').pop()?.split('?')[0] || 'File';
                                            const fileExt = fileName.split('.').pop()?.toLowerCase();
                                            const isOfficeFile = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);

                                            // Create new window for viewing
                                            const newWindow = window.open('', '_blank');

                                            if (isActualPdf) {
                                              // PDF viewer with toolbar hidden
                                              newWindow.document.write(`
                                                <html>
                                                  <head>
                                                    <title>PDF Viewer</title>
                                                    <style>
                                                      body { margin: 0; padding: 0; overflow: hidden; }
                                                      iframe { width: 100vw; height: 100vh; border: none; }
                                                    </style>
                                                  </head>
                                                  <body>
                                                    <iframe src="${selectedPDF}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
                                                  </body>
                                                </html>
                                              `);
                                            } else if (isOfficeFile) {
                                              // Microsoft Office Online Viewer for Office files - prevents download
                                              const officeViewerSrc = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(selectedPDF)}`;
                                              newWindow.document.write(`
                                                <html>
                                                  <head>
                                                    <title>${fileName}</title>
                                                    <style>
                                                      body { margin: 0; padding: 0; overflow: hidden; }
                                                      iframe { width: 100vw; height: 100vh; border: none; }
                                                    </style>
                                                  </head>
                                                  <body>
                                                    <iframe src="${officeViewerSrc}" title="${fileName}"></iframe>
                                                  </body>
                                                </html>
                                              `);
                                            } else {
                                              // Google Docs Viewer as fallback for other file types - works for many formats
                                              const googleViewerSrc = `https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true`;
                                              newWindow.document.write(`
                                                <html>
                                                  <head>
                                                    <title>${fileName}</title>
                                                    <style>
                                                      body { margin: 0; padding: 0; overflow: hidden; }
                                                      iframe { width: 100vw; height: 100vh; border: none; }
                                                    </style>
                                                  </head>
                                                  <body>
                                                    <iframe src="${googleViewerSrc}" title="${fileName}" sandbox="allow-scripts allow-same-origin"></iframe>
                                                  </body>
                                                </html>
                                              `);
                                            }
                                            newWindow.document.close();
                                          }}
                                          disabled={!selectedPDF}
                                          startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                                          sx={{
                                            fontSize:'14px'
                                          }}
                                        >
                                          View File
                                        </Button>
                                    </div>
                                    {pdfLoading && (
                                      <Skeleton
                                        variant="rectangular"
                                        width="100%"
                                        height={500}
                                      />
                                    )}

                                    {(isClient || userType === 3) && useOfficeViewer ? (
                                      <iframe
                                        src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
                                        title="Selected PDF"
                                        width="100%"
                                        height="500px"
                                        frameBorder="0"
                                        sandbox="allow-scripts allow-same-origin"
                                        style={{
                                          display: pdfLoading ? 'none' : 'block',
                                        }}
                                        onLoad={() => setPdfLoading(false)}
                                        onError={() => {
                                          // If Google Docs viewer fails, fallback to direct iframe
                                          setUseOfficeViewer(false);
                                          setPdfLoading(false);
                                        }}
                                      />
                                    ) : (() => {
                                      const fileName = selectedPDF?.split('/').pop()?.split('?')[0] || 'File';
                                      const fileExt = fileName.split('.').pop()?.toLowerCase();
                                      const isOfficeFile = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);
                                      // Formats that browsers can render natively inside an iframe
                                      const isBrowserRenderable = ['svg','txt','html','htm'].includes(fileExt);
                                      // Graphic formats best served via Google Docs Viewer
                                      const googleViewerFormats = ['eps','ai','psd','tif','tiff','bmp','ps','indd','indt'];
                                      const googleViewerSrc = `https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true`;
                                      
                                      return (isOfficeFile || googleViewerFormats.includes(fileExt) || (!isActualPdf && !isBrowserRenderable)) ? (
                                        <iframe
                                          src={googleViewerSrc}
                                          title={fileName}
                                          width="100%"
                                          height="500px"
                                          frameBorder="0"
                                          style={{ display: pdfLoading ? 'none' : 'block', border: 'none' }}
                                          sandbox="allow-scripts allow-same-origin"
                                          onLoad={() => setPdfLoading(false)}
                                          onError={() => setPdfLoading(false)}
                                        />
                                      ) : (
                                        <iframe
                                          src={selectedPDF}
                                          title="Selected PDF"
                                          width="100%"
                                          height="500px"
                                          frameBorder="0"
                                          style={{
                                            display: pdfLoading ? 'none' : 'block',
                                          }}
                                          onLoad={() => setPdfLoading(false)}
                                        />
                                      );
                                    })()}
                                  </Card>
                                </DialogAnimate>
                              </Box>
                            )}
                          </Box>
                        </ImageListItem>
                      )
                    })}
                  </ImageList>
                ) : (
                  //   </Scrollbar>
                  // </Box>
                  ''
                )}
              </Scrollbar>
            </Grid>
            <Grid container spacing={2}>
              <Scrollbar>
                {((userType == 3 || isClient) || accessForApproveDesignOrderForClient) &&
                designs?.length > 0 &&
                details?.send_client_app_req == 1
                  ? !(
                      details?.status == 2 ||
                      details?.status == 3 ||
                      details?.status == 6
                    ) && (
                      // &&
                      // (details?.design_order_job_status == 3)
                      <Box
                        sx={{
                          mt: 3,
                          display: 'flex',
                          justifyContent: 'flex-end',
                          gap: 1,
                        }}
                      >
                        {confirmInvoice ? (
                          <Stack alignItems="center" justifyContent="center">
                            <CircularProgress
                              color="primary"
                              variant="indeterminate"
                            />
                          </Stack>
                        ) : (
                          <Button
                            type="submit"
                            variant="contained"
                            onClick={() => setConfirmInvoice(true)}
                          >
                            {isAdminUser (userType) ? 'Approve For Client' : 'Approve'}
                          </Button>
                        )}
                        {invoiceReject ? (
                          <Stack alignItems="center" justifyContent="center">
                            <CircularProgress
                              color="primary"
                              variant="indeterminate"
                            />
                          </Stack>
                        ) : (
                          <>
                            <Button
                              size="small"
                              variant="outlined"
                              onClick={() => setRejectInvoice(true)}
                              sx={{ color: theme.palette.error.main }}
                            >
                              Reject
                            </Button>
                          </>
                        )}
                      </Box>
                    )
                  : ''}
              </Scrollbar>
            </Grid>
            </>
            )}
          </Modal>
          <Modal width={1000}
            open={openImageModal}
            handleClose={() => {
              setOpenImageModal(false);
            }}
            modalTitle={'Designs'}
            >
            <Stack spacing={2}>
              <Box display="flex" justifyContent="flex-end" mb={1}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleSendCurrentItemToEmailModal(imageDesigns[currentImageIndex])}
                  disabled={!imageDesigns || imageDesigns.length === 0 || currentImageIndex === null}
                  startIcon={<Icon icon="eva:email-fill" width={20} height={20} />}
                >
                  Send to Email
                </Button>
              </Box>
              <div
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                display: 'flex',
                gap:'1rem',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
          {/* <IconButton
            onClick={handlePrevious}
            disabled={currentImageIndex === 0}
            sx={{
              opacity: currentImageIndex === 0 ? 0.3 : 1,
              pointerEvents: currentImageIndex === 0 ? 'none' : 'auto',
            }}
          >
            <Icon
              icon={arrowLeftOutlined}
              width={24}
              height={24}
              color="#006097"
            />
          </IconButton> */}

          <Box
          component={'div'} 
            style={{
              width: '500px',
              height: '500px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 8,
              overflow: 'hidden',
            }}
          >
            <img
              src={imageDesigns[currentImageIndex]?.name}
              // src={`https://gratisography.com/wp-content/uploads/2025/01/gratisography-dog-vacation-1170x780.jpg`}
              alt={`Image ${currentImageIndex + 1}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: 8,
              }}
            />
          </Box>
          {/* <IconButton
            onClick={handleNext}
            disabled={currentImageIndex === imageDesigns.length - 1}
            sx={{
              opacity: currentImageIndex === imageDesigns.length - 1 ? 0.3 : 1,
              pointerEvents: currentImageIndex === imageDesigns.length - 1 ? 'none' : 'auto',
            }}
          >
            <Icon
              icon={arrowRightOutlined}
              width={24}
              height={24}
              color="#006097"
            />
          </IconButton> */}
        </div>
        </Stack>
      </Modal>
          <ConfirmationPopup
            open={openDelete}
            handleClick={handleDeleteOrder}
            handleClose={() => {
              setOpenDelete(!openDelete), setIsOpen(false)
            }}
            message={'You want to delete this order '}
          />

          <ConfirmationPopup
            open={openConvertToSalesOrder}
            handleClick={handleConvertToSalesOrder}
            handleClose={() => {
              setOpenConvertToSalesOrder(false)
            }}
            message={
              'This Design Order will be converted and moved to Sales Order Page '
            }
          />
          <ConfirmationPopup
            open={openConvertToEstimate}
            handleClick={handleConvertToEstimate}
            handleClose={() => {
              setOpenConvertToEstimate(false)
            }}
            message={
              'This Design Order will be converted and moved to Estimate Page '
            }
          />
          <ConfirmationPopup
            open={openConvertToEstimateRequest}
            handleClick={handleConvertToEstimateRequest}
            handleClose={() => {
              setOpenConvertToEstimateRequest(false)
            }}
            message={
              'This Design Order will be converted and moved to Estimate Request Page '
            }
          />
          <ConfirmationPopup
            open={openConvertToSplitEstimate}
            handleClick={handleConvertToSplitEstimate}
            handleClose={() => {
              setOpenConvertToSplitEstimate(false)
            }}
            message={
              'This Design Order will be converted and moved to Split Estimate Page '
            }
          />
          <ConfirmationPopup
            open={openMergeToSalesOrder}
            handleClick={handleMergeToSalesOrder}
            handleClose={() => {
              setOpenMergeToSalesOrder(false)
            }}
            message={
              'This duplicated Design Order will be merged to existing Sales Order '
            }
          />
          <ConfirmationPopup
            open={openMergeToEstimate}
            handleClick={handleMergeToEstimate}
            handleClose={() => {
              setOpenMergeToEstimate(false)
            }}
            message={
              'This duplicated Design Order will be merged to existing Estimate '
            }
          />
          <ConfirmationPopup
            open={openMergeToRequestEstimate}
            handleClick={handleMergeToRequestEstimate}
            handleClose={() => {
              setOpenMergeToRequestEstimate(false)
            }}
            message={
              'This duplicated Design Order will be merged to existing Request Estimate '
            }
          />

          <ConfirmationPopup
            isapproveOrder={true}
            open={confirmInvoice}
            loading={isLoading} // ✅ only passed here
            handleClick={async () => {
              setIsLoading(true);
              await handleAcceptorRejectInvoice(1);
              setIsLoading(false);
            }}
            handleClose={() => setConfirmInvoice(false)}
            // message={'You want to Approve this Order '}
            message={'Do you Approve this design ? '}
          />
          <ConfirmationPopup
            open={reOpen}
            handleClick={() => handleReopeningRequest()}
            handleClose={() => setReopen(false)}
            message={'You want to reopen this Order '}
          />
          <ConfirmationPopup
            open={openReopenDesignOrderDuplicate}
            handleClick={handleReopenDesignOrder}
            handleClose={() => setOpenReopenDesignOrderDuplicate(false)}
            message={'You want to reopen this Design Order'}
          />
{/* popup for design order duplication */}
             <ConfirmationPopup
            open={openDesignOrderDuplicate}
            handleClick={handleDuplicateDesignOrder}
            handleClose={() => setOpenDesignOrderDuplicate(false)}
            message={'You want to duplicate this Design Order'}
          />
          <ConfirmationPopup
            open={openCloseConfirm}
            handleClick={handleCloseDesignOrder}
            handleClose={() => {
              if (!isClosingDesignOrder) setOpenCloseConfirm(false);
            }}
            message={'You want to close this Design Order. It will be moved to the Projects folder.'}
            loading={isClosingDesignOrder}
          />
          {/* Preview Modal */}
          {openPreview && (
            <Modal
              width={900}
              open={openPreview}
              handleClose={() => {
                setOpenPreview(false)
              }}
              modalTitle={'Preview'}
            >
              {/* <ReactToPrint
                trigger={() => (
                  <Button variant="contained" color="primary">
                    Print A3
                  </Button>
                )}
                content={() => printableContentRef.current}
                pageStyle={`@media print {
                  .print-black {
                    color: black !important;
                    background:white !important
                  }
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-bottom: 10px;
                  }
                  * {
                    color: black !important;
                    background-color: white !important;
                  }
                  .MuiTableCell-root {
                    color: black !important;
                  }
                  .MuiInputBase-input {
                    color: black !important;
                  }
                  .no-scrollbar::-webkit-scrollbar {
                    display: none;
                  }
                  .no-scrollbar {
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                  }
                  .enable-for-print {
                    pointer-events: auto;
                    color: black !important;
                  }
                  .print-black .enable-for-print input[type='number'],
                  .print-black .enable-for-print input[type='text'] {
                    color: black !important;
                  }
                  .css-wr96yv-MuiInputBase-input-MuiOutlinedInput-input {
                  color: black !important;
                  opacity: 1;
                    -webkit-text-fill-color:black !important;
                  }
                  input[type=number]{
                    color:black !important}
                  }`}
              /> */}
              <div ref={printableContentRef} className="print-black">
                <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
                  <Grid item xs={12} md={12}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      }}
                      spacing={2}
                    >
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>
                            Name:{' '}
                          </span>
                          {previewData?.name}
                        </Typography>

                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>
                            Use custom welcome message:{' '}
                          </span>
                          {previewData.welcome_message == null
                            ? 'No'
                            : previewData.welcome_message == false
                            ? 'No'
                            : 'Yes'}
                        </Typography>
                      </Stack>
                      <Stack>
                        <Typography
                          variant="subtitle2"
                          style={{ color: theme.palette.primary.darker }}
                        >
                          Description:
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          style={{
                            overflowWrap: 'break-word',
                            wordWrap: 'break-word',
                            wordBreak: 'break-word',
                            whiteSpace: 'pre-line',
                          }}
                        >
                          {previewData?.description}
                        </Typography>
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      ></Stack>

                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>
                            Client:{' '}
                          </span>
                          {previewData?.clients?.name}
                        </Typography>
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>
                            Start Date:{' '}
                          </span>
                          {formatDateOnly(previewData.start)}
                        </Typography>
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>
                            Due Date:{' '}
                          </span>
                          {formatDateOnly(previewData.end)}
                        </Typography>
                      </Stack>
                      <Stack>
                        <Typography
                          variant="subtitle2"
                          style={{ color: theme.palette.primary.darker }}
                        >
                          Notes:
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            overflowWrap: 'break-word',
                            wordWrap: 'break-word',
                            wordBreak: 'break-word',
                            color: 'error.main',
                            whiteSpace: 'pre-line',
                          }}
                        >
                          <Scrollbar
                            sx={{
                              maxHeight: 200,
                              '& .simplebar-content': {
                                maxHeight: 200,
                                display: 'flex',
                                flexDirection: 'column',
                              },
                            }}
                          >
                            {previewData?.notes}
                          </Scrollbar>
                        </Typography>
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <Label
                            variant={
                              theme.palette.mode === 'light'
                                ? 'ghost'
                                : 'filled'
                            }
                            color={
                              getStatusColorAndLabel(
                                details?.status,
                                details?.hold,
                                details?.design_order_job_status,
                                details?.send_client_app_req,
                                designs,
                                details?.is_from_client,
                                details?.is_in_queue,
                                details?.is_closed
                              ).color
                            }
                          >
                            {
                              getStatusColorAndLabel(
                                details?.status,
                                details?.hold,
                                details?.design_order_job_status,
                                details?.send_client_app_req,
                                designs,
                                details?.is_from_client,
                                details?.is_in_queue,
                                details?.is_closed
                              ).label
                            }
                          </Label>
                        </Typography>
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </div>
            </Modal>
          )}
          {/* reject request invoice */}
          {invoiceReject == true && (
            <Dialog
              open={invoiceReject}
              onClose={() => {
                setRejectInvoice(false)
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              BackdropComponent={Backdrop}
              BackdropProps={{ invisible: true }}
              PaperProps={{
                sx: {
                  width: 700,
                  borderRadius: 2,
                  bgcolor: '#0f1b1e',
                  border: '1px solid rgba(255,255,255,0.12)'
                }
              }}
            >
              <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 600, color: '#fff', pb: 1 }}>
                {'Are you sure ?'}
              </DialogTitle>
              <DialogContent sx={{ pt: 0 }}>
                <DialogContentText id="alert-dialog-description" sx={{ color: 'grey.400', mb: 2 }}>
                  You want to reject this Order
                </DialogContentText>
                <TextField
                  select
                  fullWidth
                  label="Reject Type"
                  value={rejectTypeId || ''}
                  onChange={(e) => setRejectTypeId(e.target.value)}
                  sx={{
                    mb: 2,
                    bgcolor: 'rgba(255,255,255,0.05)',
                    borderRadius: 1,
                    input: { color: '#fff' },
                    '& .MuiInputLabel-root': { color: 'grey.400' }
                  }}
                >
                  {rejectType.map((opt) => (
                    <MenuItem key={opt.id} value={opt.id}>
                      {opt.value}
                    </MenuItem>
                  ))}
                </TextField>
                <MobileDatePicker
                  label="Requested Due Date"
                  minDate={moment().toDate()}
                  value={requestedDueDate ? moment.unix(requestedDueDate).toDate() : null}
                  onChange={(date) => setRequestedDueDate(date ? moment(date).unix() : null)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      sx={{
                        mb: 2,
                        bgcolor: 'rgba(255,255,255,0.05)',
                        borderRadius: 1,
                        input: { color: '#fff' },
                        '& .MuiInputLabel-root': { color: 'grey.400' }
                      }}
                    />
                  )}
                />
                <TextField
                  fullWidth
                  label="Reason For Rejection"
                  type="text"
                  multiline
                  minRows={3}
                  maxRows={7}
                  onInput={(event) => setReason(event.target.value)}
                  sx={{
                    mb: 2,
                    bgcolor: 'rgba(255,255,255,0.05)',
                    borderRadius: 1,
                    input: { color: '#fff' },
                    '& .MuiInputLabel-root': { color: 'grey.400' }
                  }}
                />
                <UploadMultiFile
                  showPreview
                  files={rejectFiles || []}
                  // accept="image/*,application/pdf"
                  maxSize={1024 * 1024 * 1024}
                  multiple={true}            // 🔥 ONLY here it's multiple upload
                  onDrop={handleRejectFileDrop}
                  onRemove={(file) => setRejectFiles((prev) => prev.filter((f) => f !== file))}
                  onRemoveAll={() => setRejectFiles([])}
                  isUploading={isUploadingRejectFile}
                  sx={{ mt: 1 }}
                />

              </DialogContent>
              <DialogActions>
                <Button
                  size="small"
                  variant="contained"
                  onClick={async () => {
                    setIsSubmittingReject(true);
                    await handleAcceptorRejectInvoice(2);
                    setIsSubmittingReject(false);
                  }}
                  disabled={isSubmittingReject || isUploadingRejectFile}
                  sx={{
                    color: theme.palette.background.paper,
                    fontWeight: 600,
                    px: 3
                  }}
                >
                  {isSubmittingReject ? <CircularProgress size={20} color="inherit" /> : 'OK'}
                </Button>

                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setRejectInvoice(false)
                    setReason('')
                    setRejectTypeId('')
                    setRequestedDueDate(null)
                    setRejectFiles([])
                  }}
                  sx={{ color: theme.palette.error.main }}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {/* reject request invoice */}

          <Modal
            modalTitle={'Select designs to send for client approval'}
            open={openDesignSelect === true}
            handleClose={() => setOpenDesignSelect(false)}
          >
            <Box mb={1}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      (designs?.length || 0) > 0 &&
                      designs?.every((design) => selectedDesigns?.includes(design.id))
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedDesigns((designs || []).map((design) => design.id));
                      } else {
                        setSelectedDesigns([]);
                      }
                    }}
                  />
                }
                label="Select all"
              />
            </Box>
            <ImageList
              gap={mdd ? 8 : xld ? 12 : 8}
              cols={mdd ? 3 : xld ? 3 : xs ? 1 : 3}
            >
              {designs?.map((item, index) => {
                const { file_type, name, url, id, extension } = item
                const _fileExt3 = (name || '').split('.').pop()?.split('?')[0]?.toLowerCase();
                const designFileExtensions = ['ai', 'eps', 'ps', 'psd', 'tif', 'tiff', 'indd', 'indt'];
                const isDesignFile = designFileExtensions.includes(_fileExt3);
                const isImage =
                  !isDesignFile &&
                  (file_type?.startsWith('image/') || file_type === 'img' || file_type === 'image') &&
                  !['eps','ai','ps','psd','x-eps','x-ai','postscript'].includes((file_type || '').replace('image/','').toLowerCase())
                const isActualPdf = file_type === 'pdf' || file_type === 'application/pdf' || (name || '').toLowerCase().split('?')[0].endsWith('.pdf')
                const isPdf = !isImage && !isDesignFile

                const isSelected = selectedDesigns?.includes(id)
                const handleToggle = () => {
                  setSelectedDesigns((prev) =>
                    isSelected ? prev?.filter((n) => n !== id) : [...prev, id],
                  )
                }
                return (
                  <ImageListItem key={index}>
                    <Box position="relative">
                      <Checkbox
                        checked={isSelected}
                        onChange={handleToggle}
                        sx={{
                          position: 'absolute',
                          top: 8,
                          left: 8,
                          zIndex: 1,
                          color: 'black',
                          backgroundColor: theme.palette.grey.A700,
                          boxShadow: 1 // Optional: helps make it stand out
                        }}
                      />
                      {isImage ? (
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            e.preventDefault();
                            handleImageClick(imageDesigns.findIndex((img) => img.name === name))
                          }}
                        >
                        <img
                          srcSet={`${item.name}?w=240&h=240&fit=crop&auto=format&dpr=2 2x`}
                          src={`${item.name}?w=240&h=240&fit=crop&auto=format`}
                          alt={item.title}
                          loading="lazy"
                          style={{ width: '240px', height: '240px', cursor:'pointer' }}
                        />
                        </a>
                      ) : isDesignFile ? (
                        <Box position="relative" sx={{ width: '240px', height: '240px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: 1, overflow: 'hidden' }}>
                          <iframe
                            src={`https://docs.google.com/gview?url=${encodeURIComponent(name)}&embedded=true`}
                            title={name}
                            style={{ width: '100%', height: '100%', border: 'none' }}
                            frameBorder="0"
                            sandbox="allow-scripts allow-same-origin"
                          />
                          <Tooltip title="View Design">
                            <IconButton
                              onClick={() => {
                                setPdfLoading(true)
                                setSelectedPDF(name)
                                setOpenPDFModal(true)
                                setUseOfficeViewer(true);
                              }}
                              aria-label="open file"
                              sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 200,
                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                color: '#fff',
                                '&:hover': {
                                  backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                }
                              }}
                            >
                              <Description style={{ fontSize: 40 }} />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      ) : (
                        <Box display="flex" alignItems="center">
                          <Tooltip title={isActualPdf ? "View PDF" : "View File"}>
                            <IconButton
                              onClick={() => {
                                setPdfLoading(true)
                                setSelectedPDF(name)
                                setOpenPDFModal(true)
                                setUseOfficeViewer(true);
                              }}
                              aria-label="open file"
                              sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 200,
                                color: theme.palette.error.main,
                                backgroundColor: theme.palette.text.primary,
                              }}
                            >
                              {isActualPdf ? <PictureAsPdf style={{ fontSize: 40 }} /> : <Description style={{ fontSize: 40 }} />}
                            </IconButton>
                          </Tooltip>

                          {isActualPdf ? (
                            <iframe
                              src={name}
                              title={name}
                              style={{ width: '240px', height: '240px' }}
                              frameBorder="0"
                            />
                          ) : (() => {
                            const fileName = name?.split('/').pop()?.split('?')[0] || 'File';
                            const fileExt = fileName.split('.').pop()?.toLowerCase();
                            const isOfficeFile = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);
                            
                            if (isOfficeFile) {
                              return (
                                <iframe
                                  src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(name)}`}
                                  title={fileName}
                                  style={{ width: '240px', height: '240px', borderRadius: '4px' }}
                                  frameBorder="0"
                                />
                              );
                            }
                            
                            return (
                              <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                                sx={{
                                  width: '240px',
                                  height: '240px',
                                  cursor: 'pointer',
                                  backgroundColor: 'rgba(0,0,0,0.04)',
                                  border: '1px solid rgba(0,0,0,0.1)',
                                  borderRadius: 1
                                }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setPdfLoading(true)
                                  setSelectedPDF(name)
                                  setOpenPDFModal(true)
                                  setUseOfficeViewer(true);
                                }}
                              >
                                <Description style={{ fontSize: 60, color: 'gray' }} />
                                <Typography variant="body2" sx={{ mt: 1, maxWidth: '90%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                                  {item.title || fileName}
                                </Typography>
                              </Box>
                            );
                          })()}

                          <DialogAnimate
                            open={openPDFModal}
                            onClose={() => setOpenPDFModal(false)}
                          >
                            <Card className={classes.dialogContent}>
                              <div style={{width:'90%', display:'flex',justifyContent:'flex-end', marginBottom: '15px',marginLeft:'25px' }}>
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  onClick={() => {
                                    const fileName = selectedPDF?.split('/').pop()?.split('?')[0] || 'File';
                                    const fileExt = fileName.split('.').pop()?.toLowerCase();
                                    const isOfficeFile = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);
                                    const newWindow = window.open('', '_blank');

                                    if (isActualPdf) {
                                      newWindow.document.write(`
                                        <html>
                                          <head>
                                            <title>PDF Viewer</title>
                                            <style>
                                              body { margin: 0; padding: 0; overflow: hidden; }
                                              iframe { width: 100vw; height: 100vh; border: none; }
                                            </style>
                                          </head>
                                          <body>
                                            <iframe src="${selectedPDF}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
                                          </body>
                                        </html>
                                      `);
                                    } else if (isOfficeFile) {
                                      const officeViewerSrc = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(selectedPDF)}`;
                                      newWindow.document.write(`
                                        <html>
                                          <head>
                                            <title>${fileName}</title>
                                            <style>
                                              body { margin: 0; padding: 0; overflow: hidden; }
                                              iframe { width: 100vw; height: 100vh; border: none; }
                                            </style>
                                          </head>
                                          <body>
                                            <iframe src="${officeViewerSrc}" title="${fileName}"></iframe>
                                          </body>
                                        </html>
                                      `);
                                    } else {
                                      const googleViewerSrc = `https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true`;
                                      newWindow.document.write(`
                                        <html>
                                          <head>
                                            <title>${fileName}</title>
                                            <style>
                                              body { margin: 0; padding: 0; overflow: hidden; }
                                              iframe { width: 100vw; height: 100vh; border: none; }
                                            </style>
                                          </head>
                                          <body>
                                            <iframe src="${googleViewerSrc}" title="${fileName}" sandbox="allow-scripts allow-same-origin"></iframe>
                                          </body>
                                        </html>
                                      `);
                                    }
                                    newWindow.document.close();
                                  }}
                                  disabled={!selectedPDF}
                                  startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                                  sx={{
                                    fontSize:'14px'
                                  }}
                                >
                                  View File
                                </Button>
                              </div>
                              {pdfLoading && (
                                <Skeleton
                                  variant="rectangular"
                                  width="100%"
                                  height={500}
                                />
                              )}

                              {(() => {
                                const fileName = selectedPDF?.split('/').pop()?.split('?')[0] || 'File';
                                const fileExt = fileName.split('.').pop()?.toLowerCase();
                                const isOfficeFileInner = ['xls','xlsx','doc','docx','ppt','pptx','csv'].includes(fileExt);
                                const isGoogleFileInner = ['ai', 'eps', 'ps', 'psd'].includes(fileExt);

                                if (isActualPdf) {
                                  return (isClient || userType === 3) && useOfficeViewer ? (
                                    <iframe
                                      src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
                                      title="Selected PDF - Viewer"
                                      width="100%"
                                      height="500px"
                                      frameBorder="0"
                                      sandbox="allow-scripts allow-same-origin"
                                      style={{ display: pdfLoading ? 'none' : 'block' }}
                                      onLoad={() => setPdfLoading(false)}
                                      onError={() => {
                                        setUseOfficeViewer(false);
                                        setPdfLoading(false);
                                      }}
                                    />
                                  ) : (
                                    <iframe
                                      src={selectedPDF}
                                      title="Selected PDF - Direct"
                                      width="100%"
                                      height="500px"
                                      frameBorder="0"
                                      style={{ display: pdfLoading ? 'none' : 'block' }}
                                      onLoad={() => setPdfLoading(false)}
                                    />
                                  );
                                }

                                if (isOfficeFileInner) {
                                  return (
                                    <iframe
                                      src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(selectedPDF)}`}
                                      title={fileName}
                                      width="100%"
                                      height="500px"
                                      frameBorder="0"
                                      style={{ display: pdfLoading ? 'none' : 'block' }}
                                      onLoad={() => setPdfLoading(false)}
                                      onError={() => setPdfLoading(false)}
                                    />
                                  );
                                }

                                if (isGoogleFileInner) {
                                  return (
                                    <iframe
                                      src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true`}
                                      title={fileName}
                                      width="100%"
                                      height="500px"
                                      frameBorder="0"
                                      sandbox="allow-scripts allow-same-origin"
                                      style={{ display: pdfLoading ? 'none' : 'block' }}
                                      onLoad={() => setPdfLoading(false)}
                                      onError={() => setPdfLoading(false)}
                                    />
                                  );
                                }

                                return (
                                  <iframe
                                    src={selectedPDF}
                                    title={fileName}
                                    width="100%"
                                    height="500px"
                                    frameBorder="0"
                                    style={{ display: pdfLoading ? 'none' : 'block' }}
                                    onLoad={() => setPdfLoading(false)}
                                  />
                                );
                              })()}
                            </Card>
                          </DialogAnimate>
                        </Box>
                      )}
                    </Box>
                  </ImageListItem>
                )
              })}
            </ImageList>
            <Box mt={2} display="flex" justifyContent="flex-end" gap={2} alignItems="center">
              <AttachmentDownloadAllButton
                files={(designs || []).filter((item) =>
                  selectedDesigns.includes(item.id),
                )}
                label="Download Selected"
                onDownloadComplete={() => setSelectedDesigns([])}
                hidden={isClient || userType === 3}
              />
              <Button
                variant="contained"
                disabled={selectedDesigns.length === 0 || sendForApproval}
                onClick={() => handleSendClientApproveReq(selectedDesigns)}
              >
                Send for Approval
              </Button>
            </Box>
          </Modal>
          <Dialog open={showApprovalPopup} onClose={() => setShowApprovalPopup(false)}>
            <DialogTitle>Confirm Design Order Changes</DialogTitle>
            <DialogContent>
              <Typography>
                {/* Modifying this design order may require admin approval to approve. Do you want to proceed? */}
                This design order was sent by the admin. 
                Modifying it may require the admin to review and resend it for client approval. Do you want to proceed?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setShowApprovalPopup(false)}>Cancel</Button>
              <Button
                variant="contained"
                onClick={() => {
                  setShowApprovalPopup(false);
                  setIsClientEdited(true); // Mark it edited
                  formik.submitForm(); // Retry form submission
                }}
              >
                Proceed
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={openHoldPopup}
            onClose={() => {
              setOpenHoldPopup(false);
              setHoldReason('');
            }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              BackdropProps={{ invisible: true }}
            >
              <DialogTitle id="alert-dialog-title">
                {details?.hold === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {
                      details?.hold === 1
                        ? 'You want to move this Design Order from Hold.'
                        : 'You want to move this Design Order to Hold.'
                  }
                </DialogContentText>
                {(details?.hold === 0) ? (
                  <TextField
                    sx={{ width: 400 }}
                    label="Reason"
                    type="text"
                    multiline
                    minRows={3}
                    maxRows={7}
                    value={holdReason}
                    onChange={(e) => {
                      setHoldReason(e.target.value);
                      if (holdReasonError) setHoldReasonError('');
                    }}
                    error={Boolean(holdReasonError)}
                    helperText={holdReasonError}
                  />
                ) : ''}
              </DialogContent>
              <DialogActions>
                <Button
                  size="small"
                  variant="contained"
                  onClick={async () => {
                    if ((details?.hold === 0) && !holdReason.trim()) {
                      setHoldReasonError(`Reason is required to put this Design Order on Hold`);
                      return;
                    }
                    setIsSubmittingHold(true);
                    handleUpdateHoldStatus(holdReason);
                    setIsSubmittingHold(false);
                    setOpenHoldPopup(false);
                    setHoldReason('');
                    setHoldReasonError('');
                  }}
                  disabled={isSubmittingHold}
                >
                  {isSubmittingHold ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    'OK'
                  )}
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setOpenHoldPopup(false);
                    setHoldReason('');
                  }}
                  sx={{ color: theme.palette.error.main }}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
        </Container>
      )}
      
      {/* 🚀 PROGRESS TRACKING: Request Progress Modal */}
      {/* <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        onSocketReady={setSocketReady}
        heading={progressHeading}
      /> */}
      <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        heading={progressHeading}
        message="We're processing your request. Please wait..."
      />
      <SendDesignsEmailModal
        open={openEmailModal}
        onClose={() => setOpenEmailModal(false)}
        selectedDesigns={emailModalDesigns}
        designOrderId={details?.id}
        userId={user.user_id}
        userType={userType}
        onSuccess={handleEmailSent}
        pageType="design"
      />
      <SendDesignsEmailModal
        open={openInvoiceEmailModal}
        onClose={() => setOpenInvoiceEmailModal(false)}
        selectedDesigns={invoicePdfData || []}
        designOrderId={details?.id}
        invoice={invoice}
        details={details}
        userId={user?.user_id}
        userType={userType}
        onSuccess={handleDesignOrderInvoiceEmailSent}
        pageType="design"
        hasViewCostPermission={hasViewCostPermission}
      />
    </Page>
  )
}

const PrintFunction = forwardRef(
  ({ invoiceDate, details, invoice, data }, ref) => {
    const theme = useTheme()
    const { COMPANY_LOGO, COMPANY_NAME } = useCompanyProfile()
    return (
      <Stack ref={ref}>
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              mb: 5,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
            }}
          >
            <Box
              component="img"
              alt="logo"
              src={COMPANY_LOGO}
              id="logoImage"
              sx={{ height: 98, alignSelf: 'flex-start' }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              mb: 5,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
            }}
          >
            {/* <Typography variant="h1">Invoice from:</Typography> */}
            <Typography variant="h2">{COMPANY_NAME}</Typography>
            <Typography variant="h2">www.{COMPANY_NAME}.com</Typography>
            <Typography variant="h3">
              {data?.address}
              <br /> {data?.city}
              <br /> {data?.state}, {data?.zipcode}
            </Typography>
            {/* <Typography variant="h3">Telephone: +15208362947</Typography> */}
            <Typography variant="h3">Telephone: {data?.phone ? `+${data?.phone_country_code}${data?.phone}` : ''}</Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid id="total1" item xs={12} sm={6}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
              }}
            >
              <Box
                id="order"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography
                  id="discount1"
                  variant="h3"
                  style={{ textAlign: 'left' }}
                >
                  Order date:
                </Typography>
                <Typography variant="h3">{invoiceDate}</Typography>
              </Box>
              <Box
                id="title"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  maxWidth: 250,
                }}
              >
                <Typography
                  id="discount1"
                  variant="h3"
                  style={{ textAlign: 'left' }}
                >
                  Title:
                </Typography>
                <Typography variant="h3">{details?.name}</Typography>
              </Box>
              <Box
                id="orderID"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography
                  id="discount"
                  variant="h3"
                  style={{ textAlign: 'left' }}
                >
                  Order ID:
                </Typography>
                <Typography variant="h3">{details?.id}</Typography>
              </Box>
              <Box
                id="to"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography id="totalmain1" variant="h3">
                  To:
                </Typography>
                <Typography variant="h3" style={{ textAlign: 'right' }}>
                  {invoice?.customer_name}
                </Typography>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Typography id="totalmain1" variant="h3">
                  Phone:
                </Typography>
                <Typography variant="h3" style={{ textAlign: 'right' }}>
                  {invoice?.customer_phone}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Scrollbar></Scrollbar>
        </Grid>
      </Stack>
    )
  },
)
